import * as i0 from '@angular/core';
import { InjectionToken, Injectable, EventEmitter, APP_INITIALIZER, Inject, Optional, Component, LOCALE_ID, ErrorHandler, NgModule, inject } from '@angular/core';
import { BehaviorSubject, Subject, of, from, Observable, lastValueFrom, defer, forkJoin, map as map$1, catchError as catchError$1, tap as tap$1, filter, switchMap, mergeMap as mergeMap$1, takeUntil, throwError, EMPTY } from 'rxjs';
import * as i1$3 from '@lvflanders/bar';
import { openUrl, resolveValue, ensureGlobal, BarErrorHandling, checkDateObject, convertToISOString, LOCALE, getParamNames, BarCacheManager, BarCacheStore, BarCacheEntryOptions, _BAAS_SHARED_CONSTANTS, deleteCookie, BarStopwatch, generateRandomNumber, concatUrl, deleteAllIndexedDb, deleteAllCookies, BarCacheStoreType, versionCompare, checkUrlAbsolute, generateUuid, extractUrlParts, parseQueryStringValue, BarIdpClient, extractUrlOrigin, BarGvkManager, BarHubClient, BarNotificationManager, checkLocalhost, BarSharedBootstrapper } from '@lvflanders/bar';
import { registerLocaleData, Location, LocationStrategy, PathLocationStrategy, NgIf, APP_BASE_HREF, CommonModule } from '@angular/common';
import * as i1$1 from '@angular/common/http';
import { HttpParams, HttpResponse, HTTP_INTERCEPTORS, HttpHeaders, HttpClient } from '@angular/common/http';
import localeNlExtra from '@angular/common/locales/extra/nl';
import localeNlBeExtra from '@angular/common/locales/extra/nl-BE';
import localeNl from '@angular/common/locales/nl';
import localeNlBe from '@angular/common/locales/nl-BE';
import * as i1 from '@angular/router';
import { Router, DefaultUrlSerializer, UrlSerializer, RouterModule, NavigationEnd, NavigationStart, NavigationError } from '@angular/router';
import * as i1$2 from '@lvflanders/bar-ng-i18n';
import { BarI18nModule } from '@lvflanders/bar-ng-i18n';
import { mergeMap, catchError, tap, map, delayWhen, retry } from 'rxjs/operators';
import { parseISO, isAfter, isBefore, isEqual } from 'date-fns';
import { __classPrivateFieldGet, __awaiter, __decorate } from 'tslib';
import * as i1$4 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';

// injection token to have same class injected in different ways
const BAR_GLOBAL_CACHE = new InjectionToken('Global cache store');
const BAR_USER_CACHE = new InjectionToken('User cache store');
const BAR_APP_CACHE = new InjectionToken('Application cache store');
const BAR_MELDINGEN_CACHE = new InjectionToken('Meldingen cache store');
/** Token for BAR initialized lifecycle hook. */
const BAR_INITIALIZED = new InjectionToken('BAR initialized token.');
/** Token for BAR error handler hook. */
const BAR_ERROR_HANDLER = new InjectionToken('BAR error handling token.');
const BAR_LOG_OFF = new InjectionToken('BAR log off token');
/** Token used to define whether running under localhost. */
const BAR_LOCALHOST = new InjectionToken('BAR localhost token');

const APP_INFO_COOKIE_KEY = 'domain.basisarchitectuur.appinfo';
const PAGES_ROOT_PATH = 'bui/';
const STORAGE_KEY_PREFIX = 'lvflanders.bar.ng.core.';
const BAR_CORE_CONSTANTS = {
    STORAGE_KEY_PREFIX,
    DEFAULT_MEETPUNT_TYPE: 'NG',
    STORAGE_KEYS: {
        SESSION_ID: 'sessionId',
        IDP_IMPERSONATE: STORAGE_KEY_PREFIX + 'idpImpersonate'
    },
    URL_SEGMENT: {
        BAR_WEB: '/basisarchitectuur/domain.basisarchitectuur.web/',
        BAAS_STATIC: '/{segment}/baas-static/web/',
        BAAS_WEB: '/{segment}/baasweb/web/'
    },
    AUDIT: {
        HTML_ATTRIBUTE_AUDIT_ID: 'data-bar-audit-id',
        HTML_ATTRIBUTE_AUDIT_TYPE: 'data-bar-audit-type'
    },
    COOKIE: {
        APP_INFO: {
            MAIN: APP_INFO_COOKIE_KEY,
            SESSION: APP_INFO_COOKIE_KEY + '.session',
            SECURE: APP_INFO_COOKIE_KEY + '.secure'
        }
    },
    HEADERS: {
        BAAS_BACKEND_HEADER: 'baas.context.backend',
        BAAS_BROWSER_CALLSTACK: 'baas.browser.callstack'
    },
    PAGES: {
        ONBESCHIKBAAR: PAGES_ROOT_PATH + 'blokkerende-melding',
        SESSION_EXPIRED: PAGES_ROOT_PATH + 'session-expired',
        INSUFFICIENT_PRIVILEGES: PAGES_ROOT_PATH + 'insufficient-privileges',
        LOG_OFF: PAGES_ROOT_PATH + 'log-off'
    }
};

class BarRoutingService {
    constructor(router) {
        this.router = router;
    }
    /**
     * Will navigates to a given url and make sure the current component is not reused in case of a same route navigation (reload).
     * @param url
     */
    navigateByUrlWithReload(url, extras) {
        return new Promise((resolve, reject) => {
            // navigate to the bar refresh route to then navigate to the same url (tricks of the trade)
            this.router.navigateByUrl('/bar-refresh', { skipLocationChange: true }).then(() => {
                // to then navigate back to the same page
                this.router
                    .navigateByUrl(url)
                    .then((value) => {
                    resolve(value);
                })
                    .catch((reason) => {
                    reject(reason);
                });
            });
        });
    }
    /**
     * Will navigates based on command array and make sure the current component is not reused in case of a same route navigation (reload).
     * @param url
     */
    navigateWithReload(commands, extras) {
        return new Promise((resolve, reject) => {
            // navigate to the bar refresh route to then navigate to the same url (tricks of the trade)
            this.router.navigateByUrl('/bar-refresh', { skipLocationChange: true }).then(() => {
                // to then navigate back to the same page
                this.router
                    .navigate(commands, extras)
                    .then((value) => {
                    resolve(value);
                })
                    .catch((reason) => {
                    reject(reason);
                });
            });
        });
    }
}
BarRoutingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarRoutingService, deps: [{ token: i1.Router }], target: i0.ɵɵFactoryTarget.Injectable });
BarRoutingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarRoutingService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarRoutingService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.Router }]; } });

/**
   Holds state of the BAR core module within the single page.
   With this in place we can access the state anywhere.
 */
// NOTE not a model because injectable provider and not a service because it only holds state
class BarCoreStateService {
    constructor() {
        /** Meldingen set by the BarMeldingGuard */
        this.meldingen$ = new BehaviorSubject(undefined);
    }
}
BarCoreStateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCoreStateService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BarCoreStateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCoreStateService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCoreStateService, decorators: [{
            type: Injectable
        }] });

class BarCoreService {
    constructor(
    // all app initializers need to be run again
    appInits, injector, coreState) {
        this.appInits = appInits;
        this.injector = injector;
        this.coreState = coreState;
        /** Global core event that is invoked when an error occurs. */
        this.errorOccurred = new EventEmitter();
        /** Event invoked when performed soft refresh. */
        this.refreshed = new EventEmitter();
        /** Occurs when a custom message is send from the BaaS hub and received in the client. */
        this.customHubMessageReceived = new EventEmitter();
        // Listen for the custom event on a JavaScript object or DOM element
        window.addEventListener('customHubMessage', (event) => {
            this.customHubMessageReceived.emit(event.detail);
        });
    }
    // avoid cyclic dependency
    get router() {
        return this.injector.get(Router);
    }
    get routing() {
        return this.injector.get(BarRoutingService);
    }
    /** Performs a soft refresh (make sure to have onSameUrlNavigation set to 'reload' in the routing setup) */
    refresh() {
        return new Promise((resolve) => {
            // https://dormoshe.io/articles/hook-into-angular-initialization-process-8
            // get all async promises (or executed if no promise)
            const initPromises = [];
            if (this.appInits) {
                this.appInits.forEach((appInit) => {
                    const initResult = appInit();
                    const promise = Promise.resolve(initResult);
                    initPromises.push(promise);
                });
            }
            // after executing all startup logic
            Promise.all(initPromises).then(() => {
                // save url before navigating (otherwise wrong one)
                const url = this.router.url;
                // use custom navigate with to reload to ensure route component is completely reloaded
                this.routing.navigateWithReload([url]).then(() => {
                    this.refreshed.emit();
                    resolve();
                });
            });
        });
    }
    /**
     * Navigate to the defined home url (default is startscherm)
     * @param invokeHomeAction Whether to invoke the custom home action defined in this service as a property.
     */
    navigateHome(invokeHomeAction = true) {
        return this.navigateAction(invokeHomeAction, () => {
            window.location = this.coreState.config.homeUrl;
        }, this.homeAction, undefined);
    }
    navigateRoot(invokeRootAction = true, event = undefined) {
        return this.navigateAction(invokeRootAction, () => {
            const newTab = event && (event.ctrlKey || event.metaKey);
            if (newTab) {
                openUrl(this.coreState.location.spa.url, '_blank');
            }
            else {
                this.router.navigate(['./']);
            }
        }, this.rootAction, event);
    }
    navigateAction(invokeAction, defaultAction, action, event) {
        // return a promise for whatever use
        return new Promise((resolve) => {
            let defaultBehaviour = false;
            if (invokeAction && action != null) {
                if (action.action != null) {
                    const result = action.action(event);
                    if (result instanceof Promise) {
                        result.then(() => {
                            resolve();
                        });
                    }
                    else {
                        resolve();
                    }
                }
                else if (action.routerUrl != null) {
                    const routerUrl = resolveValue(action.routerUrl);
                    this.router.navigateByUrl(routerUrl).then(() => {
                        resolve();
                    });
                }
                else if (action.routerCommands != null) {
                    const routerLink = resolveValue(action.routerCommands);
                    this.router.navigate(routerLink).then((a) => {
                        resolve();
                    });
                }
                else if (action.href != null) {
                    const href = resolveValue(action.href);
                    openUrl(href, action.target);
                    resolve();
                }
                else {
                    defaultBehaviour = true;
                }
            }
            else {
                defaultBehaviour = true;
            }
            if (defaultBehaviour) {
                defaultAction();
                resolve();
            }
        });
    }
}
BarCoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCoreService, deps: [{ token: APP_INITIALIZER, optional: true }, { token: i0.Injector }, { token: BarCoreStateService, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
BarCoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCoreService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [APP_INITIALIZER]
                    }, {
                        type: Optional
                    }] }, { type: i0.Injector }, { type: BarCoreStateService, decorators: [{
                        type: Optional
                    }] }];
    } });

class BarLogModel {
}

var BarLogLevel;
(function (BarLogLevel) {
    BarLogLevel[BarLogLevel["Debug"] = 0] = "Debug";
    BarLogLevel[BarLogLevel["Audit"] = 1] = "Audit";
    BarLogLevel[BarLogLevel["Info"] = 2] = "Info";
    BarLogLevel[BarLogLevel["Warn"] = 3] = "Warn";
    BarLogLevel[BarLogLevel["Error"] = 4] = "Error";
    BarLogLevel[BarLogLevel["Critical"] = 5] = "Critical";
})(BarLogLevel || (BarLogLevel = {}));

/**
 * Represents a mechanism to add items to a queue and to read them out to execute something.
 */
class BarQueueProcessor {
    /**
     * Constructor.
     * @param storage Storage to use.
     * @param storageKey Key to use in the storage.
     */
    constructor(storage, storageKey) {
        this.storage = storage;
        this.storageKey = storageKey;
        this.started = false;
    }
    /**
     * Starts listening to the queue.
     * @param interval Interval in milliseconds to get items from the queue.
     * @param dequeueCount Number of items to get from the queue.
     */
    start(interval, dequeueCount) {
        this.subject$ = new Subject();
        this.execute$ = this.subject$.asObservable();
        this.intervalId = window.setInterval(() => this.dequeue(dequeueCount), interval);
        this.started = true;
    }
    /**
     * Stops listening to the queue.
     */
    stop() {
        if (this.started) {
            this.started = false;
            this.subject$.complete();
            this.subject$ = null;
            this.execute$ = null;
            window.clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
    /**
     * Adds an item to the queue.
     * @param item
     */
    enqueue(item) {
        let queueStr = this.storage.getItem(this.storageKey);
        let queue = null;
        if (queueStr == null) {
            queue = [];
        }
        else {
            queue = JSON.parse(queueStr);
        }
        queue.push(item);
        queueStr = JSON.stringify(queue);
        this.storage.setItem(this.storageKey, queueStr);
    }
    dequeue(dequeueCount) {
        let queueStr = this.storage.getItem(this.storageKey);
        if (queueStr != null) {
            let queue = JSON.parse(queueStr);
            if (queue.length > 0) {
                const itemsToSend = queue.slice(0, dequeueCount);
                queue = queue.slice(dequeueCount);
                if (queue.length == 0) {
                    this.storage.removeItem(this.storageKey);
                }
                else {
                    queueStr = JSON.stringify(queue);
                    this.storage.setItem(this.storageKey, queueStr);
                }
                this.subject$.next(itemsToSend);
            }
        }
    }
}

// https://stackoverflow.com/a/46078299/2174621
class BarHttpParams extends HttpParams {
    constructor(
    /**This means this is a request that should pass the interceptor but happens in background*/
    backgroundRequest = false, 
    /**This means interception should be ommited*/
    ommitInterceptor = false, options) {
        super(options);
        this.backgroundRequest = backgroundRequest;
        this.ommitInterceptor = ommitInterceptor;
    }
}

class BarLoggingHttpDefaultService {
    constructor(http, state) {
        this.http = http;
        this.state = state;
    }
    save(logs) {
        return this.http.post(this.state.location.barWeb.url + 'api/logging', logs, { params: new BarHttpParams(true, false) });
    }
}
BarLoggingHttpDefaultService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarLoggingHttpDefaultService, deps: [{ token: i1$1.HttpClient }, { token: BarCoreStateService }], target: i0.ɵɵFactoryTarget.Injectable });
BarLoggingHttpDefaultService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarLoggingHttpDefaultService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarLoggingHttpDefaultService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: BarCoreStateService }]; } });

class BarLoggingHttpService {
}
BarLoggingHttpService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarLoggingHttpService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BarLoggingHttpService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarLoggingHttpService, providedIn: 'root', useClass: BarLoggingHttpDefaultService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarLoggingHttpService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root', useClass: BarLoggingHttpDefaultService }]
        }] });

/**
 BAR connectivity modus. In the future extra connectivities could be supported (no boolean).
 */
var BarConnectivity;
(function (BarConnectivity) {
    /** The application is online -> connect to remote BAR */
    BarConnectivity[BarConnectivity["Online"] = 0] = "Online";
    /** The application is offline -> connect to local BAR (in the same process) */
    BarConnectivity[BarConnectivity["Offline"] = 1] = "Offline";
})(BarConnectivity || (BarConnectivity = {}));

class BarAuthOptions {
    constructor() {
        /** Whether authentication is enabled */
        this.enabled = true;
        /** Whether IDP validation is enabled. */
        this.validation = true;
    }
}

class BarConnectedModuleOptions {
    constructor() {
        /** The authentication options */
        this.auth = new BarAuthOptions();
        /** Whether the sources (static files, web api) are local or remote */
        this.connectivity = BarConnectivity.Online;
    }
}

class BarLoggingService {
    constructor(state, loggingHttpService, config) {
        this.state = state;
        this.loggingHttpService = loggingHttpService;
        this.config = config;
        // instantiate the queue with session storage
        this.queueProcessor = new BarQueueProcessor(window.sessionStorage, `${BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX}logQueue`);
    }
    error(log) {
        this.post(log, BarLogLevel.Error);
    }
    warn(log) {
        this.post(log, BarLogLevel.Warn);
    }
    critical(log) {
        this.post(log, BarLogLevel.Critical);
    }
    info(log) {
        this.post(log, BarLogLevel.Info);
    }
    /**
     * Inits logging logic (init != start).
     */
    init() {
        const global = ensureGlobal('lvflanders.bar.ng.core.logging');
        Object.defineProperty(global, 'failedLogs', {
            get() {
                const failedLogsStr = window.localStorage.getItem(BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX + 'failedLogs');
                return failedLogsStr != null ? JSON.parse(failedLogsStr) : null;
            }
        });
    }
    /**
     * Start to listen to the log queue.
     */
    start() {
        // start listening to the queue
        this.queueProcessor.start(this.state.config.log.interval, this.state.config.log.itemCount);
        // post items to back-end with interval
        this.queueProcessor.execute$
            .pipe(mergeMap((logs) => this.loggingHttpService.save(logs).pipe(catchError((error) => {
            console.error(error);
            // in case of failure we store this in the local storage with a timestamp
            const failedLogsStr = window.localStorage.getItem(BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX + 'failedLogs');
            const failedLogs = failedLogsStr != null ? JSON.parse(failedLogsStr) : [];
            logs.forEach((log) => {
                log.timestamp = new Date();
                failedLogs.push(log);
            });
            window.localStorage.setItem(BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX + 'failedLogs', JSON.stringify(failedLogs));
            return of(null);
        }))))
            .subscribe();
    }
    post(log, level) {
        var _a;
        if (!((_a = this.state.config) === null || _a === void 0 ? void 0 : _a.log.enabled))
            return;
        const model = new BarLogModel();
        model.logLevel = level;
        model.message = log.message;
        if (log.error != null) {
            if (typeof log.error === 'string') {
                model.exception = log.error;
                if (model.message == null) {
                    model.message = log.error;
                }
            }
            else {
                model.exception = log.error.message;
                model.stackTrace = log.error.stack;
                if (model.message == null) {
                    model.message = log.error.message;
                }
            }
        }
        // toepassing informatie meegeven om te loggen in context van die toepassing (use config if null)
        if (this.state.toepassing != null) {
            model.appCode = this.state.toepassing.code;
            model.appVersion = this.state.toepassing.versie;
        }
        else {
            model.appCode = this.config.appCode;
            model.appVersion = this.config.appVersion;
        }
        if (!model.message)
            model.message = '';
        // append the current URL for extra information purposes
        model.message += `\r\n\r\nURL: ${window.location.href}`;
        this.queueProcessor.enqueue(model);
    }
}
BarLoggingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarLoggingService, deps: [{ token: BarCoreStateService }, { token: BarLoggingHttpService }, { token: BarConnectedModuleOptions }], target: i0.ɵɵFactoryTarget.Injectable });
BarLoggingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarLoggingService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarLoggingService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: BarCoreStateService }, { type: BarLoggingHttpService }, { type: BarConnectedModuleOptions }]; } });

// https://medium.com/@amcdnl/global-error-handling-with-angular2-6b992bdfb59c
class BarErrorHandler {
    constructor(zone, core, logging, errorHandlerHooks) {
        this.zone = zone;
        this.core = core;
        this.logging = logging;
        this.errorHandlerHooks = errorHandlerHooks;
        const global = ensureGlobal('lvflanders.bar.ng.core');
        // make global variable to handle the error from outside Angular
        global.handleError = (error) => {
            // run back in Angular zone from outside Angular
            this.zone.run(() => {
                // invoke error routine
                this.handleError(error);
            });
        };
    }
    handleError(error) {
        var _a;
        if (error == null)
            return;
        if (typeof error === 'object') {
            error.handled = true;
        }
        let proceed = true;
        // process angular hooks
        if (this.errorHandlerHooks && this.errorHandlerHooks.length) {
            this.errorHandlerHooks.forEach((hook) => {
                const args = {
                    handled: false,
                    error: error
                };
                hook.run(args);
                if (args.handled)
                    proceed = false;
            });
        }
        // process non-angular handlers
        if ((_a = BarErrorHandling.instance.delegates) === null || _a === void 0 ? void 0 : _a.length) {
            BarErrorHandling.instance.delegates.forEach((handler) => {
                const args = {
                    handled: false,
                    error: error
                };
                handler.handle(args);
                if (args.handled)
                    proceed = false;
            });
        }
        // a hook already handled the error, stop proceeding
        if (!proceed)
            return;
        // do something with the exception
        try {
            console.error(error);
            const getCircularReplacer = () => {
                const seen = new WeakSet();
                return (key, value) => {
                    if (typeof value === 'object' && value !== null) {
                        if (seen.has(value)) {
                            return;
                        }
                        seen.add(value);
                    }
                    return value;
                };
            };
            // put the error in session storage
            window.sessionStorage[BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX + 'error'] = JSON.stringify(error, getCircularReplacer());
            this.core.errorOccurred.emit(error);
            if (this.logging != null) {
                this.logging.error({ error });
            }
        }
        catch (error) {
            console.error(error);
        }
    }
}
BarErrorHandler.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarErrorHandler, deps: [{ token: i0.NgZone }, { token: BarCoreService }, { token: BarLoggingService, optional: true }, { token: BAR_ERROR_HANDLER, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
BarErrorHandler.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarErrorHandler });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarErrorHandler, decorators: [{
            type: Injectable
        }], ctorParameters: function () {
        return [{ type: i0.NgZone }, { type: BarCoreService }, { type: BarLoggingService, decorators: [{
                        type: Optional
                    }] }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [BAR_ERROR_HANDLER]
                    }, {
                        type: Optional
                    }] }];
    } });

class BarErrorExpressionChangedAfterCheckedHook {
    /** Invoked by the error handler. */
    run(args) {
        if (args.error && args.error.code === '100' && args.error.message && args.error.message.startsWith('NG0100')) {
            args.handled = true;
            console.error(args.error);
        }
    }
}

/** Represents the strategy to use for converting date objects to strings. */
var BarDateTimeConversionStrategy;
(function (BarDateTimeConversionStrategy) {
    /** Converts the date to an iso string with the exact same date. */
    BarDateTimeConversionStrategy[BarDateTimeConversionStrategy["Iso"] = 0] = "Iso";
    /** Converts the date to an iso string in GMT 0. */
    BarDateTimeConversionStrategy[BarDateTimeConversionStrategy["IsoGmt"] = 1] = "IsoGmt";
})(BarDateTimeConversionStrategy || (BarDateTimeConversionStrategy = {}));

class BarCoreModuleOptions {
}

// NOTE based on https://gist.github.com/martinobordin/39bb1fe3400a29c1078dec00ff76bba9
const ISO_8601_REGEX = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/;
/** This http interceptor will capture json calls and transform ISO strings to Date objects through date-fns and vice versa. */
class BarDateTimeHttpInterceptor {
    constructor(moduleOptions) {
        this.moduleOptions = moduleOptions;
    }
    intercept(req, next) {
        this.traverseInput(req.body);
        return next.handle(req).pipe(tap((event) => {
            if (event instanceof HttpResponse) {
                const body = event.body;
                this.traverseOutput(body);
            }
        }));
    }
    traverseInput(body) {
        this.traverse(body, (value) => checkDateObject(value), (value) => this.convertToISOString(value), (body) => this.traverseInput(body));
    }
    traverseOutput(body) {
        this.traverse(body, (value) => this.isIso8601(value), (value) => parseISO(value), (body) => this.traverseOutput(body));
    }
    convertToISOString(value) {
        switch (this.moduleOptions.dateTimeInterception.conversionStrategy) {
            case BarDateTimeConversionStrategy.IsoGmt:
                return value.toISOString();
            default:
            case BarDateTimeConversionStrategy.Iso:
                return convertToISOString(value);
        }
    }
    traverse(body, matcher, converter, traverser) {
        if (body == null || typeof body !== 'object')
            return;
        if (Array.isArray(body)) {
            for (let i = 0; i < body.length; i++) {
                const value = body[i];
                if (matcher(value)) {
                    body[i] = converter(value);
                }
                else if (typeof value === 'object') {
                    traverser(value);
                }
            }
        }
        else {
            for (const key of Object.keys(body)) {
                const value = body[key];
                if (matcher(value)) {
                    body[key] = converter(value);
                }
                else if (typeof value === 'object') {
                    traverser(value);
                }
            }
        }
    }
    isIso8601(value) {
        if (value === null || value === undefined)
            return false;
        return ISO_8601_REGEX.test(value);
    }
}
BarDateTimeHttpInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarDateTimeHttpInterceptor, deps: [{ token: BarCoreModuleOptions }], target: i0.ɵɵFactoryTarget.Injectable });
BarDateTimeHttpInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarDateTimeHttpInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarDateTimeHttpInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: BarCoreModuleOptions }]; } });

class BarEmptyComponent {
}
BarEmptyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarEmptyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BarEmptyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BarEmptyComponent, selector: "ng-component", ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarEmptyComponent, decorators: [{
            type: Component,
            args: [{ template: '' }]
        }] });

var translations$1 = {
    GENERIC_ERROR: 'Er heeft zich een fout voorgedaan'
};

// next is needed for case insensitive routing (added as provider in the forRoot method)
class LowerCaseUrlSerializer extends DefaultUrlSerializer {
    parse(url) {
        return super.parse(url.toLowerCase());
    }
}
const coreRoutes = [{ path: 'bar-refresh', component: BarEmptyComponent, data: { _framework: true } }];
// NOTE this is used for backwards compatibility with basiscomponenten while @bar 8 is still supported
class BarCoreModule {
    constructor(injector, translate) {
        this.injector = injector;
        this.translate = translate;
        BarCoreModule.injector = this.injector;
        this.translate.addTranslations('DOMAIN_BAR_CORE', translations$1);
    }
    static forRoot(options = { dateTimeInterception: { enabled: false } }) {
        if (options == null)
            options = new BarCoreModuleOptions();
        if (options.dateTimeInterception == null)
            options.dateTimeInterception = { enabled: false };
        if (options.dateTimeInterception.enabled && !options.dateTimeInterception.conversionStrategy)
            options.dateTimeInterception.conversionStrategy = BarDateTimeConversionStrategy.Iso;
        // register nl-BE
        registerLocaleData(localeNlBe, LOCALE.FLEMISH, localeNlBeExtra);
        registerLocaleData(localeNl, LOCALE.DUTCH, localeNlExtra);
        const providers = [
            { provide: LOCALE_ID, useValue: LOCALE.FLEMISH },
            {
                provide: BarCoreModuleOptions,
                useValue: options
            },
            {
                provide: UrlSerializer,
                // routing needs to work case insensitive
                useClass: LowerCaseUrlSerializer
            },
            Location,
            {
                provide: LocationStrategy,
                useClass: PathLocationStrategy
            },
            {
                provide: ErrorHandler,
                useClass: BarErrorHandler
            },
            {
                provide: BAR_ERROR_HANDLER,
                useClass: BarErrorExpressionChangedAfterCheckedHook,
                multi: true
            }
        ];
        if (options.dateTimeInterception.enabled) {
            providers.push({
                provide: HTTP_INTERCEPTORS,
                useClass: BarDateTimeHttpInterceptor,
                multi: true
            });
        }
        return {
            ngModule: BarCoreModule,
            providers: providers
        };
    }
}
BarCoreModule.injector = null;
BarCoreModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCoreModule, deps: [{ token: i0.Injector }, { token: i1$2.BarI18nService }], target: i0.ɵɵFactoryTarget.NgModule });
BarCoreModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: BarCoreModule, declarations: [BarEmptyComponent], imports: [i1.RouterModule, BarI18nModule] });
BarCoreModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCoreModule, imports: [RouterModule.forChild(coreRoutes), BarI18nModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BarEmptyComponent],
                    imports: [RouterModule.forChild(coreRoutes), BarI18nModule]
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i1$2.BarI18nService }]; } });

function defineCacheKey(cacheKeyPrefix, paramNames, args) {
    // no arguments just use cache key prefix (class + method)
    if (paramNames.length == 0) {
        return cacheKeyPrefix;
    }
    if (paramNames.length != args.length) {
        // we cannot match the parameters names with the arguments so we just stringify entire args
        return `${cacheKeyPrefix}_${JSON.stringify(args)}`;
    }
    // we have matching parameters, loop through them and generate a full cache key
    let result = cacheKeyPrefix;
    for (let i = 0; i < paramNames.length; i++) {
        result += `_${paramNames[i]}:${JSON.stringify(args[i])}`;
    }
    return result;
}
/**
 * Decorator to use to use on functions which return an observable which will use @lvflanders/bar caching.
 * Note that because it uses async cache it cannot be used on methods which do not return Observable.
 * @param options
 */
function BarCacheable(options) {
    return function (target, key, descriptor) {
        // original method
        const originalMethod = descriptor.value;
        const className = target.constructor != null ? target.constructor.name : null;
        const cacheKeyPrefix = options == null || options.key == null ? `${className}_${key}` : options.key;
        const paramNames = getParamNames(descriptor.value);
        descriptor.value = function (...args) {
            const cacheKey = defineCacheKey(cacheKeyPrefix, paramNames, args);
            let cacheStore;
            if (options != null && options.store != null) {
                if (options.store instanceof InjectionToken) {
                    // we have an injection token use this
                    cacheStore = BarCoreModule.injector.get(options.store);
                }
                else {
                    const manager = BarCoreModule.injector.get(BarCacheManager);
                    cacheStore = manager.getStore(options.store);
                }
            }
            else {
                // get the default one which is for the current app
                cacheStore = BarCoreModule.injector.get(BarCacheStore);
            }
            if (options != null && options.promise) {
                // consumer wants to use a promise return type
                return cacheStore.getOrSetItem(cacheKey, () => {
                    // callback in case not in cache yet
                    // get original result and we make assumption that an observable is used because this is what is mostly used in Angular applications
                    const originalResult = originalMethod.apply(this, args);
                    if (originalResult instanceof Promise) {
                        // convert it back to a promise because @lvflanders/bar uses promises to be more loosely coupled
                        return originalResult;
                    }
                    else {
                        Promise.reject('Functions using BarCacheable from @lvflanders/bar-ng decorator must return a Promise in case BarCacheableOptions.promise equals true.');
                    }
                }, options != null ? options.options : BarCacheEntryOptions.default);
            }
            else {
                // consumer wants to use default Observable return type
                // get the item through the cache and converts it to observable because we cannot detect at runtime what the return type of a method is without executing it
                return from(cacheStore.getOrSetItem(cacheKey, () => {
                    // callback in case not in cache yet
                    // get original result and we make assumption that an observable is used because this is what is mostly used in Angular applications
                    const originalResult = originalMethod.apply(this, args);
                    if (originalResult instanceof Observable) {
                        // convert it back to a promise because @lvflanders/bar uses promises to be more loosely coupled
                        return lastValueFrom(originalResult);
                    }
                    else {
                        Promise.reject('Functions using BarCacheable from @lvflanders/bar-ng decorator must return an Observable in case BarCacheableOptions.promise is not equal true.');
                    }
                }, options != null ? options.options : BarCacheEntryOptions.default));
            }
        };
        return descriptor;
    };
}

var BaasContextTransportModus;
(function (BaasContextTransportModus) {
    BaasContextTransportModus[BaasContextTransportModus["OnlineCookies"] = 0] = "OnlineCookies";
    BaasContextTransportModus[BaasContextTransportModus["OfflineHeaders"] = 1] = "OfflineHeaders";
    BaasContextTransportModus[BaasContextTransportModus["OnlineHeaders"] = 2] = "OnlineHeaders";
})(BaasContextTransportModus || (BaasContextTransportModus = {}));

class BarAppInfoSecure {
}

class BarBasiscontext {
}

var BarSecurityLevel;
(function (BarSecurityLevel) {
    BarSecurityLevel[BarSecurityLevel["Development"] = 0] = "Development";
    BarSecurityLevel[BarSecurityLevel["Test"] = 1] = "Test";
    BarSecurityLevel[BarSecurityLevel["Production"] = 2] = "Production";
    BarSecurityLevel[BarSecurityLevel["Unknown"] = 3] = "Unknown";
})(BarSecurityLevel || (BarSecurityLevel = {}));

/** header object coming from BaaS apps, an stored in session storage */
class BaasPersistentStateObject {
}
class UserTicketInfo {
}
var TokenType;
(function (TokenType) {
    TokenType[TokenType["BarSecTicket"] = 0] = "BarSecTicket";
    TokenType[TokenType["OidcLinkId"] = 1] = "OidcLinkId";
})(TokenType || (TokenType = {}));

class BarAppInfo {
}

/** Stores/retrieves baaS context header to window.sessionStorage
 *  This header is being used as the alternative for cookies
 */
class BaasContextService {
    /** saves the baas state context as a structure in sessiondata (for re-use in headers). Will only save when key does not exist */
    saveBaasContextToStorage(baasPersistentStateObject) {
        // Q&D enums from backend can become strings due to following setting:
        // o.SerializerSettings.Converters.Add(new Newtonsoft.Json.Converters.StringEnumConverter());
        // here we parse it back to a numeric enum (which is expected by the backend header parsing logic)
        if (typeof baasPersistentStateObject.tokenType === 'string') {
            const strTokenType = baasPersistentStateObject.tokenType;
            switch (strTokenType.toUpperCase()) {
                case 'BARSECTICKET':
                    baasPersistentStateObject.tokenType = TokenType.BarSecTicket;
                    break;
                case 'OIDCLINKID':
                    baasPersistentStateObject.tokenType = TokenType.OidcLinkId;
                    break;
                default:
                    baasPersistentStateObject.tokenType = undefined;
                    break;
            }
        }
        const jsonObj = JSON.stringify(baasPersistentStateObject);
        window.sessionStorage.setItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAAS_STATE_CONTEXT, jsonObj);
        /*Session storage is boss here, but localstorage also serves as a "backup" for other apps that run on different browser windows (in Hybrid and Headeronly modus without cookies)*/
        window.localStorage.setItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAAS_STATE_CONTEXT, jsonObj);
    }
    /** Updates the baas context (when it exists in storage) with altered voorwie + hoedanigheid */
    updateAppInfoToStorage(appInfo) {
        var _a, _b, _c, _d, _e, _f;
        if (!this.checkBaasContextInStorage())
            return;
        const data = this.getBaasContextFromStorage();
        //only certain fields are allowed to be altered
        const vw = (_a = appInfo.ToepVoorwie) !== null && _a !== void 0 ? _a : '';
        const vwrc = (_b = appInfo.ToepVoorwieRolcode) !== null && _b !== void 0 ? _b : '';
        const hd = (_c = appInfo.ToepHoedanigheid) !== null && _c !== void 0 ? _c : '';
        const hdrc = (_d = appInfo.ToepHoedanigheidRolcode) !== null && _d !== void 0 ? _d : '';
        data.userVoorwie = `${vw};${vwrc}`;
        data.userHoedanigheid = `${hd};${hdrc}`;
        //choosing a(nother) testprofiel can also alter the user here!!
        data.userID = (_e = appInfo === null || appInfo === void 0 ? void 0 : appInfo.ToepUser) !== null && _e !== void 0 ? _e : data.userID; //do not alter this when no other guid available (in case of external auth provider)
        data.userTicketGuid = (_f = appInfo === null || appInfo === void 0 ? void 0 : appInfo.SecurityTicketGuid) !== null && _f !== void 0 ? _f : data.userTicketGuid;
        if (data.userTicketInfo == null)
            data.userTicketInfo = new UserTicketInfo();
        data.userTicketInfo.userCbiUserID = appInfo.CbiUserId;
        //save changed object in session state
        window.sessionStorage.setItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAAS_STATE_CONTEXT, JSON.stringify(data));
        window.sessionStorage.removeItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAR_APPINFO_CONTEXT); //(cache cleared) needs to be recreated next time appinfo is retrieved
        window.localStorage.setItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAAS_STATE_CONTEXT, JSON.stringify(data)); //keep localstorage in sync
    }
    /** returns stored baas context object in stringified format (used for baas.context.backend header)*/
    getBaasContextAsHeaderString() {
        const data = this.getBaasContextString();
        if (data == null)
            return '';
        return data;
    }
    /** detects if baaS context state is available in storage (alternative for cookies)*/
    checkBaasContextInStorage() {
        return this.getBaasContextString() !== null;
    }
    /** retrieves baaS context from storage and converts it into appinfo object */
    getAppInfoFromStorage() {
        //this method is requested many times, so needs to be fast!
        const appInfoDataFromStorage = window.sessionStorage.getItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAR_APPINFO_CONTEXT);
        if (appInfoDataFromStorage !== null)
            return JSON.parse(appInfoDataFromStorage);
        //no appinfo in session store.. retrieve baas state insead, then convert it to appinfo, and store + return appinfo
        const data = this.getBaasContextFromStorage();
        const appinfo = this.convertFromBaasState(data);
        window.sessionStorage.setItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAR_APPINFO_CONTEXT, JSON.stringify(appinfo)); //save for fast retrieval
        return appinfo;
    }
    removeContextFromSession() {
        window.sessionStorage.removeItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAAS_STATE_CONTEXT);
        window.sessionStorage.removeItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAR_APPINFO_CONTEXT);
        window.localStorage.removeItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAAS_STATE_CONTEXT); //keep localstore in sync
    }
    convertFromBaasState(baas) {
        var _a, _b;
        const resp = new BarAppInfo();
        resp.AuditId = baas.auditID;
        resp.CbiUserId = (_a = baas.userTicketInfo) === null || _a === void 0 ? void 0 : _a.userCbiUserID;
        resp.SecurityTicketGuid = baas.userTicketGuid;
        resp.UserZone = (_b = baas.userTicketInfo) === null || _b === void 0 ? void 0 : _b.userZone;
        //old stuff that does not exist in BaaS
        resp.ForcePerformanceLog = false;
        resp.AllowCookieAuth = false;
        //old stuff ends
        resp.ExpireTicks = this.generateDatum2DaysInFutureInticks(); //set dotnet ticks, 48 hrs in future
        resp.Timestamp = new Date().toString();
        resp.ToepVoorwie = this.getPart(true, baas === null || baas === void 0 ? void 0 : baas.userVoorwie);
        resp.ToepVoorwieRolcode = this.getPart(false, baas === null || baas === void 0 ? void 0 : baas.userVoorwie);
        resp.ToepHoedanigheid = this.getPart(true, baas === null || baas === void 0 ? void 0 : baas.userHoedanigheid);
        resp.ToepHoedanigheidRolcode = this.getPart(false, baas === null || baas === void 0 ? void 0 : baas.userHoedanigheid);
        resp.ToepUser = baas === null || baas === void 0 ? void 0 : baas.userID;
        return resp;
    }
    generateDatum2DaysInFutureInticks() {
        const date = new Date();
        date.setTime(date.getTime() + 50 * 60 * 60 * 1000); //add 2 days + 2 hours time-zone compensation
        const ticks = date.getTime() * 10000 + 621355968000000000; //ticks from epoch (1970) to this date
        return ticks;
    }
    getPart(getfirstPart, input) {
        var _a, _b;
        if (input == null)
            return '';
        if (input.indexOf(';') == -1)
            return '';
        const segments = input.split(';');
        if (segments.length != 2)
            return '';
        return getfirstPart ? (_a = segments[0]) === null || _a === void 0 ? void 0 : _a.trim() : (_b = segments[1]) === null || _b === void 0 ? void 0 : _b.trim();
    }
    /** Retrieves the baasPersistentStateObject from storage if it exists */
    getBaasContextFromStorage() {
        const data = this.getBaasContextString();
        if (data === null)
            return null;
        return JSON.parse(data);
    }
    /** get raw string from session or local storage */
    getBaasContextString() {
        let data = window.sessionStorage.getItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAAS_STATE_CONTEXT);
        if (data === null) {
            data = window.localStorage.getItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAAS_STATE_CONTEXT); //get it from local storage backup (and copy in sessionstorage) instead!
            if (data !== null)
                window.sessionStorage.setItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAAS_STATE_CONTEXT, data);
        }
        return data;
    }
}
BaasContextService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasContextService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BaasContextService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasContextService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasContextService, decorators: [{
            type: Injectable
        }] });

// NOTE this service is not exposed to consumers
// NOTE partially copied from legacy bwcCookieUpdater.ts and util.ts
/**
 * This service will perform manipulations on the app info cookie or BaaS persistentstateobject (wrapper around cookie).
 */
class BarAppInfoService {
    constructor(state, baasContextService, config) {
        this.state = state;
        this.baasContextService = baasContextService;
        this.config = config;
        /** Occurs when synchronisation is needed (local cookie and server cookie) */
        this.onSyncRequired = new EventEmitter();
    }
    get sessionId() {
        return this.readCookie(BAR_CORE_CONSTANTS.COOKIE.APP_INFO.SESSION);
    }
    set sessionId(sessionId) {
        this.createCookie(BAR_CORE_CONSTANTS.COOKIE.APP_INFO.SESSION, sessionId);
    }
    /**
     * Passes initialization data.
     * @param data
     */
    init(data) {
        this.data = data;
    }
    /**
     * Gets the app info data from the cookie or from stored BaaS persist object
     */
    get() {
        if (this.baasContextModus !== BaasContextTransportModus.OnlineCookies) {
            //do NOT get state from cookie but from session when that object is available
            if (this.baasContextService.checkBaasContextInStorage())
                return this.baasContextService.getAppInfoFromStorage();
            return null; //WARNING THIS MODUS IGNORES COOKIES
        }
        const koek = this.readCookie(BAR_CORE_CONSTANTS.COOKIE.APP_INFO.MAIN);
        if (koek == null)
            return null;
        // decode again because it is possible the cookie is double encoded (iframe...)
        return JSON.parse(decodeURIComponent(koek));
    }
    /** Deletes the app info cookie and the secure cookie (if possible). */
    delete() {
        this.baasContextService.removeContextFromSession(); //equal to logoff
        if (this.baasContextModus !== BaasContextTransportModus.OnlineCookies)
            return; //WARNING THIS MODUS IGNORES COOKIES
        deleteCookie(BAR_CORE_CONSTANTS.COOKIE.APP_INFO.MAIN);
        deleteCookie(BAR_CORE_CONSTANTS.COOKIE.APP_INFO.SECURE);
    }
    /**
     * Saves the app info data
     * @param appInfo
     */
    save(appInfo, createGuidCookie = false, setTimestamp = true, emit = true, syncContext = null) {
        if (setTimestamp) {
            appInfo.Timestamp = new Date().toISOString();
        }
        if (this.baasContextModus != BaasContextTransportModus.OnlineCookies)
            this.baasContextService.updateAppInfoToStorage(appInfo);
        if (this.baasContextModus == BaasContextTransportModus.OfflineHeaders)
            return Promise.resolve(null); //do NOT call xdc to set cookies
        // save cookie (writes new cookie)
        this.createCookie(BAR_CORE_CONSTANTS.COOKIE.APP_INFO.MAIN, JSON.stringify(appInfo));
        if (createGuidCookie || this.secureCookieMissing) {
            //also make guid cookie when missing
            const secureContent = new BarAppInfoSecure();
            secureContent.SecurityTicketGuid = appInfo.SecurityTicketGuid;
            secureContent.ExpireTicks = appInfo.ExpireTicks;
            this.createCookie(BAR_CORE_CONSTANTS.COOKIE.APP_INFO.SECURE, JSON.stringify(secureContent));
        }
        if (emit) {
            return this.sync({ caller: 'Save', innerContext: syncContext });
        }
        else {
            // nothing to emit: just auto resolve
            return Promise.resolve();
        }
    }
    /**
     * Persists the modifiable data of the basiscontext into the app info cookie.
       This is used when having to make a request to the back-end.
     * @param basiscontext
     */
    persistBasiscontext(syncContext) {
        if (this.state.basiscontext == null)
            return;
        const context = {
            caller: 'PersistBasiscontext',
            innerContext: syncContext
        };
        return new Promise((resolve, reject) => {
            // first we sync cookies (or auto resolve in case not localhost)
            this.sync(context).then(() => {
                const appInfo = this.get();
                if (appInfo != null) {
                    // make sure not to put value null because this will lead to a null string after uri encode
                    appInfo.ToepVoorwie = this.state.basiscontext.voorwie == null ? '' : this.state.basiscontext.voorwie;
                    appInfo.ToepVoorwieRolcode = this.state.basiscontext.voorwieRolcode == null ? '' : this.state.basiscontext.voorwieRolcode;
                    appInfo.ToepHoedanigheid = this.state.basiscontext.hoedanigheid == null ? '' : this.state.basiscontext.hoedanigheid;
                    appInfo.ToepHoedanigheidRolcode = this.state.basiscontext.hoedanigheidRolcode == null ? '' : this.state.basiscontext.hoedanigheidRolcode;
                    // save it
                    this.save(appInfo, false, true, true, context)
                        .then(() => {
                        resolve();
                    })
                        .catch(() => {
                        reject();
                    });
                }
                else {
                    resolve();
                }
            });
        });
    }
    /**
     * Derives the basis context from the app info cookie.
     */
    getBasiscontext() {
        const appInfo = this.get();
        return this.toBasiscontext(appInfo);
    }
    sync(context) {
        if (this.baasContextModus !== BaasContextTransportModus.OnlineCookies)
            //no not sync
            return Promise.resolve(null);
        // emit the event and pass the resolve reject
        return new Promise((resolve, reject) => {
            this.onSyncRequired.next({ resolve, reject, context });
        });
    }
    toBasiscontext(appInfo) {
        let result = null;
        if (appInfo != null) {
            result = new BarBasiscontext();
            // assign values with trick for readonly values
            const hoedanigheidKey = 'hoedanigheid';
            result[hoedanigheidKey] = appInfo.ToepHoedanigheid;
            const hoedanigheidRolcodeKey = 'hoedanigheidRolcode';
            result[hoedanigheidRolcodeKey] = appInfo.ToepHoedanigheidRolcode;
            const voorwieKey = 'voorwie';
            result[voorwieKey] = appInfo.ToepVoorwie;
            const voorwieRolcodeKey = 'voorwieRolcode';
            result[voorwieRolcodeKey] = appInfo.ToepVoorwieRolcode;
            const userIdKey = 'userId';
            result[userIdKey] = appInfo.ToepUser;
            const securityTicketIdKey = 'securityTicketId';
            result[securityTicketIdKey] = appInfo.SecurityTicketGuid || '';
            const zoneKey = 'zone';
            result[zoneKey] = appInfo.UserZone || appInfo.ToepZone;
            // assign extra initialization data which does not exist in the cookie
            if (this.data != null) {
                const fullUsernameKey = 'fullUsername';
                result[fullUsernameKey] = this.data.fullUsername;
                const klantnummerKey = 'klantnummer';
                result[klantnummerKey] = this.data.klantnummer;
                // define test profiel
                // if the user starts with DUMMY we know it is a test profiel
                if (result.userId != null && result.userId.toString().startsWith('DUMMY')) {
                    // now we need to substract the test profiel name
                    const testProfielKey = 'testProfiel';
                    try {
                        result[testProfielKey] = result.fullUsername.substr(result.fullUsername.indexOf('\\') + 1, result.fullUsername.indexOf('#') - 6);
                    }
                    catch (error) {
                        console.warn('BarAppInfoService: ', error);
                    }
                }
            }
            // assign extra data which exists outside the cookie
            const impersonateStrStorage = window.localStorage.getItem(BAR_CORE_CONSTANTS.STORAGE_KEYS.IDP_IMPERSONATE);
            let impersonate = false;
            if (impersonateStrStorage != null && impersonateStrStorage.length) {
                impersonate = impersonateStrStorage.toLowerCase() === true.toString();
            }
            const impersonateKey = 'impersonate';
            result[impersonateKey] = impersonate;
        }
        return result;
    }
    readCookie(name) {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ')
                c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) {
                const cookieValue = decodeURIComponent(c.substring(nameEQ.length, c.length));
                return cookieValue === 'null' ? null : cookieValue;
            }
        }
        return null;
    }
    get secureCookieMissing() {
        return this.readCookie(BAR_CORE_CONSTANTS.COOKIE.APP_INFO.SECURE) === null;
    }
    createCookie(name, value) {
        let str = name + '=' + encodeURIComponent(value) + ';path=/;'; //wimfra
        if (this.state.toepassing != null && this.state.toepassing.securityLevel != BarSecurityLevel.Production)
            str = str + 'SameSite=None;Secure=true;';
        document.cookie = str;
    }
    get baasContextModus() {
        var _a, _b, _c;
        //return BaasContextModus.HybridHeaderThenCookies;
        return (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.auth) === null || _b === void 0 ? void 0 : _b.contextTransportModus) !== null && _c !== void 0 ? _c : BaasContextTransportModus.OnlineCookies;
    }
}
BarAppInfoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAppInfoService, deps: [{ token: BarCoreStateService }, { token: BaasContextService }, { token: BarConnectedModuleOptions }], target: i0.ɵɵFactoryTarget.Injectable });
BarAppInfoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAppInfoService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAppInfoService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: BarCoreStateService }, { type: BaasContextService }, { type: BarConnectedModuleOptions }]; } });

class BarMeetpuntHttpDefaultService {
    constructor(http, state) {
        this.http = http;
        this.state = state;
    }
    save(meetpunten) {
        return this.http.post(this.state.location.barWeb.url + 'api/meetpunt', meetpunten, { params: new BarHttpParams(true, false) });
    }
}
BarMeetpuntHttpDefaultService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeetpuntHttpDefaultService, deps: [{ token: i1$1.HttpClient }, { token: BarCoreStateService }], target: i0.ɵɵFactoryTarget.Injectable });
BarMeetpuntHttpDefaultService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeetpuntHttpDefaultService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeetpuntHttpDefaultService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: BarCoreStateService }]; } });

class BarMeetpuntHttpService {
}
BarMeetpuntHttpService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeetpuntHttpService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BarMeetpuntHttpService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeetpuntHttpService, providedIn: 'root', useClass: BarMeetpuntHttpDefaultService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeetpuntHttpService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root', useClass: BarMeetpuntHttpDefaultService }]
        }] });

class BarMeetpuntService {
    constructor(state, appInfo, meetpuntHttpService) {
        this.state = state;
        this.appInfo = appInfo;
        this.meetpuntHttpService = meetpuntHttpService;
        // instantiate the queue with session storage
        this.queueProcessor = new BarQueueProcessor(window.sessionStorage, BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX + 'meetpuntQueue');
    }
    /** Whether performance logging is enabled:
        - must be enabled in config
        - must be enabled by cookie OR enabled in configuation for the toepassing
    */
    get loggingEnabled() {
        var _a;
        const appinfo = this.appInfo.get();
        // meetpunt must be enabled globally
        return (((_a = this.state.config) === null || _a === void 0 ? void 0 : _a.meetpunt.enabled) &&
            // we must be authenticated
            appinfo &&
            // must be enforced by cookie OR must be set on in configuration for the toepassing
            (appinfo.ForcePerformanceLog || this.state.meetpuntenAutomatischAanmaken) &&
            // must be supported by browser to perform measurements
            window.performance &&
            window.performance.timing != null);
    }
    /**
     * Logs a meetpunt.
     * @param meetpunt
     */
    log(meetpunt) {
        if (!this.loggingEnabled)
            return;
        if (meetpunt.appCode == null) {
            meetpunt.appCode = this.state.toepassing.code;
        }
        if (meetpunt.meetpuntType == null) {
            meetpunt.meetpuntType = BAR_CORE_CONSTANTS.DEFAULT_MEETPUNT_TYPE;
        }
        this.queueProcessor.enqueue(meetpunt);
    }
    /**
     * Start to listen to the meetpunten queue.
     */
    start() {
        // start listening to the queue
        this.queueProcessor.start(this.state.config.meetpunt.interval, this.state.config.meetpunt.itemCount);
        // post items to back-end with interval
        // NOTE use mergeMap because switchMap would cancel out first subscription which is a hot observable
        this.queueProcessor.execute$.pipe(mergeMap((meetpunten) => this.meetpuntHttpService.save(meetpunten))).subscribe();
    }
}
BarMeetpuntService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeetpuntService, deps: [{ token: BarCoreStateService }, { token: BarAppInfoService }, { token: BarMeetpuntHttpService }], target: i0.ɵɵFactoryTarget.Injectable });
BarMeetpuntService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeetpuntService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeetpuntService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: BarCoreStateService }, { type: BarAppInfoService }, { type: BarMeetpuntHttpService }]; } });

// https://netbasal.com/inspiration-for-custom-decorators-in-angular-95aeb87f072c
/**
 * Measures the duration of a directive or component (which is a directive) between ngOnInit and ngAfterViewInit.
 */
function BarMeetpunt() {
    return function (constructor) {
        // get meetpunt service through static injector on the core module
        const meetpunt = BarCoreModule.injector.get(BarMeetpuntService);
        const ngOnInit = constructor.prototype.ngOnInit;
        let stopwatch = null;
        // override the ngOnInit
        constructor.prototype.ngOnInit = function (...args) {
            // create and start new watch
            stopwatch = new BarStopwatch();
            stopwatch.start();
            // call original ngOnInit after starting the watch (if present)
            ngOnInit && ngOnInit.apply(this, args);
        };
        const ngAfterViewInit = constructor.prototype.ngAfterViewInit;
        // override the ngAfterViewInit
        constructor.prototype.ngAfterViewInit = function (...args) {
            // call original ngAfterViewInit if present
            ngAfterViewInit && ngAfterViewInit.apply(this, args);
            // stop the watch
            stopwatch.stop();
            // call meetpunt service to log this
            meetpunt.log({
                meetpunt: 'DIRECTIVE',
                meetpuntDetail: constructor.name,
                waarde: stopwatch.duration,
                meetpuntInfo: document.location.href
            });
            stopwatch = null;
        };
    };
}

var __OopsDomService_instances, __OopsDomService_coreStateService, __OopsDomService_mappings, __OopsDomService_oopsActionRefresh, __OopsDomService_oopsActionHome;
var _OopsType;
(function (_OopsType) {
    _OopsType[_OopsType["Technical"] = 0] = "Technical";
    _OopsType[_OopsType["Authentication"] = 1] = "Authentication";
    _OopsType[_OopsType["NotFound"] = 2] = "NotFound";
})(_OopsType || (_OopsType = {}));
const ACTION_ICON_REFRESH = 'fa-solid fa-rotate';
const ACTION_CONTENT_REFRESH = 'Wis & herlaad';
const ACTION_INFO_REFRESH = 'Met de knop hieronder wordt uw sessie-data gewist en deze pagina opnieuw geladen.';
class _OopsDomService {
    constructor() {
        __OopsDomService_instances.add(this);
        __OopsDomService_coreStateService.set(this, inject(BarCoreStateService, { optional: true }));
        __OopsDomService_mappings.set(this, {
            [_OopsType.Technical]: {
                title: 'Technische fout',
                content: 'Er heeft zich een technische fout voorgedaan.',
                action: __classPrivateFieldGet(this, __OopsDomService_instances, "m", __OopsDomService_oopsActionRefresh).bind(this),
                actionIcon: ACTION_ICON_REFRESH,
                actionContent: ACTION_CONTENT_REFRESH,
                actionInfo: ACTION_INFO_REFRESH
            },
            [_OopsType.Authentication]: {
                title: 'Authenticatie mislukt',
                content: 'Er heeft zich een authenticatie fout voorgedaan.',
                action: __classPrivateFieldGet(this, __OopsDomService_instances, "m", __OopsDomService_oopsActionRefresh).bind(this),
                actionIcon: ACTION_ICON_REFRESH,
                actionContent: ACTION_CONTENT_REFRESH,
                actionInfo: ACTION_INFO_REFRESH
            },
            [_OopsType.NotFound]: {
                title: 'Oeps',
                content: 'Deze pagina is vermist.',
                action: __classPrivateFieldGet(this, __OopsDomService_instances, "m", __OopsDomService_oopsActionHome).bind(this),
                actionIcon: 'fa-regular fa-house',
                actionContent: 'Terug naar Startscherm'
            }
        });
    }
    checkOopsSupported() {
        return document.getElementById('oops') != null;
    }
    showOops(settings) {
        var _a, _b, _c;
        if (!settings)
            throw new Error('Oops settings are required.');
        if (!this.checkOopsSupported()) {
            console.warn('Oops DOM is not supported.');
            return;
        }
        const oopsElement = document.getElementById('oops');
        if ((_c = (_b = (_a = __classPrivateFieldGet(this, __OopsDomService_coreStateService, "f")) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.baasStatic) === null || _c === void 0 ? void 0 : _c.url) {
            let image;
            let imgElement = document.getElementById('oops-image');
            // @deprecated old img id wrong convention
            if (imgElement == null)
                imgElement = document.getElementById('oopsImg');
            if (settings.type === _OopsType.NotFound)
                image = 'lv-melding-error-404.png';
            else {
                const number = generateRandomNumber(1, 8);
                image = `lv-melding-circle-0${number}.png`;
            }
            imgElement.src = concatUrl(__classPrivateFieldGet(this, __OopsDomService_coreStateService, "f").location.baasStatic.url, '/images/all/', image);
        }
        // new mechanism with oops
        oopsElement.style.display = 'block';
        const appRoot = document.getElementById('app-root');
        appRoot.parentElement.removeChild(appRoot);
        const loader = document.getElementById('app-loading');
        loader.style.display = 'none';
        const config = __classPrivateFieldGet(this, __OopsDomService_mappings, "f")[settings.type];
        const titleElement = document.getElementById('oops-title');
        if (titleElement)
            titleElement.innerText = config.title;
        const contentElement = document.getElementById('oops-content');
        if (contentElement)
            contentElement.innerText = config.content;
        const actionElement = document.getElementById('oops-action');
        if (actionElement)
            actionElement.addEventListener('click', config.action);
        const actionIconElement = document.getElementById('oops-action-icon');
        if (actionIconElement)
            actionIconElement.className = config.actionIcon;
        const actionContentElement = document.getElementById('oops-action-content');
        if (actionContentElement)
            actionContentElement.innerText = config.actionContent;
        const actionInfoElement = document.getElementById('oops-action-info');
        if (actionInfoElement) {
            actionInfoElement.style.display = config.actionInfo ? 'block' : 'none';
            actionInfoElement.innerText = config.actionInfo;
        }
    }
}
__OopsDomService_coreStateService = new WeakMap(), __OopsDomService_mappings = new WeakMap(), __OopsDomService_instances = new WeakSet(), __OopsDomService_oopsActionRefresh = function __OopsDomService_oopsActionRefresh() {
    return __awaiter(this, void 0, void 0, function* () {
        window.localStorage.clear();
        window.sessionStorage.clear();
        yield deleteAllIndexedDb();
        deleteAllCookies();
        window.location.reload();
    });
}, __OopsDomService_oopsActionHome = function __OopsDomService_oopsActionHome() {
    var _a, _b;
    if ((_b = (_a = __classPrivateFieldGet(this, __OopsDomService_coreStateService, "f")) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.homeUrl)
        window.location = __classPrivateFieldGet(this, __OopsDomService_coreStateService, "f").config.homeUrl;
    return Promise.resolve();
};
_OopsDomService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: _OopsDomService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
_OopsDomService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: _OopsDomService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: _OopsDomService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/**
 * Will return an Observable based on a value which can be of different types.
 * @param value
 */
function resolveValue$(value) {
    if (value instanceof Observable) {
        return value;
    }
    if (value instanceof Promise) {
        return from(value);
    }
    const resolvedValue = resolveValue(value);
    return of(resolvedValue);
}
/**
 * Convers an object to a http params.
 * @param obj
 */
// https://github.com/angular/angular/issues/18012
function convertToHttpParams(obj) {
    let params = new HttpParams();
    if (obj != null) {
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                const val = obj[key];
                if (val !== null && val !== undefined) {
                    params = params.append(key, val.toString());
                }
            }
        }
    }
    return params;
}
/** Creates the default base href factory. The base href factory generated will ensure the base href match is done in a case insensitive way. Use this when providing APP_BASE_HREF.*/
function createDefaultBaseHrefFactory(baseHref) {
    return () => {
        if (!baseHref || baseHref === '/')
            return baseHref;
        // do not take into account end slash because pathname is not with end slash
        const comparisonBaseHref = baseHref.endsWith('/') ? baseHref.substring(0, baseHref.length - 1) : baseHref;
        if (!window.location.pathname.toLowerCase().startsWith(comparisonBaseHref.toLowerCase()))
            return baseHref;
        return window.location.pathname.substring(0, comparisonBaseHref.length);
    };
}

class BarActie {
    constructor(actie) {
        if (actie != null) {
            this.actie = actie.actie;
            this.voorwie = actie.voorwie;
            this.voorwieRolcode = actie.voorwieRolcode;
            this.hoedanigheid = actie.hoedanigheid;
            this.hoedanigheidRolcode = actie.hoedanigheidRolcode;
        }
    }
}

class BarSecurityHttpDefaultService {
    constructor(http, state) {
        this.http = http;
        this.state = state;
    }
    checkActieAllowed(actie) {
        return this.http.post(this.state.location.barWeb.url + 'api/security/check-actie-allowed', actie);
    }
    getHoedanigheidInfoSet() {
        return this.http.get(this.state.location.barWeb.url + 'api/security/ticket-info').pipe(catchError((err) => {
            console.warn('You need BAR web api 7.54.1 or higher for the ticket info api.', err);
            return of([]);
        }));
    }
    getUserInfo() {
        // @deprecated feature flagging not needed in long term
        if (this.state.connectivity === BarConnectivity.Offline) {
            // old mechanisme in case offline modus (only hoedanigheid info set is filled in)
            // user-data doesn't exist in BAR
            return this.getHoedanigheidInfoSet().pipe(map((data) => ({
                hoedanigheidInfoSet: data
            })));
        }
        else {
            // ask baas static for the user data
            return this.http.get(this.state.location.baasStatic.url + 'baas/security/user-info').pipe(map((data) => ({
                cbiUserId: data.cbiUserId,
                hoedanigheidInfoSet: data.hoedList,
                contactInfo: data.contactInfo != null
                    ? {
                        klantnummer: data.contactInfo.alvNr,
                        firstname: data.contactInfo.firstName,
                        lastname: data.contactInfo.lastname,
                        fullName: data.contactInfo.fullname,
                        phone: data.contactInfo.phoneNumber,
                        mobile: data.contactInfo.mobileNumber,
                        email: data.contactInfo.mailAddress
                    }
                    : undefined
            })), catchError((err) => {
                console.error(err);
                return of({});
            }));
        }
    }
}
BarSecurityHttpDefaultService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarSecurityHttpDefaultService, deps: [{ token: i1$1.HttpClient }, { token: BarCoreStateService }], target: i0.ɵɵFactoryTarget.Injectable });
BarSecurityHttpDefaultService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarSecurityHttpDefaultService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarSecurityHttpDefaultService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: BarCoreStateService }]; } });

class BarSecurityHttpService {
}
BarSecurityHttpService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarSecurityHttpService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BarSecurityHttpService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarSecurityHttpService, providedIn: 'root', useClass: BarSecurityHttpDefaultService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarSecurityHttpService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root', useClass: BarSecurityHttpDefaultService }]
        }] });

/**
 * Security service to perform BAR security tasks.
 */
class BarSecurityService {
    constructor(securityHttpService, state, cacheManager) {
        this.securityHttpService = securityHttpService;
        this.state = state;
        this.cacheManager = cacheManager;
    }
    get store() {
        return this.cacheManager.getStore({
            storeType: BarCacheStoreType.User,
            store: 'actieAllowed',
            userId: this.state.basiscontext.userId
        });
    }
    /**
     * Checks whether the actie is allowed and returns an observable with the result.
     */
    checkActieAllowed(actie) {
        return defer(() => {
            const key = JSON.stringify(actie);
            const httpCallback = () => {
                return lastValueFrom(this.securityHttpService.checkActieAllowed(actie));
            };
            return this.store.getOrSetItem(key, httpCallback, {
                session: true
            });
        });
    }
    // NOTE equivalent of isActieAllowedFromSession but using basiscontext from page state
    /**
     * Checks whether the actie is allowed by checking the basiscontext and returns an observable with the result.
     * @param actie
     * @param includeVoorwie
     * @param includeHoedanigheid
     */
    checkActieAllowedFromContext(actie) {
        const actieObj = new BarActie();
        actieObj.actie = actie.actie;
        if (actie.includeVoorwie) {
            actieObj.voorwie = this.state.basiscontext.voorwie;
            actieObj.voorwieRolcode = this.state.basiscontext.voorwieRolcode;
        }
        if (actie.includeHoedanigheid) {
            actieObj.hoedanigheid = this.state.basiscontext.hoedanigheid;
            actieObj.hoedanigheidRolcode = this.state.basiscontext.hoedanigheidRolcode;
        }
        return this.checkActieAllowed(actieObj);
    }
    /**
     * Flushes the security browser cache.
     */
    flush() {
        return from(this.store.clear());
    }
}
BarSecurityService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarSecurityService, deps: [{ token: BarSecurityHttpService }, { token: BarCoreStateService }, { token: i1$3.BarCacheManager }], target: i0.ɵɵFactoryTarget.Injectable });
BarSecurityService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarSecurityService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarSecurityService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: BarSecurityHttpService }, { type: BarCoreStateService }, { type: i1$3.BarCacheManager }]; } });

class BarActieAllowedGuard {
    constructor(translate, core, security, state, localhost) {
        this.translate = translate;
        this.core = core;
        this.security = security;
        this.state = state;
        this.localhost = localhost;
    }
    // NOTE use any because of typescript compiler incompatibility
    canActivate(route) {
        return new Promise((resolve) => {
            // https://stackoverflow.com/questions/42719445/pass-parameter-into-route-guard
            const acties = route.data['acties'];
            // turns different observables into promises
            const promises = [];
            // iterate all acties
            acties.forEach((actie) => {
                const promise = lastValueFrom(this.security.checkActieAllowedFromContext(actie));
                // push to promise list
                promises.push(promise);
                // save the result
                promise.then((result) => {
                    if (!result) {
                        if (!this.localhost) {
                            // perform hard redirect on deployed environment
                            window.location.href = this.state.location.baasStatic.url + BAR_CORE_CONSTANTS.PAGES.INSUFFICIENT_PRIVILEGES;
                        }
                        else {
                            // on localhost emit an error, do not perform hard redirect
                            const errorMessage = this.translate.instant('DOMAIN_BAR_CORE_CONNECTED.INSUFFICIENT_PRIVILEGES_FOR_ACTIE', {
                                actie: actie.actie,
                                includeVoorwie: actie.includeVoorwie,
                                includeHoedanigheid: actie.includeHoedanigheid
                            });
                            console.error(errorMessage);
                            const error = new Error(errorMessage);
                            this.core.errorOccurred.emit(error);
                        }
                        resolve(false);
                    }
                });
            });
            // wait for all promises
            Promise.all(promises).then(() => {
                // give positive result because no false result was given
                resolve(true);
            });
        });
    }
}
BarActieAllowedGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarActieAllowedGuard, deps: [{ token: i1$2.BarI18nService }, { token: BarCoreService }, { token: BarSecurityService }, { token: BarCoreStateService }, { token: BAR_LOCALHOST }], target: i0.ɵɵFactoryTarget.Injectable });
BarActieAllowedGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarActieAllowedGuard });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarActieAllowedGuard, decorators: [{
            type: Injectable
        }], ctorParameters: function () {
        return [{ type: i1$2.BarI18nService }, { type: BarCoreService }, { type: BarSecurityService }, { type: BarCoreStateService }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [BAR_LOCALHOST]
                    }] }];
    } });

class BarProfielModel {
}

class BarProfielHttpDefaultService {
    constructor(http, state) {
        this.http = http;
        this.state = state;
    }
    read(model) {
        return this.http.post(this.state.location.barWeb.url + 'api/profiel/read', model, { responseType: 'text' });
    }
}
BarProfielHttpDefaultService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarProfielHttpDefaultService, deps: [{ token: i1$1.HttpClient }, { token: BarCoreStateService }], target: i0.ɵɵFactoryTarget.Injectable });
BarProfielHttpDefaultService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarProfielHttpDefaultService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarProfielHttpDefaultService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: BarCoreStateService }]; } });

class BarProfielHttpService {
}
BarProfielHttpService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarProfielHttpService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BarProfielHttpService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarProfielHttpService, providedIn: 'root', useClass: BarProfielHttpDefaultService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarProfielHttpService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root', useClass: BarProfielHttpDefaultService }]
        }] });

/** @deprecated use BarConfigurationService. */
class BarProfielService {
    constructor(state, cacheManager, profielHttpService) {
        this.state = state;
        this.cacheManager = cacheManager;
        this.profielHttpService = profielHttpService;
    }
    get store() {
        return this.cacheManager.getStore({
            storeType: BarCacheStoreType.User,
            store: 'profiel',
            userId: this.state.basiscontext.userId
        });
    }
    /**
     * Reads a profiel key and returns an observable.
     * @param key
     */
    read(key) {
        return defer(() => {
            const httpCallback = () => {
                const model = new BarProfielModel();
                model.key = key;
                model.appCode = this.state.toepassing.code;
                model.appVersion = this.state.toepassing.versie;
                // NOTE perform post to avoid query string
                return lastValueFrom(this.profielHttpService.read(model));
            };
            return this.store.getOrSetItem(key, httpCallback, {
                session: true
            });
        });
    }
    readNumber(key) {
        return this.read(key).pipe(map((value) => (value != null ? parseFloat(value) : null)));
    }
    readBoolean(key) {
        return this.read(key).pipe(map((value) => (value != null ? value.toLowerCase() == 'true' || value == '1' : null)));
    }
    /**
     * Flushes the security browser cache.
     */
    flush() {
        return from(this.store.clear());
    }
}
BarProfielService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarProfielService, deps: [{ token: BarCoreStateService }, { token: i1$3.BarCacheManager }, { token: BarProfielHttpService }], target: i0.ɵɵFactoryTarget.Injectable });
BarProfielService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarProfielService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarProfielService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: BarCoreStateService }, { type: i1$3.BarCacheManager }, { type: BarProfielHttpService }]; } });

/** Configuration service. */
class BarConfigurationService {
    constructor(state, cacheManager, profielHttpService) {
        this.state = state;
        this.cacheManager = cacheManager;
        this.profielHttpService = profielHttpService;
    }
    get store() {
        return this.cacheManager.getStore({
            storeType: BarCacheStoreType.User,
            store: 'configuration',
            userId: this.state.basiscontext.userId
        });
    }
    /** Reads the value with given options. */
    readValue(options) {
        if (!options)
            throw new Error('The options argument is required.');
        if (!options.pathAndKey)
            throw new Error('The pathAndKey property is required.');
        let key = options.pathAndKey;
        if (key && key.indexOf('/') > -1) {
            console.warn('BaaS configuration keys should contain backslashes (\\) instead of slashes (/). The key was automatically transformed.');
            // apparently replace func replaces only the first occurrence
            do
                key = key.replace('/', '\\');
            while (key.indexOf('/') > -1);
        }
        return defer(() => {
            const httpCallback = () => {
                const model = new BarProfielModel();
                model.key = key;
                model.appCode = options.appCode || this.state.toepassing.code;
                // NOTE that version is only used with BAR backend and not with BaaS backend
                model.appVersion = options.appVersion || this.state.toepassing.versie;
                // for now we just use the existing profiel http service
                return lastValueFrom(this.profielHttpService.read(model));
            };
            return this.store.getOrSetItem(key, httpCallback, {
                session: true
            });
        });
    }
    /**
     * Flushes the security browser cache.
     */
    flush() {
        return from(this.store.clear());
    }
}
BarConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarConfigurationService, deps: [{ token: BarCoreStateService }, { token: i1$3.BarCacheManager }, { token: BarProfielHttpService }], target: i0.ɵɵFactoryTarget.Injectable });
BarConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarConfigurationService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: BarCoreStateService }, { type: i1$3.BarCacheManager }, { type: BarProfielHttpService }]; } });

const STORAGE_KEY = BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX + 'requestLogOff';
// NOTE do not expose !!!
/** Internal log off (utility) service. */
class BarLogOffUtilityService {
    constructor(coreOptions, state, profiel, configuration, security, globalStore, logOffHooks) {
        this.coreOptions = coreOptions;
        this.state = state;
        this.profiel = profiel;
        this.configuration = configuration;
        this.security = security;
        this.globalStore = globalStore;
        this.logOffHooks = logOffHooks;
    }
    /** Start to listen for log off request. */
    startListening() {
        window.onstorage = () => {
            if (this.requestLogOff)
                this.navigateLogOff();
        };
    }
    get requestLogOff() {
        return localStorage.getItem(STORAGE_KEY) === 'true';
    }
    set requestLogOff(value) {
        if (value == null)
            localStorage.removeItem(STORAGE_KEY);
        else
            localStorage.setItem(STORAGE_KEY, value.toString());
    }
    invokePreLogOffHooks() {
        if (!this.logOffHooks || this.logOffHooks.length == 0)
            return of(undefined);
        const logOffObservables = this.logOffHooks.map((hook) => {
            const hookResult = hook.run();
            if (hookResult === undefined)
                return of(undefined);
            return hookResult.pipe(
            // make sure not to block log off
            catchError((err) => {
                console.error(err);
                return of(undefined);
            }));
        });
        return forkJoin(logOffObservables).pipe(map(() => undefined));
    }
    /** Performs some pre-log off logic. */
    cleanup() {
        var _a;
        this.globalStore.clear();
        if ((_a = this.state.basiscontext) === null || _a === void 0 ? void 0 : _a.userId) {
            this.profiel.flush().subscribe();
            this.configuration.flush().subscribe();
            this.security.flush().subscribe();
        }
        // NOTE make sure not to block the log off process
        return of(undefined);
    }
    navigateLogOff() {
        var _a;
        // redirect to log off page
        window.location.href = ((_a = this.coreOptions.auth) === null || _a === void 0 ? void 0 : _a.logOffUrl) || this.state.location.baasStatic.url + BAR_CORE_CONSTANTS.PAGES.LOG_OFF;
    }
}
BarLogOffUtilityService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarLogOffUtilityService, deps: [{ token: BarConnectedModuleOptions }, { token: BarCoreStateService }, { token: BarProfielService }, { token: BarConfigurationService }, { token: BarSecurityService }, { token: BAR_GLOBAL_CACHE }, { token: BAR_LOG_OFF, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
BarLogOffUtilityService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarLogOffUtilityService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarLogOffUtilityService, decorators: [{
            type: Injectable
        }], ctorParameters: function () {
        return [{ type: BarConnectedModuleOptions }, { type: BarCoreStateService }, { type: BarProfielService }, { type: BarConfigurationService }, { type: BarSecurityService }, { type: i1$3.BarCacheStore, decorators: [{
                        type: Inject,
                        args: [BAR_GLOBAL_CACHE]
                    }] }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [BAR_LOG_OFF]
                    }, {
                        type: Optional
                    }] }];
    } });

/** BAR authentication service contract. Implement this class to provide authentication. */
class BarAuthService {
    constructor(injector) {
        this.injector = injector;
    }
    get logOffService() {
        if (!this._logOffService)
            this._logOffService = this.injector.get(BarLogOffUtilityService);
        return this._logOffService;
    }
    /** Processing that occurs after the authentication. Meaning we are authenticated. */
    postProcessing() { }
    /** Performs the log off. */
    logOff() {
        // first do some cleanup (state)
        return this.logOffService.cleanup().pipe(
        // then invoke log off hooks by other applications
        mergeMap(() => this.logOffService.invokePreLogOffHooks()), tap(() => {
            // notify other tabs about fact that we are logging off
            this.logOffService.requestLogOff = true;
        }), 
        // do the log off (e.g. in idp this is a redirect)
        mergeMap(() => this.performLogOff()));
    }
}
BarAuthService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAuthService, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
BarAuthService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAuthService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAuthService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.Injector }]; } });

class BarAuthGuard {
    constructor(authService) {
        this.authService = authService;
    }
    canActivate(route, state) {
        return this.authService.authenticated ? of(true) : this.authService.authenticate();
    }
}
BarAuthGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAuthGuard, deps: [{ token: BarAuthService }], target: i0.ɵɵFactoryTarget.Injectable });
BarAuthGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAuthGuard });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAuthGuard, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: BarAuthService }]; } });

var BarMeldingType;
(function (BarMeldingType) {
    BarMeldingType["Opgelost"] = "OPGELOST";
    BarMeldingType["Informatief"] = "INFORMATIEF";
    BarMeldingType["Belangrijk"] = "BELANGRIJK";
    BarMeldingType["Onbeschikbaar"] = "ONBESCHIKBAAR";
    BarMeldingType["Banner"] = "BANNER";
})(BarMeldingType || (BarMeldingType = {}));

class BarMelding {
    convert(m) {
        const meldingTypeMapping = {
            20: BarMeldingType.Opgelost,
            40: BarMeldingType.Informatief,
            60: BarMeldingType.Belangrijk,
            80: BarMeldingType.Onbeschikbaar,
            90: BarMeldingType.Banner
        };
        const classicBannerProcessing = (m) => {
            // banner information is the same accross BAR en BaaS
            this.bannerTitle = m.bannerTitle;
            this.bannerUrl = m.bannerUrl;
            this.bannerUrlText = m.bannerUrlText;
            this.bannerImage = m.bannerImage;
        };
        if (m.baas === true) {
            //BaaS melding
            if (m.version === '2') {
                // V2
                const readField = (m, field) => { var _a, _b; return (_b = (_a = m.fields) === null || _a === void 0 ? void 0 : _a.find(f => f.name === field)) === null || _b === void 0 ? void 0 : _b.content; };
                Object.assign(this, {
                    id: m.meldingId,
                    startDate: m.validFrom,
                    endDate: m.validUntil,
                    meldingType: m.meldingType,
                    location: m.urlPattern,
                    content: readField(m, 'TEKST'),
                    title: readField(m, 'TITEL'),
                    zone: m.zone
                });
                if (this.meldingType === BarMeldingType.Banner) {
                    this.bannerTitle = readField(m, 'TITLE');
                    this.bannerUrl = readField(m, 'LINK_URL');
                    this.bannerUrlText = readField(m, 'LINK_CONTENT');
                    this.bannerImage = readField(m, 'IMAGE');
                }
            }
            else {
                Object.assign(this, {
                    id: m.meldingId,
                    startDate: m.validFrom,
                    endDate: m.validUntil,
                    meldingType: meldingTypeMapping[m._mtype],
                    location: m.urlPattern,
                    content: m.meldingText,
                    zone: m.zone
                });
                classicBannerProcessing(m);
            }
        }
        //BAR melding
        else {
            Object.assign(this, {
                id: m.id,
                startDate: m.startDatum,
                endDate: m.eindDatum,
                meldingType: meldingTypeMapping[m.meldingType],
                location: m.locatie,
                content: m.tekst,
                zone: m.zone
            });
            classicBannerProcessing(m);
        }
        return this;
    }
}

class BarMeldingHttpDefaultService {
    constructor(http, state) {
        this.http = http;
        this.state = state;
    }
    /**
     * Get meldingen for requested url
     */
    getMeldingen(url) {
        return this.http.post(this.state.location.barWeb.url + 'api/meldingen', { url }, { params: new BarHttpParams(true, false) }).pipe(map$1((meldingen) => meldingen.map((melding) => {
            return Object.assign(Object.assign({}, melding), { baas: false, version: '0' });
        })));
    }
    /**
     *Used by Melding Guard to check if a route has a blocking notification, if so it has to redirect to a specific page
     */
    hasBlockingMelding(url) {
        return this.http.post(this.state.location.barWeb.url + 'api/meldingen/get', { url }, { params: new BarHttpParams(true, false) });
    }
}
BarMeldingHttpDefaultService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeldingHttpDefaultService, deps: [{ token: i1$1.HttpClient }, { token: BarCoreStateService }], target: i0.ɵɵFactoryTarget.Injectable });
BarMeldingHttpDefaultService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeldingHttpDefaultService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeldingHttpDefaultService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: BarCoreStateService }]; } });

class BarMeldingHttpService {
}
BarMeldingHttpService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeldingHttpService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BarMeldingHttpService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeldingHttpService, providedIn: 'root', useClass: BarMeldingHttpDefaultService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeldingHttpService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root', useClass: BarMeldingHttpDefaultService }]
        }] });

class BarMeldingService {
    constructor(meldingHttpService) {
        this.meldingHttpService = meldingHttpService;
    }
    /**
     * Get meldingen for requested url
     */
    getMeldingen(url) {
        return this.meldingHttpService.getMeldingen(url);
    }
    /**
     *Used by Melding Guard to check if a route has a blocking notification, if so it has to redirect to a specific page
     */
    hasBlockingMelding(url) {
        return this.hasBlockingMelding(url);
    }
}
BarMeldingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeldingService, deps: [{ token: BarMeldingHttpService }], target: i0.ɵɵFactoryTarget.Injectable });
BarMeldingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeldingService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeldingService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: BarMeldingHttpService }]; } });

var _BarMeldingenEngine_instances, _BarMeldingenEngine_state, _BarMeldingenEngine_meldingService, _BarMeldingenEngine_handleOnbeschikbaar;
class BarMeldingenEngine {
    constructor() {
        _BarMeldingenEngine_instances.add(this);
        _BarMeldingenEngine_state.set(this, inject(BarCoreStateService));
        _BarMeldingenEngine_meldingService.set(this, inject(BarMeldingService));
    }
    /** Retrieves and processes the meldinen. Returns true in case the route is available (meaning no blocking meldingen). */
    retrieveAndProcess(routeUrl) {
        const pathnameEndsWithSlash = __classPrivateFieldGet(this, _BarMeldingenEngine_state, "f").location.spa.pathname.endsWith('/');
        const url = `${__classPrivateFieldGet(this, _BarMeldingenEngine_state, "f").location.spa.pathname}${pathnameEndsWithSlash ? routeUrl.substring(1) : routeUrl}`;
        return __classPrivateFieldGet(this, _BarMeldingenEngine_meldingService, "f").getMeldingen(url).pipe(catchError$1((err) => {
            console.error(err);
            return of([]);
        }), map$1((meldingen) => {
            let onbeschikbaarMelding = null;
            if (meldingen && meldingen.length) {
                // Parse DTO to our model
                const parsedMeldingen = meldingen.map((m) => new BarMelding().convert(m));
                // Find melding of type onbeschikbaar
                onbeschikbaarMelding = parsedMeldingen.find((m) => m.meldingType === BarMeldingType.Onbeschikbaar);
                // If melding of type onbeschikbaar has been found, redirect to onbeschikbaar page
                if (onbeschikbaarMelding) {
                    __classPrivateFieldGet(this, _BarMeldingenEngine_instances, "m", _BarMeldingenEngine_handleOnbeschikbaar).call(this, onbeschikbaarMelding);
                }
                else {
                    // Set meldingen on layout
                    __classPrivateFieldGet(this, _BarMeldingenEngine_state, "f").meldingen$.next(parsedMeldingen);
                }
            }
            else {
                __classPrivateFieldGet(this, _BarMeldingenEngine_state, "f").meldingen$.next([]);
            }
            return !onbeschikbaarMelding;
        }));
    }
}
_BarMeldingenEngine_state = new WeakMap(), _BarMeldingenEngine_meldingService = new WeakMap(), _BarMeldingenEngine_instances = new WeakSet(), _BarMeldingenEngine_handleOnbeschikbaar = function _BarMeldingenEngine_handleOnbeschikbaar(melding) {
    const meldingKey = `${BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX}melding_${melding.id}`;
    // store melding content in session storage
    window.sessionStorage.setItem(meldingKey, JSON.stringify(melding));
    // redirect to onbeschikbaar pagina which will ready the melding to show from the session storage (and clean it up)
    window.location.href = `${__classPrivateFieldGet(this, _BarMeldingenEngine_state, "f").location.baasStatic.url}${BAR_CORE_CONSTANTS.PAGES.ONBESCHIKBAAR}/${melding.id}`;
};
BarMeldingenEngine.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeldingenEngine, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BarMeldingenEngine.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeldingenEngine });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeldingenEngine, decorators: [{
            type: Injectable
        }] });

var __BarMeldingGuard_meldingEngine;
/** Internal guard for meldingen. */
class _BarMeldingGuard {
    constructor() {
        __BarMeldingGuard_meldingEngine.set(this, inject(BarMeldingenEngine));
    }
    canActivate(route, state) {
        return this._canActivate(route, state);
    }
    canActivateChild(childRoute, state) {
        return this._canActivate(childRoute, state);
    }
    _canActivate(route, state) {
        var _a;
        // if not leaf route ommit check
        if (!((_a = route.routeConfig) === null || _a === void 0 ? void 0 : _a.component))
            return of(true);
        return __classPrivateFieldGet(this, __BarMeldingGuard_meldingEngine, "f").retrieveAndProcess(state.url);
    }
}
__BarMeldingGuard_meldingEngine = new WeakMap();
_BarMeldingGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: _BarMeldingGuard, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
_BarMeldingGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: _BarMeldingGuard });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: _BarMeldingGuard, decorators: [{
            type: Injectable
        }] });
/** @deprecated Adding guards for meldingen is not needed anymore. */
class BarMeldingGuard {
    // NOTE use any because of typescript compiler incompatibility
    canActivate(route, state) {
        if (!BarMeldingGuard.warningGiven) {
            console.warn('The BarMeldingGuard is deprecated and can be removed safely.');
            BarMeldingGuard.warningGiven = true;
        }
        return of(true);
    }
}
BarMeldingGuard.warningGiven = false;
BarMeldingGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeldingGuard, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BarMeldingGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeldingGuard });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMeldingGuard, decorators: [{
            type: Injectable
        }] });

class BarZoneGuard {
    constructor(translate, core, state, localhost) {
        this.translate = translate;
        this.core = core;
        this.state = state;
        this.localhost = localhost;
    }
    canActivate(route) {
        // https://stackoverflow.com/questions/42719445/pass-parameter-into-route-guard
        const zones = route.data['zones'];
        let result = false;
        if (zones != null &&
            zones.length > 0 &&
            this.state.basiscontext != null &&
            this.state.basiscontext.zone != null &&
            this.state.basiscontext.zone.length > 0) {
            result = zones.indexOf(this.state.basiscontext.zone) > -1;
        }
        if (!result) {
            if (!this.localhost) {
                this.core.navigateHome();
            }
            else {
                const errorMessage = this.translate.instant('DOMAIN_BAR_CORE_CONNECTED.ZONES_NOT_ALLOWED', { zones: zones.join() });
                console.error(errorMessage);
                const error = new Error(errorMessage);
                this.core.errorOccurred.emit(error);
            }
        }
        return result;
    }
}
BarZoneGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarZoneGuard, deps: [{ token: i1$2.BarI18nService }, { token: BarCoreService }, { token: BarCoreStateService }, { token: BAR_LOCALHOST }], target: i0.ɵɵFactoryTarget.Injectable });
BarZoneGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarZoneGuard });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarZoneGuard, decorators: [{
            type: Injectable
        }], ctorParameters: function () {
        return [{ type: i1$2.BarI18nService }, { type: BarCoreService }, { type: BarCoreStateService }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [BAR_LOCALHOST]
                    }] }];
    } });

class BaasModuleOptions {
}

/**
 * Actie object to check. This is needed by the BarActieAllowedGuard.
 */
class BarActieFromContext {
    constructor(actie) {
        this.includeVoorwie = true;
        this.includeHoedanigheid = true;
        if (actie != null) {
            this.actie = actie.actie;
            this.includeVoorwie =
                actie.includeVoorwie === undefined
                    ? true
                    : actie.includeVoorwie;
            this.includeHoedanigheid =
                actie.includeHoedanigheid === undefined
                    ? true
                    : actie.includeHoedanigheid;
        }
    }
}

/** Represents a definition of an action without UI or styling. */
class BarActionDef {
}

/** Options for the cacheable decorator. */
class BarCacheableOptions {
    constructor() {
        /** Whether to use a promise instead of an Observable. The reason is that we cannot guess the return type by default without executing it. */
        this.promise = false;
    }
}

class BarLogInfo {
}

/** Will initialize everything regarding the BaaS BUI hub. */
class BaasHubInitializedHook {
    constructor(hubClient, coreState, moduleOptions) {
        this.hubClient = hubClient;
        this.coreState = coreState;
        this.moduleOptions = moduleOptions;
    }
    run() {
        var _a, _b, _c;
        if ((_a = this.moduleOptions.hub) === null || _a === void 0 ? void 0 : _a.enabled) {
            const hubUrl = concatUrl(this.coreState.location.baasWeb.url, '/baas/hubs/bui');
            this.hubClient.init({
                hubUrl,
                userId: (_b = this.coreState.basiscontext) === null || _b === void 0 ? void 0 : _b.userId,
                appCode: this.coreState.toepassing.code,
                securityTicketId: (_c = this.coreState.basiscontext) === null || _c === void 0 ? void 0 : _c.securityTicketId,
                logLevel: this.moduleOptions.hub.logLevel
            });
        }
    }
}
BaasHubInitializedHook.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasHubInitializedHook, deps: [{ token: i1$3.BarHubClient }, { token: BarCoreStateService }, { token: BaasModuleOptions }], target: i0.ɵɵFactoryTarget.Injectable });
BaasHubInitializedHook.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasHubInitializedHook });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasHubInitializedHook, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$3.BarHubClient }, { type: BarCoreStateService }, { type: BaasModuleOptions }]; } });

class BaasAuditHttpService {
    constructor(http, state) {
        this.http = http;
        this.state = state;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    save(auditItems) {
        return this.http.post(this.state.location.apiRoot.url + 'baas/audit/bui/messages', auditItems, {
            params: new BarHttpParams(true, false),
            responseType: 'text'
        });
    }
}
BaasAuditHttpService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasAuditHttpService, deps: [{ token: i1$1.HttpClient }, { token: BarCoreStateService }], target: i0.ɵɵFactoryTarget.Injectable });
BaasAuditHttpService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasAuditHttpService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasAuditHttpService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: BarCoreStateService }]; } });

// version of baas where this is available with the version parameter (endpoint logging)
const BAAS_VERSION_ENDPOINTS = '3.8.2.0';
class BaasCommonHttpService {
    constructor(http, state, coreOptions) {
        this.http = http;
        this.state = state;
        this.coreOptions = coreOptions;
    }
    get rootUrl() {
        if (this.coreOptions.rootUrl != null) {
            if (this.coreOptions.rootUrl.endsWith('/')) {
                return this.coreOptions.rootUrl;
            }
            return this.coreOptions.rootUrl + '/';
        }
        return '/';
    }
    preInitLocal() {
        return this.http.post(this.state.location.apiRoot.url + 'baas/bootloader/pre-init-local', null, {
            // ommit interceptor for performing the pre-init-local
            // this is invoked in the very beginning before pre-init
            params: new BarHttpParams(false, true),
            withCredentials: true
        });
    }
    preInit(request) {
        return this.http
            .post(this.state.location.apiRoot.url + 'baas/bootloader/pre-init', request, {
            // ommit interceptor for getting configuration
            // this is invoked before authentication
            params: new BarHttpParams(false, true),
            withCredentials: true
        })
            .pipe(tap((response) => {
            if (response === null || response === void 0 ? void 0 : response.toepassing)
                this.parseToepassing(response.toepassing);
        }));
    }
    init(request) {
        return this.http
            .post(this.state.location.apiRoot.url + 'baas/bootloader/init', request, {
            // treat as background request because audit needs the toepassing (kip of het ei syndrom)
            // this is running after authentication
            params: new BarHttpParams(true, false)
        })
            .pipe(tap((response) => {
            if (response && response.toepassing)
                this.parseToepassing(response.toepassing);
        }));
    }
    initLocal() {
        return this.http.post(this.state.location.apiRoot.url + 'baas/bootloader/init-local', {}, {
            // init local runs after init, meaning we are authenticated
            params: new BarHttpParams(true, false)
        });
    }
    saveEndpoints(appCode, appVersion, endpoints) {
        // @deprecated feature flagging not needed in long term
        const versionOk = this.state.baasVersion && versionCompare(this.state.baasVersion, BAAS_VERSION_ENDPOINTS) >= 0;
        if (!versionOk)
            console.warn(`Please upgrade Baas.NET to the latest stable version higher or equal to ${BAAS_VERSION_ENDPOINTS} for an optimal registration of route endpoints.`);
        const rootUrl = versionOk ? this.state.location.apiRoot.url : this.state.location.baasStatic.url;
        const url = `${rootUrl}baas/bootloader/endpoints/appcode/${appCode}/version/${appVersion}`;
        return this.http.post(url, endpoints).pipe(tap((result) => {
            if (!result.returnVal)
                console.error('An error occurred while saving the endpoints', result);
        }), catchError((err) => {
            // application should not crash because of this
            console.error('An error occurred while saving the endpoints', err);
            return of(undefined);
        }));
    }
    parseToepassing(toepassing) {
        if (typeof toepassing.securityLevel === 'string') {
            const securityLevelKey = 'securityLevel';
            toepassing[securityLevelKey] = this.parseSecLevelFromString(toepassing.securityLevel);
        }
    }
    parseSecLevelFromString(securityLevel) {
        if (securityLevel == null)
            return null;
        switch (securityLevel.toUpperCase()) {
            case 'DEV':
                return BarSecurityLevel.Development;
            case 'TST':
                return BarSecurityLevel.Test;
            case 'PRD':
                return BarSecurityLevel.Production;
            default:
                return BarSecurityLevel.Unknown;
        }
    }
}
BaasCommonHttpService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasCommonHttpService, deps: [{ token: i1$1.HttpClient }, { token: BarCoreStateService }, { token: BarConnectedModuleOptions }], target: i0.ɵɵFactoryTarget.Injectable });
BaasCommonHttpService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasCommonHttpService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasCommonHttpService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: BarCoreStateService }, { type: BarConnectedModuleOptions }]; } });

class BaasLoggingHttpService {
    constructor(http, state) {
        this.http = http;
        this.state = state;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    save(logs) {
        return this.http.post(this.state.location.apiRoot.url + 'baas/logging/bui/messages', logs, {
            params: new BarHttpParams(true, false),
            responseType: 'text'
        });
    }
}
BaasLoggingHttpService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasLoggingHttpService, deps: [{ token: i1$1.HttpClient }, { token: BarCoreStateService }], target: i0.ɵɵFactoryTarget.Injectable });
BaasLoggingHttpService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasLoggingHttpService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasLoggingHttpService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: BarCoreStateService }]; } });

class BaasMeetpuntHttpService {
    constructor() {
        this.warnedNotAvailable = false;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    save(meetpunten) {
        this.warnNotAvailable();
        return of(null);
    }
    warnNotAvailable() {
        if (!this.warnedNotAvailable) {
            this.warnedNotAvailable = true;
            console.warn('Meetpunten zijn (nog) niet beschikbaar binnen BaaS.Net...');
        }
    }
}
BaasMeetpuntHttpService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasMeetpuntHttpService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BaasMeetpuntHttpService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasMeetpuntHttpService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasMeetpuntHttpService, decorators: [{
            type: Injectable
        }] });

var _BaasMeldingHttpService_instances, _BaasMeldingHttpService_getMeldingenV2, _BaasMeldingHttpService_getMeldingenV1;
const BAAS_VERSION_MELDINGEN_V2 = '3.8.5.0';
class BaasMeldingHttpService {
    constructor(http, state) {
        this.http = http;
        this.state = state;
        _BaasMeldingHttpService_instances.add(this);
    }
    /**
     * Get meldingen for requested url
     */
    getMeldingen(url) {
        var _a, _b, _c;
        const apiVersion = (_c = (_b = (_a = this.state.config) === null || _a === void 0 ? void 0 : _a.baasStatic) === null || _b === void 0 ? void 0 : _b.meldingen) === null || _c === void 0 ? void 0 : _c.apiVersion;
        if (apiVersion === '2')
            return __classPrivateFieldGet(this, _BaasMeldingHttpService_instances, "m", _BaasMeldingHttpService_getMeldingenV2).call(this, url);
        return __classPrivateFieldGet(this, _BaasMeldingHttpService_instances, "m", _BaasMeldingHttpService_getMeldingenV1).call(this, url);
    }
    /**
     *Used by Melding Guard to check if a route has a blocking notification, if so it has to redirect to a specific page
     */
    hasBlockingMelding(urlPart) {
        const url = this.state.location.apiRoot.url + `baas/melding/important-only/for-url?urlPart=${encodeURI(urlPart)}`;
        return this.http.get(url);
    }
}
_BaasMeldingHttpService_instances = new WeakSet(), _BaasMeldingHttpService_getMeldingenV2 = function _BaasMeldingHttpService_getMeldingenV2(url) {
    // @deprecated feature flagging not needed in long term
    const versionOk = this.state.baasVersion && versionCompare(this.state.baasVersion, BAAS_VERSION_MELDINGEN_V2) >= 0;
    if (!versionOk)
        console.warn(`Please upgrade Baas.NET to the latest stable version higher or equal to ${BAAS_VERSION_MELDINGEN_V2} for an optimal use of meldingen api V2.`);
    const apiUrl = concatUrl(versionOk ? this.state.location.apiRoot.url : this.state.location.baasStatic.url, `/baas/meldingv2/for-url?pattern=${encodeURI(url)}`);
    return this.http.get(apiUrl).pipe(map$1((meldingen) => meldingen.map((melding) => {
        return Object.assign(Object.assign({}, melding), { baas: true, version: '2' });
    })));
}, _BaasMeldingHttpService_getMeldingenV1 = function _BaasMeldingHttpService_getMeldingenV1(url) {
    const myUrl = this.state.location.apiRoot.url + `baas/melding/all-types/for-url?urlPart=${encodeURI(url)}`;
    return this.http.get(myUrl).pipe(map$1((meldingen) => meldingen.map((melding) => {
        return Object.assign(Object.assign({}, melding), { baas: true, version: '1' });
    })));
};
BaasMeldingHttpService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasMeldingHttpService, deps: [{ token: i1$1.HttpClient }, { token: BarCoreStateService }], target: i0.ɵɵFactoryTarget.Injectable });
BaasMeldingHttpService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasMeldingHttpService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasMeldingHttpService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: BarCoreStateService }]; } });

class BaasProfielHttpService {
    constructor(http, state) {
        this.http = http;
        this.state = state;
    }
    // de BaaS api werkt met GET voor ophalen van values
    read(model) {
        const myUrl = this.state.location.apiRoot.url + `baas/configuration/value/appCode/${model.appCode}/path/${encodeURI(model.key)}`;
        return this.http.get(myUrl, { responseType: 'text' });
    }
}
BaasProfielHttpService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasProfielHttpService, deps: [{ token: i1$1.HttpClient }, { token: BarCoreStateService }], target: i0.ɵɵFactoryTarget.Injectable });
BaasProfielHttpService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasProfielHttpService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasProfielHttpService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: BarCoreStateService }]; } });

const BAAS_VERSION_USER_INFO = '1.7.6.0';
class BaasSecurityHttpService {
    constructor(http, state) {
        this.http = http;
        this.state = state;
    }
    checkActieAllowed(actie) {
        // indien checkActieAllowed vanuit checkActieAllowedFromContext wordt aangeroepen
        // zal voorwie / voorwierolcode en hoedanigheid / hoedanigheidrolcode ingevuld zijn
        // /baas/security/isactieallowed/actie/{actie}
        // /baas/security/isactieallowed/actie/{actie}/voorwie/{voorwie}/rolcode/{rolcode}
        // /baas/security/isactieallowed/actie/{actie}/hoedanigheid/{hoedanigheid}/rolcode/{rolcode}
        // /baas/security/isactieallowed/actie/{actie}/voorwie/{vw}/rolcode/{vwrc}/hoedanigheid/{hoed}/rolcode/{hdrc}
        let voorwieSegment = '';
        if (actie.voorwie && actie.voorwieRolcode)
            voorwieSegment = '/voorwie/' + actie.voorwie + '/rolcode/' + actie.voorwieRolcode;
        let hoedanigheidSegment = '';
        if (actie.hoedanigheid && actie.hoedanigheidRolcode)
            hoedanigheidSegment = '/hoedanigheid/' + actie.hoedanigheid + '/rolcode/' + actie.hoedanigheidRolcode;
        return this.http.get(this.state.location.apiRoot.url + 'baas/security/isactieallowed/actie/' + encodeURI(actie.actie) + voorwieSegment + hoedanigheidSegment);
    }
    /** @deprecated */
    getHoedanigheidInfoSet() {
        return this.http.get(this.state.location.apiRoot.url + 'baas/security/ticket-info').pipe(catchError((err) => {
            console.error(err);
            return of([]);
        }));
    }
    getUserInfo() {
        // @deprecated feature flagging not needed in long term
        const versionOk = this.state.baasVersion && versionCompare(this.state.baasVersion, BAAS_VERSION_USER_INFO) >= 0;
        if (!versionOk)
            console.warn(`Please upgrade Baas.NET to the latest stable version higher or equal to ${BAAS_VERSION_USER_INFO} for an optimal retrieval of user info.`);
        if (!versionOk && this.state.connectivity === BarConnectivity.Offline) {
            // old mechanisme in case offline modus (only hoedanigheid info set is filled in)
            return this.getHoedanigheidInfoSet().pipe(map((data) => ({
                hoedanigheidInfoSet: data
            })));
        }
        else {
            // in case baas version is too low we ask information to baas static (we cannot call baas static in offline modus)
            const rootUrl = versionOk ? this.state.location.apiRoot.url : this.state.location.baasStatic.url;
            return this.http.get(rootUrl + 'baas/security/user-info').pipe(map((data) => ({
                cbiUserId: data.cbiUserId,
                hoedanigheidInfoSet: data.hoedList,
                contactInfo: data.contactInfo != null
                    ? {
                        klantnummer: data.contactInfo.alvNr,
                        firstname: data.contactInfo.firstName,
                        lastname: data.contactInfo.lastname,
                        fullName: data.contactInfo.fullname,
                        phone: data.contactInfo.phoneNumber,
                        mobile: data.contactInfo.mobileNumber,
                        email: data.contactInfo.mailAddress
                    }
                    : undefined
            })), catchError((err) => {
                console.error(err);
                return of({});
            }));
        }
    }
}
BaasSecurityHttpService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasSecurityHttpService, deps: [{ token: i1$1.HttpClient }, { token: BarCoreStateService }], target: i0.ɵɵFactoryTarget.Injectable });
BaasSecurityHttpService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasSecurityHttpService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasSecurityHttpService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: BarCoreStateService }]; } });

class BarAuditHttpDefaultService {
    constructor(http, state) {
        this.http = http;
        this.state = state;
    }
    save(auditItems) {
        return this.http.post(this.state.location.barWeb.url + 'api/audit', auditItems, { params: new BarHttpParams(true, false) });
    }
}
BarAuditHttpDefaultService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAuditHttpDefaultService, deps: [{ token: i1$1.HttpClient }, { token: BarCoreStateService }], target: i0.ɵɵFactoryTarget.Injectable });
BarAuditHttpDefaultService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAuditHttpDefaultService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAuditHttpDefaultService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: BarCoreStateService }]; } });

class BarAuditHttpService {
}
BarAuditHttpService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAuditHttpService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BarAuditHttpService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAuditHttpService, providedIn: 'root', useClass: BarAuditHttpDefaultService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAuditHttpService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root', useClass: BarAuditHttpDefaultService }]
        }] });

class BarCommonHttpDefaultService {
    constructor(http, state) {
        this.http = http;
        this.state = state;
    }
    preInitLocal() {
        return this.http.post(this.state.location.apiRoot.url + 'api/pre-init-local', null, {
            // ommit interceptor for performing the pre-init-local
            params: new BarHttpParams(false, true),
            withCredentials: true
        });
    }
    preInit(request) {
        return this.http
            .post(this.state.location.baasStatic.url + 'baas/bootloader/pre-init', request, {
            // ommit interceptor for getting configuration
            // this is invoked before authentication
            params: new BarHttpParams(false, true),
            withCredentials: true
        })
            .pipe(tap$1((response) => {
            if (response === null || response === void 0 ? void 0 : response.toepassing)
                this.parseToepassing(response.toepassing);
        }));
    }
    init(request) {
        return this.http
            .post(this.state.location.baasStatic.url + 'baas/bootloader/init', request, {
            // treat as background request because audit needs the toepassing (kip of het ei syndrom)
            // this is running after authentication
            params: new BarHttpParams(true, false)
        })
            .pipe(tap$1((response) => {
            if (response && response.toepassing)
                this.parseToepassing(response.toepassing);
        }));
    }
    initLocal() {
        return this.http.post(this.state.location.apiRoot.url + 'api/init-local', {}, {
            params: new BarHttpParams(false, true),
            withCredentials: true,
            headers: new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' })
        });
    }
    saveEndpoints(appCode, appVersion, endpoints) {
        // NOTE just invoke baas static instead of BAR web
        const url = `${this.state.location.baasStatic.url}baas/bootloader/endpoints/appcode/${appCode}/version/${appVersion}`;
        return this.http.post(url, endpoints).pipe(tap$1((result) => {
            if (!result.returnVal)
                console.error('An error occurred while saving the endpoints', result);
        }), catchError$1((err) => {
            // application should not crash because of this
            console.error('An error occurred while saving the endpoints', err);
            return of(undefined);
        }));
    }
    parseToepassing(toepassing) {
        if (typeof toepassing.securityLevel === 'string') {
            const securityLevelKey = 'securityLevel';
            toepassing[securityLevelKey] = this.parseSecLevelFromString(toepassing.securityLevel);
        }
    }
    parseSecLevelFromString(securityLevel) {
        if (securityLevel == null)
            return null;
        switch (securityLevel.toUpperCase()) {
            case 'DEV':
                return BarSecurityLevel.Development;
            case 'TST':
                return BarSecurityLevel.Test;
            case 'PRD':
                return BarSecurityLevel.Production;
            default:
                return BarSecurityLevel.Unknown;
        }
    }
}
BarCommonHttpDefaultService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCommonHttpDefaultService, deps: [{ token: i1$1.HttpClient }, { token: BarCoreStateService }], target: i0.ɵɵFactoryTarget.Injectable });
BarCommonHttpDefaultService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCommonHttpDefaultService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCommonHttpDefaultService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: BarCoreStateService }]; } });

class BarCommonHttpService {
}
BarCommonHttpService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCommonHttpService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BarCommonHttpService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCommonHttpService, providedIn: 'root', useClass: BarCommonHttpDefaultService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCommonHttpService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root', useClass: BarCommonHttpDefaultService }]
        }] });

class BaasCoreModule {
    constructor(injector, translate) {
        this.translate = translate;
        BaasCoreModule.injector = injector;
        this.translate.addTranslations('DOMAIN_BAR_CORE', translations$1);
    }
    static forRoot(options = {}) {
        return {
            ngModule: BaasCoreModule,
            providers: [
                {
                    provide: BaasModuleOptions,
                    useValue: options
                },
                {
                    provide: BarAuditHttpService,
                    useClass: BaasAuditHttpService
                },
                {
                    provide: BarCommonHttpService,
                    useClass: BaasCommonHttpService
                },
                {
                    provide: BarLoggingHttpService,
                    useClass: BaasLoggingHttpService
                },
                {
                    provide: BarMeetpuntHttpService,
                    useClass: BaasMeetpuntHttpService
                },
                {
                    provide: BarMeldingHttpService,
                    useClass: BaasMeldingHttpService
                },
                {
                    provide: BarProfielHttpService,
                    useClass: BaasProfielHttpService
                },
                {
                    provide: BarSecurityHttpService,
                    useClass: BaasSecurityHttpService
                },
                {
                    provide: BAR_INITIALIZED,
                    useClass: BaasHubInitializedHook,
                    multi: true
                }
            ]
        };
    }
}
BaasCoreModule.injector = null;
BaasCoreModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasCoreModule, deps: [{ token: i0.Injector }, { token: i1$2.BarI18nService }], target: i0.ɵɵFactoryTarget.NgModule });
BaasCoreModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: BaasCoreModule });
BaasCoreModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasCoreModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasCoreModule, decorators: [{
            type: NgModule
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i1$2.BarI18nService }]; } });

class BarGvkStateBridge {
    constructor(coreState) {
        this.coreState = coreState;
        // In Angular applications calls to remote api are enabled because we have XDC
        this.remoteLocalhostApiEnabled = true;
    }
    get userId() {
        return this.coreState.basiscontext ? this.coreState.basiscontext.userId : null;
    }
    get appCode() {
        return this.coreState.toepassing ? this.coreState.toepassing.code : null;
    }
    get apiRootUrl() {
        return this.coreState.location && this.coreState.location.barWeb ? this.coreState.location.barWeb.url : null;
    }
}
BarGvkStateBridge.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarGvkStateBridge, deps: [{ token: BarCoreStateService }], target: i0.ɵɵFactoryTarget.Injectable });
BarGvkStateBridge.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarGvkStateBridge, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarGvkStateBridge, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: BarCoreStateService }]; } });

var _BarPageNotFoundGuard_oopsDomService;
class BarPageNotFoundGuard {
    constructor() {
        _BarPageNotFoundGuard_oopsDomService.set(this, inject(_OopsDomService));
    }
    canActivate(route) {
        if (__classPrivateFieldGet(this, _BarPageNotFoundGuard_oopsDomService, "f").checkOopsSupported()) {
            __classPrivateFieldGet(this, _BarPageNotFoundGuard_oopsDomService, "f").showOops({ type: _OopsType.NotFound });
        }
        return true;
    }
}
_BarPageNotFoundGuard_oopsDomService = new WeakMap();
BarPageNotFoundGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarPageNotFoundGuard, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BarPageNotFoundGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarPageNotFoundGuard });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarPageNotFoundGuard, decorators: [{
            type: Injectable
        }] });

var __BaasStaticConfigurationApiClient_instances, __BaasStaticConfigurationApiClient_httpClient, __BaasStaticConfigurationApiClient_coreState, __BaasStaticConfigurationApiClient_logging, __BaasStaticConfigurationApiClient_cacheManager, __BaasStaticConfigurationApiClient_invalidateConfiguration;
const CACHE_STORE = 'baas-static';
const CONFIGURATION_KEY = 'configuration';
/** Internal service to access the BaaS Static configuration api. */
class _BaasStaticConfigurationApiClient {
    constructor() {
        __BaasStaticConfigurationApiClient_instances.add(this);
        __BaasStaticConfigurationApiClient_httpClient.set(this, inject(HttpClient));
        __BaasStaticConfigurationApiClient_coreState.set(this, inject(BarCoreStateService));
        __BaasStaticConfigurationApiClient_logging.set(this, inject(BarLoggingService));
        __BaasStaticConfigurationApiClient_cacheManager.set(this, inject(BarCacheManager));
    }
    /* Gets the BaaS static configuration */
    getConfiguration() {
        const url = `${__classPrivateFieldGet(this, __BaasStaticConfigurationApiClient_coreState, "f").location.baasStatic.url}api/configuration`;
        return __classPrivateFieldGet(this, __BaasStaticConfigurationApiClient_httpClient, "f").get(url).pipe(
        // NOTE do not crash the application in case something happens here
        catchError((err) => {
            console.error(err);
            __classPrivateFieldGet(this, __BaasStaticConfigurationApiClient_logging, "f").error(err);
            return of(undefined);
        }));
    }
    /** Enables or disables the chatbot. */
    enableChatbot(enabled) {
        const url = `${__classPrivateFieldGet(this, __BaasStaticConfigurationApiClient_coreState, "f").location.baasStatic.url}api/configuration/chat-bot/enabled`;
        return __classPrivateFieldGet(this, __BaasStaticConfigurationApiClient_httpClient, "f").put(url, enabled).pipe(mergeMap(() => {
            var _a;
            if ((_a = __classPrivateFieldGet(this, __BaasStaticConfigurationApiClient_coreState, "f").config) === null || _a === void 0 ? void 0 : _a.baasStatic) {
                // change in memory value
                __classPrivateFieldGet(this, __BaasStaticConfigurationApiClient_coreState, "f").config.baasStatic.chatbot.enabled = enabled;
                // remove the configuration from the cache store
                return __classPrivateFieldGet(this, __BaasStaticConfigurationApiClient_instances, "m", __BaasStaticConfigurationApiClient_invalidateConfiguration).call(this);
            }
            return of(undefined);
        }));
    }
    /** Checks whether the chatbot is enabled. */
    checkChatbotEnabled() {
        var _a, _b, _c;
        return of((_c = (_b = (_a = __classPrivateFieldGet(this, __BaasStaticConfigurationApiClient_coreState, "f").config) === null || _a === void 0 ? void 0 : _a.baasStatic) === null || _b === void 0 ? void 0 : _b.chatbot) === null || _c === void 0 ? void 0 : _c.enabled);
    }
}
__BaasStaticConfigurationApiClient_httpClient = new WeakMap(), __BaasStaticConfigurationApiClient_coreState = new WeakMap(), __BaasStaticConfigurationApiClient_logging = new WeakMap(), __BaasStaticConfigurationApiClient_cacheManager = new WeakMap(), __BaasStaticConfigurationApiClient_instances = new WeakSet(), __BaasStaticConfigurationApiClient_invalidateConfiguration = function __BaasStaticConfigurationApiClient_invalidateConfiguration() {
    const cacheStore = __classPrivateFieldGet(this, __BaasStaticConfigurationApiClient_cacheManager, "f").getStore({ storeType: BarCacheStoreType.Global, store: CACHE_STORE });
    // remove the configuration from the cache store
    return from(cacheStore.removeItem(CONFIGURATION_KEY));
};
_BaasStaticConfigurationApiClient.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: _BaasStaticConfigurationApiClient, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
_BaasStaticConfigurationApiClient.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: _BaasStaticConfigurationApiClient, providedIn: 'root' });
__decorate([
    BarCacheable({
        key: CONFIGURATION_KEY,
        store: {
            store: CACHE_STORE,
            storeType: BarCacheStoreType.Global
        }
    })
], _BaasStaticConfigurationApiClient.prototype, "getConfiguration", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: _BaasStaticConfigurationApiClient, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], propDecorators: { getConfiguration: [] } });

// internal key in app store
const KEY_ENDPOINTS = '_endpoints';
/** Internal class logging all routes of the app. */
class _BarRouteLogger {
    constructor() {
        this.router = inject(Router);
        this.api = inject(BarCommonHttpService);
        this.state = inject(BarCoreStateService);
        this.appStore = inject(BarCacheStore);
        this.localhost = inject(BAR_LOCALHOST);
        // TODO use takeUntil from angular 16+ in the future
        this.destroyed$ = new Subject();
        this.loggedEndpoints$$ = new BehaviorSubject(undefined);
    }
    ngOnDestroy() {
        this.destroyed$.next(undefined);
        this.destroyed$.complete();
        this.loggedEndpoints$$.complete();
    }
    init() {
        var _a, _b;
        // behavior must be turned on and not in localhost modus
        const enabled = ((_b = (_a = this.state.config.baasStatic) === null || _a === void 0 ? void 0 : _a.general) === null || _b === void 0 ? void 0 : _b.endpointLoggingEnabled) && !this.localhost;
        if (!enabled)
            return;
        this.router.events
            .pipe(filter((val) => val instanceof NavigationEnd), switchMap(() => {
            // Check if data is available in the BehaviorSubject, otherwise, fetch from appStore
            // NOTE this is to avoid having to access indexed db too much
            if (this.loggedEndpoints$$.getValue() === undefined) {
                // also get the already logged endpoints from the storage
                return from(this.appStore.getItem(KEY_ENDPOINTS)).pipe(tap$1((endpoints) => {
                    // Cache the fetched endpoints in the BehaviorSubject
                    this.loggedEndpoints$$.next(endpoints);
                }));
            }
            else {
                return this.loggedEndpoints$$.asObservable(); // Use cached data
            }
        }), map$1((loggedEndpoints) => {
            if (!loggedEndpoints)
                loggedEndpoints = [];
            const endpointsToLog = [];
            this.collect(this.router.config, endpointsToLog, loggedEndpoints);
            return { endpoints: endpointsToLog, loggedEndpoints };
        }), filter((result) => result.endpoints.length > 0), mergeMap$1((result) => {
            const remember$ = from(this.appStore.setItem(KEY_ENDPOINTS, result.loggedEndpoints.concat(result.endpoints)));
            return forkJoin([this.api.saveEndpoints(this.state.toepassing.code, this.state.toepassing.versie, result.endpoints), remember$]);
        }), takeUntil(this.destroyed$))
            .subscribe();
    }
    collect(routes, endpointsToLog, loggedEndpoints, parentPath = undefined) {
        routes
            // don't collect framework routes
            .filter((route) => { var _a; return !((_a = route.data) === null || _a === void 0 ? void 0 : _a._framework); })
            .forEach((route) => {
            var _a;
            const fullPath = parentPath ? parentPath + '/' + route.path : route.path;
            if (route.loadChildren) {
                // check that lazy loaded module has already been loaded
                if (route._loadedRoutes) {
                    // lazy loaded module, traverse the children
                    this.collect(route._loadedRoutes, endpointsToLog, loggedEndpoints, fullPath);
                }
            }
            else {
                if (((_a = route.children) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    // this is a parent route, so traverse the children
                    this.collect(route.children, endpointsToLog, loggedEndpoints, fullPath);
                }
                // define whether it is an end route
                const endRoute = route.component || route.loadComponent || route.redirectTo;
                // real route should have a component (but can still be a parent route)
                if (!route._baasHandled && endRoute) {
                    const path = `${this.state.location.application.pathname}${fullPath}`;
                    // chech that it has not been logged yet
                    if (loggedEndpoints.indexOf(path) == -1) {
                        // regular route, just log in case not handled yet
                        endpointsToLog.push(path);
                    }
                    // mark as handled in case leaf route
                    // note that a parent route could always have lazy loaded modules which have not been loaded yet
                    route._baasHandled = true;
                }
            }
        });
    }
}
_BarRouteLogger.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: _BarRouteLogger, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
_BarRouteLogger.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: _BarRouteLogger });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: _BarRouteLogger, decorators: [{
            type: Injectable
        }] });

// NOTE here we load some BaaS static specific data after BAR/BaaS is initialized
class BaasStaticInitializedHook {
    constructor() {
        this.order = 0;
        /** Invoked before init. */
        this._pre = true;
        this._framework = true;
        this.moduleOptions = inject(BarConnectedModuleOptions);
        this.coreState = inject(BarCoreStateService);
        this.apiService = inject(_BaasStaticConfigurationApiClient);
        this.routeLogger = inject(_BarRouteLogger);
        this.localhost = inject(BAR_LOCALHOST);
    }
    run() {
        if (this.coreState.connectivity === BarConnectivity.Online) {
            return this.apiService.getConfiguration().pipe(tap((config) => this.handleConfig(config)), 
            // NOTE after configuration we init the route logging which depends on BaaS Static configuration
            tap(() => this.routeLogger.init()), map(() => undefined));
        }
    }
    handleConfig(config) {
        var _a, _b;
        (_a = config === null || config === void 0 ? void 0 : config.appMenuItems) === null || _a === void 0 ? void 0 : _a.forEach((ami) => {
            ami.url = this.processAppMenuUrl(ami.url);
            if (this.localhost) {
                ami.urlLocalhost = this.processAppMenuUrl(ami.urlLocalhost);
            }
        });
        const configKey = 'config';
        // assign it to sub property
        this.coreState[configKey].baasStatic = config;
        // override config in case public
        if (this.moduleOptions.public === true && ((_b = config.public) === null || _b === void 0 ? void 0 : _b.homeUrl)) {
            this.coreState.config.homeUrl = config.public.homeUrl;
        }
    }
    processAppMenuUrl(url) {
        if (!url || checkUrlAbsolute(url))
            return url;
        return `${this.coreState.location.release.origin}${url}`;
    }
}
BaasStaticInitializedHook.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasStaticInitializedHook, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BaasStaticInitializedHook.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasStaticInitializedHook });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasStaticInitializedHook, decorators: [{
            type: Injectable
        }] });

/** Lifecycle for initializing everything regarding push notifications. */
class BarNotificationInitializedHook {
    constructor(notificationManager, moduleOptions) {
        this.notificationManager = notificationManager;
        this.moduleOptions = moduleOptions;
    }
    run() {
        if (this.moduleOptions.notifications === true)
            this.notificationManager.init();
    }
}
BarNotificationInitializedHook.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarNotificationInitializedHook, deps: [{ token: i1$3.BarNotificationManager }, { token: BarConnectedModuleOptions }], target: i0.ɵɵFactoryTarget.Injectable });
BarNotificationInitializedHook.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarNotificationInitializedHook });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarNotificationInitializedHook, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$3.BarNotificationManager }, { type: BarConnectedModuleOptions }]; } });

const STORAGE_KEY_USER_INFO_PREFIX = BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX + 'userInfo_';
/** Handles the user data (security ticket, contact...) processing.  */
class BarUserDataHook {
    constructor(securityHttpService, state, auth) {
        this.securityHttpService = securityHttpService;
        this.state = state;
        this.auth = auth;
        this.order = 1;
        this._framework = true;
    }
    run() {
        var _a;
        // don't do anything if not authenticated
        if (!this.auth.authenticated) {
            const hoedanigheidInfoSetKey = 'hoedanigheidInfoSet';
            this.state[hoedanigheidInfoSetKey] = [];
            const userDataKey = 'userInfo';
            this.state[userDataKey] = {
                hoedanigheidInfoSet: []
            };
            return of(undefined);
        }
        const cacheKey = STORAGE_KEY_USER_INFO_PREFIX + (((_a = this.state.basiscontext) === null || _a === void 0 ? void 0 : _a.userId) || 'UNDEFINED');
        let cachedItem = window.sessionStorage.getItem(cacheKey);
        let userData$;
        if (cachedItem) {
            userData$ = of(JSON.parse(cachedItem));
        }
        else {
            userData$ = this.securityHttpService.getUserInfo().pipe(tap((data) => {
                cachedItem = JSON.stringify(data);
                window.sessionStorage.setItem(cacheKey, cachedItem);
            }));
        }
        return userData$.pipe(tap((userData) => {
            const userInfoKey = 'userInfo';
            this.state[userInfoKey] = userData;
            const hoedanigheidInfoSetKey = 'hoedanigheidInfoSet';
            this.state[hoedanigheidInfoSetKey] = userData.hoedanigheidInfoSet || [];
        }), mergeMap(() => of(undefined)));
    }
}
BarUserDataHook.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarUserDataHook, deps: [{ token: BarSecurityHttpService }, { token: BarCoreStateService }, { token: BarAuthService }], target: i0.ɵɵFactoryTarget.Injectable });
BarUserDataHook.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarUserDataHook });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarUserDataHook, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: BarSecurityHttpService }, { type: BarCoreStateService }, { type: BarAuthService }]; } });

var BarAuditType;
(function (BarAuditType) {
    BarAuditType["Session"] = "BROWSERSESSIONSTART";
    BarAuditType["Page"] = "BROWSERPAGE";
    BarAuditType["Route"] = "BROWSERROUTE";
    BarAuditType["Dependencies"] = "BROWSERDEPENDENCIES";
})(BarAuditType || (BarAuditType = {}));

/** Internal enum representing the RAP segment in the URL. */
var _BarRapSegment;
(function (_BarRapSegment) {
    _BarRapSegment["Applicative"] = "a";
    _BarRapSegment["ReverseProxy"] = "r";
    _BarRapSegment["Public"] = "p";
})(_BarRapSegment || (_BarRapSegment = {}));
/** Internal url to assist with RAP related stuff. */
class _BarRapUrlHelper {
    constructor(config) {
        this.config = config;
    }
    get baasStaticSegment() {
        return BAR_CORE_CONSTANTS.URL_SEGMENT.BAAS_STATIC.replace('{segment}', this.rapSegment);
    }
    get baasWebSegment() {
        return BAR_CORE_CONSTANTS.URL_SEGMENT.BAAS_WEB.replace('{segment}', this.rapSegment);
    }
    get rapSegment() {
        return this.config.public ? _BarRapSegment.Public : _BarRapSegment.Applicative;
    }
    parseUrl(url) {
        if (this.config.public && url.toLowerCase().indexOf(`/${_BarRapSegment.Applicative}/`) > -1) {
            // Q&D for now we just do a replace (short term)
            return url.toLowerCase().replace(`/${_BarRapSegment.Applicative}/`, `/${_BarRapSegment.Public}/`);
        }
        return url;
    }
}
_BarRapUrlHelper.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: _BarRapUrlHelper, deps: [{ token: BarConnectedModuleOptions }], target: i0.ɵɵFactoryTarget.Injectable });
_BarRapUrlHelper.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: _BarRapUrlHelper });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: _BarRapUrlHelper, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: BarConnectedModuleOptions }]; } });

/**
 * Provides cross domain cookie functionality.
 * creëert een iframe (indien toegestaan)
 * voorziet een sendMessage functie voor het versturen van strings naar de iframebron
 * luistert op het message event
 */
class BarXdcService {
    constructor(translate, logging, config, appInfo, state, rapUrlHelper, localhost) {
        this.translate = translate;
        this.logging = logging;
        this.config = config;
        this.appInfo = appInfo;
        this.state = state;
        this.rapUrlHelper = rapUrlHelper;
        this.localhost = localhost;
        // holds all resolve and rejects for the synchronization with a guid as a key
        this.syncDefers = {};
        // defines whether sync has been disabled at runtime because of broken XDC, we need to do this to avoid syncen causing endless error loops
        this.syncDisabled = false;
        // avoid cyclic dependency with event emitter -> when app info is saved we perform a sync
        this.appInfo.onSyncRequired.subscribe((arg) => {
            this.sync(arg.context)
                .then(() => {
                arg.resolve();
            })
                .catch(() => {
                arg.reject();
            });
        });
    }
    get enabled() {
        var _a;
        // enabled in release build with localhost client if security level is not production (if state.toepassing is not set yet we assume XDC might be on -> chicken or egg problem: we don't have this toepassing information yet in the beginning)
        // or enabled in local build if we force it for testing purposes
        // only enabled if online (never in offline or disconnected modus)
        return (this.localhost &&
            this.config.connectivity == BarConnectivity.Online &&
            (!this.config.local || ((_a = this.config.auth) === null || _a === void 0 ? void 0 : _a.forceRemote)) &&
            this.baasContextModus === BaasContextTransportModus.OnlineCookies &&
            (this.state.toepassing == null || this.state.toepassing.securityLevel != BarSecurityLevel.Production));
    }
    /** Will sync the local cookie with the server cookie */
    // the sync is a chat between the main thread and an iframe using asynchronous communication
    // the main goal is to sync the local cookie and the server cookie by using a timestamp
    sync(context) {
        if (this.enabled && !this.syncDisabled) {
            return new Promise((resolve, reject) => {
                const id = generateUuid();
                this.syncDefers[id] = { resolve, reject };
                // get the server cookie first
                this.sendMessage({ action: 'get', id: id, context: context });
            });
        }
        else {
            //disabled: auto resolve
            return Promise.resolve();
        }
    }
    /** Will clear the server cookies at the other end (iframe). */
    clear(context) {
        if (this.enabled && !this.syncDisabled) {
            return new Promise((resolve, reject) => {
                const id = generateUuid();
                this.syncDefers[id] = { resolve, reject };
                // get the server cookie first
                this.sendMessage({ action: 'clear', id: id, context: context });
            });
        }
        else {
            //disabled: auto resolve
            return Promise.resolve();
        }
    }
    handleMessage(e) {
        if (e == null || e.data == null || e.data.action == null)
            return;
        switch (e.data.action) {
            case 'ready': {
                // the iframe is ready
                // resolve the promise so that messages can be send
                this.resolveReady();
                break;
            }
            case 'get-response': {
                // if we don't have a local session we take over the remote session of the iframe
                if (this.appInfo.sessionId == null) {
                    this.appInfo.sessionId = e.data.sessionId;
                }
                // we have the server cookie
                const localCookie = this.appInfo.get();
                if (localCookie == null && e.data.cookie != null) {
                    // save without setting the timestamp + set guid cookie
                    this.appInfo.save(e.data.cookie, true, false, false);
                    this.resolveSync(e.data.id);
                }
                else if (e.data.cookie == null && localCookie != null) {
                    this.sendMessage({
                        action: 'set',
                        cookie: localCookie,
                        context: e.data.context,
                        id: e.data.id
                    });
                    // do not resolve yet
                }
                else if (e.data.cookie != null && localCookie != null) {
                    // convert timestamps to date time to be able to compare
                    const localTimestamp = localCookie.Timestamp == null ? null : new Date(localCookie.Timestamp);
                    const serverTimestamp = e.data.cookie.Timestamp == null ? null : new Date(e.data.cookie.Timestamp);
                    if (localTimestamp == null && serverTimestamp != null) {
                        // no timestamp locally -> take sever cookie as is and update main cookie
                        this.appInfo.save(e.data.cookie, true, false, false);
                        this.resolveSync(e.data.id);
                    }
                    else if (localTimestamp != null && serverTimestamp == null) {
                        // do an update on the local cookie
                        this.sendMessage({
                            action: 'update',
                            cookie: localCookie,
                            context: e.data.context,
                            id: e.data.id
                        });
                        // do not resolve yet
                    }
                    else if (localTimestamp != null && serverTimestamp != null) {
                        if (localTimestamp > serverTimestamp) {
                            // local cookie time is more recent -> update server cookie
                            this.sendMessage({
                                action: 'update',
                                cookie: localCookie,
                                context: e.data.context,
                                id: e.data.id
                            });
                            // do not resolve yet
                        }
                        else if (localTimestamp < serverTimestamp) {
                            // server cookie time is more recent -> update local cookie
                            this.appInfo.save(e.data.cookie, true, false, false);
                            this.resolveSync(e.data.id);
                        }
                        else {
                            // times are equal just resolve
                            this.resolveSync(e.data.id);
                        }
                    }
                    else {
                        // we cannot sync because times are null -> do nothing
                        this.resolveSync(e.data.id);
                    }
                }
                else {
                    // nothing to sync
                    this.resolveSync(e.data.id);
                }
                break;
            }
            case 'set-response':
            case 'update-response':
            case 'clear-response': {
                // end of response -> resolve the sync
                this.resolveSync(e.data.id);
                break;
            }
        }
    }
    ensureIFrame() {
        if (this.iframeEl != null)
            return;
        this.defineGlobal();
        // Create the iframe
        this.iframeEl = document.createElement('iframe');
        // if xdc is enabled in local solution this means we need to point to dev because of remote authentication
        const rootUrl = this.config.local ? `${this.state.location.release.origin}${this.rapUrlHelper.baasStaticSegment}` : this.state.location.baasStatic.url;
        this.iframeEl.setAttribute('src', rootUrl + 'xdc');
        this.iframeEl.style.display = 'none';
        document.body.appendChild(this.iframeEl);
        this.bindEvent(window, 'message', (e) => this.handleMessage(e));
        // create the promise to be used when sending a message
        this.iframeReady = new Promise((resolve, reject) => {
            // remember the resolve variable
            this.resolveReady = resolve;
        });
    }
    // addEventListener support for IE8
    bindEvent(element, eventName, eventHandler) {
        if (element.addEventListener) {
            element.addEventListener(eventName, eventHandler, false);
        }
        else if (element.attachEvent) {
            element.attachEvent('on' + eventName, eventHandler);
        }
    }
    // Send a message to the child iframe
    // Make sure you are sending a string, and to stringify JSON
    sendMessage(msg) {
        this.ensureIFrame();
        // when the iframe is ready we send the message
        // we are dynamically adding the iframe to the DOM, this means it is not immediately ready (unless F12 is open)
        this.iframeReady.then(() => {
            try {
                this.iframeEl.contentWindow.postMessage(msg, '*');
            }
            catch (error) {
                const xdcErrorMsg = this.translate.instant('DOMAIN_BAR_CORE_CONNECTED.XDC_ERROR');
                console.error(xdcErrorMsg);
                console.error(error);
                // keep the promise (avoid promise error cycle by not rejecting)
                this.resolveSync(msg.id);
                // disable xdc sync
                this.syncDisabled = true;
                console.warn(this.translate.instant('DOMAIN_BAR_CORE_CONNECTED.XDC_SYNC_DISABLED'));
                this.logging.error({
                    error: error,
                    message: xdcErrorMsg
                });
            }
        });
    }
    // define some global stuff
    defineGlobal() {
        // make sure the state is available globally for non Angular code
        const xdc = ensureGlobal('lvflanders.bar.ng.core.xdc');
        Object.defineProperty(xdc, 'loggingEnabled', {
            set: (value) => {
                this.sendMessage({
                    action: 'set-logging-enabled',
                    value: value
                });
            }
        });
    }
    resolveSync(id) {
        if (this.syncDefers[id] != null) {
            this.syncDefers[id].resolve();
            delete this.syncDefers[id];
        }
    }
    rejectSync(id) {
        if (this.syncDefers[id] != null) {
            this.syncDefers[id].reject();
            delete this.syncDefers[id];
        }
    }
    get baasContextModus() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.auth) === null || _b === void 0 ? void 0 : _b.contextTransportModus) !== null && _c !== void 0 ? _c : BaasContextTransportModus.OnlineCookies;
    }
}
BarXdcService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarXdcService, deps: [{ token: i1$2.BarI18nService }, { token: BarLoggingService }, { token: BarConnectedModuleOptions }, { token: BarAppInfoService }, { token: BarCoreStateService }, { token: _BarRapUrlHelper }, { token: BAR_LOCALHOST }], target: i0.ɵɵFactoryTarget.Injectable });
BarXdcService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarXdcService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarXdcService, decorators: [{
            type: Injectable
        }], ctorParameters: function () {
        return [{ type: i1$2.BarI18nService }, { type: BarLoggingService }, { type: BarConnectedModuleOptions }, { type: BarAppInfoService }, { type: BarCoreStateService }, { type: _BarRapUrlHelper }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [BAR_LOCALHOST]
                    }] }];
    } });

class BarCoreHttpInterceptor {
    constructor(injector, state, appInfo, xdc, moduleOptions, baasContextService, logging, localhost, oopsDomService) {
        this.injector = injector;
        this.state = state;
        this.appInfo = appInfo;
        this.xdc = xdc;
        this.moduleOptions = moduleOptions;
        this.baasContextService = baasContextService;
        this.logging = logging;
        this.localhost = localhost;
        this.oopsDomService = oopsDomService;
        this.defineGlobal();
    }
    get meetpunt() {
        return this.injector.get(BarMeetpuntService);
    }
    // defines if we handle the forbidden status (combined means we check different parts of the afschakelplan)
    get handleAuthFailedStatusCombined() {
        var _a;
        // we handle it if defined globally through configuration and if the user didn't turn it off (if we don't have the configuration yet we assume we want to handle: init call)
        return this.handleAuthFailedStatus && (!this.state.config || ((_a = this.state.config.interception) === null || _a === void 0 ? void 0 : _a.handleAuthFailed));
    }
    // gets if we handle the forbidden status based on a global linked to the local storage
    get handleAuthFailedStatus() {
        let result = true;
        const tmp = window.localStorage.getItem('lvflanders.bar.ng.core.interception.handleAuthFailed');
        if (tmp != null && tmp.length > 0) {
            result = JSON.parse(tmp);
        }
        return result;
    }
    // sets if we handle the forbidden status based on a global linked to the local storage
    set handleAuthFailedStatus(value) {
        window.localStorage.setItem('lvflanders.bar.ng.core.interception.handleAuthFailed', JSON.stringify(value));
    }
    // defines if we handle the forbidden status (combined means we check different parts of the afschakelplan)
    get handleForbiddenStatusCombined() {
        // we handle it if defined globally through configuration and if the user didn't turn it off
        return this.handleForbiddenStatus && this.state.config.interception != null && this.state.config.interception.handleForbidden;
    }
    // gets if we handle the forbidden status based on a global linked to the local storage
    get handleForbiddenStatus() {
        let result = true;
        const tmp = window.localStorage.getItem('lvflanders.bar.ng.core.interception.handleForbidden');
        if (tmp != null && tmp.length > 0) {
            result = JSON.parse(tmp);
        }
        return result;
    }
    // sets if we handle the forbidden status based on a global linked to the local storage
    set handleForbiddenStatus(value) {
        window.localStorage.setItem('lvflanders.bar.ng.core.interception.handleForbidden', JSON.stringify(value));
    }
    intercept(request, next) {
        const ommitInterceptor = request.params instanceof BarHttpParams && request.params.ommitInterceptor;
        if (ommitInterceptor) {
            return next.handle(request);
        }
        else {
            let stopwatch = null;
            // first we need to know if this is a background request, we don't want audit for audit (recursive)
            const backgroundRequest = request.params instanceof BarHttpParams && request.params.backgroundRequest;
            if (!backgroundRequest && this.meetpunt.loggingEnabled) {
                stopwatch = new BarStopwatch();
                stopwatch.start();
            }
            // determine whether this is a domain request
            const domainRequest = this.checkDomainRequest(request.url);
            const crossDomainRequest = this.checkCrossDomainRequest(request.url);
            let promise = null;
            // for domain requests (within same application) or cross domain request, we want to persist the basiscontext or at least sync the cookies if enabled
            if (domainRequest || crossDomainRequest) {
                if (this.state.basiscontext != null) {
                    // before we do the call we make sure the cookie is up to date for the request
                    promise = this.appInfo.persistBasiscontext({
                        caller: 'Interceptor',
                        url: request.url
                    });
                }
                else if (crossDomainRequest && this.xdc.enabled) {
                    promise = this.xdc.sync({
                        caller: 'Interceptor',
                        url: request.url
                    });
                }
                // clone request
                request = request.clone({
                    // needed for localhost cookie sharing
                    withCredentials: true,
                    headers: this.defineHeaders(request.headers, domainRequest, crossDomainRequest)
                });
            }
            if (promise != null) {
                // execute promise before proceeding
                // use merge map to be able
                return from(promise).pipe(mergeMap(() => {
                    return this.handleRequest(request, next, stopwatch, domainRequest, crossDomainRequest);
                }));
            }
            else {
                // no promise just proceed
                return this.handleRequest(request, next, stopwatch, domainRequest, crossDomainRequest);
            }
        }
    }
    handleRequest(request, next, stopwatch, domainRequest, crossDomainRequest) {
        return next.handle(request).pipe(catchError((error) => {
            // 455 custom code authentication engine or authentication handler (in localhost we also want redirect behavior)
            if (this.handleAuthFailedStatusCombined && !this.localhost && error.status == 455) {
                this.handleAuthFailed(error);
            }
            // 403 forbidden (e.g. actie allowed failed) handling, in localhost we don't want to get kicked out of application
            else if (this.handleForbiddenStatusCombined && !this.localhost && error.status == 403) {
                this.handleForbidden(error);
            }
            return throwError(() => error);
        }), 
        // tap to execute some non asynchronous code after the request
        tap((ev) => {
            if (ev instanceof HttpResponse) {
                if (domainRequest) {
                    // get the basiscontext based on cookie and update basiscontext in temp state and page state
                    // a request can lead to changed basiscontext
                    const basiscontext = this.appInfo.getBasiscontext();
                    const basiscontextKey = 'basiscontext';
                    this.state[basiscontextKey] = basiscontext;
                }
                if (stopwatch != null) {
                    // read audit id response headers
                    const auditId = ev.headers.get('X-Audit-Id');
                    stopwatch.stop();
                    this.meetpunt.log({
                        meetpunt: 'INTERCEPTOR',
                        meetpuntDetail: extractUrlParts(request.url).pathname,
                        waarde: stopwatch.duration,
                        meetpuntInfo: request.url,
                        auditId: auditId
                    });
                }
            }
        }), 
        // https://stackoverflow.com/a/52206312/2174621
        // here we execute another observable, but we don't alter the output which is needed by the return parameter of this function (delayWhen doesn't alter result)
        delayWhen((ev) => {
            // execute the sync promise in case it's a httpresponse (otherwise auto resolve)
            return from(ev instanceof HttpResponse && crossDomainRequest
                ? this.xdc.sync({
                    caller: 'Interceptor-End',
                    url: request.url
                })
                : Promise.resolve());
        }));
    }
    defineHeaders(headers, domainRequest, crossDomainRequest) {
        // needed for aspnet core knowing about ajax requests
        headers = headers.set('X-Requested-With', 'XMLHttpRequest');
        let requestToken = null;
        if (domainRequest && !crossDomainRequest && this.state.localRequestToken != null && this.xdc.enabled) {
            // local request cookie in case domain request && cross domain cookeis are enabled
            requestToken = this.state.localRequestToken;
        }
        else if (this.state.requestToken != null) {
            requestToken = this.state.requestToken;
        }
        if (requestToken != null) {
            // antiforgery header
            headers = headers.set('X-XSRF-TOKEN', requestToken);
        }
        let auditId = null;
        let auditType = null;
        if (this.state.routeId != null) {
            auditId = this.state.routeId;
            auditType = BarAuditType.Route;
        }
        else if (this.state.pageId != null) {
            auditId = this.state.pageId;
            auditType = BarAuditType.Page;
        }
        else if (this.state.sessionId != null) {
            auditId = this.state.sessionId;
            auditType = BarAuditType.Session;
        }
        if (auditId != null) {
            // set audit id so that audit system can chain everything together
            headers = headers.set('X-Audit-Id', auditId).set('X-Audit-Type', auditType);
        }
        //wimfra: adds baas header to request, when available in sessiondata.
        //this header will have preference to cookies, when being passed
        headers = this.addBaasHeaders(headers);
        return headers;
    }
    /**pass headers from session storage to call */
    addBaasHeaders(headers) {
        var _a, _b;
        if (this.baasContextModus !== BaasContextTransportModus.OnlineCookies &&
            this.baasContextService.checkBaasContextInStorage() &&
            !headers.has(BAR_CORE_CONSTANTS.HEADERS.BAAS_BACKEND_HEADER)) {
            // (old BAR apps only accept baas.context.backend headers)
            headers = headers.set(BAR_CORE_CONSTANTS.HEADERS.BAAS_BACKEND_HEADER, this.baasContextService.getBaasContextAsHeaderString());
        }
        if (!headers.has(BAR_CORE_CONSTANTS.HEADERS.BAAS_BROWSER_CALLSTACK)) {
            const callStack = [
                {
                    userId: (_a = this.state.basiscontext) === null || _a === void 0 ? void 0 : _a.userId,
                    appCode: (_b = this.state.toepassing) === null || _b === void 0 ? void 0 : _b.code
                }
            ];
            const headerValue = JSON.stringify(callStack);
            headers = headers.set(BAR_CORE_CONSTANTS.HEADERS.BAAS_BROWSER_CALLSTACK, headerValue);
        }
        return headers;
    }
    checkDomainRequest(url) {
        return !checkUrlAbsolute(url) || url.indexOf('localhost') > -1 || url.startsWith(document.location.origin) || this.checkCompatibleOrigin(url);
    }
    /* check if this is a cross domain request
        rules:
        - xdc must be enabled (localhost, not production...)
        - we must be doing a call to the release domain (which is not localhost)
    */
    checkCrossDomainRequest(url) {
        const result = false;
        if (this.localhost) {
            // get the parts of the url being invoked by http
            const invokedUrlParts = extractUrlParts(url);
            // do the check if this is really a cross domain check (http call to origin of cross domain && cross domain is not localhost)
            return invokedUrlParts.origin == this.state.location.release.origin && this.state.location.release.hostname != 'localhost';
        }
        return result;
    }
    checkCompatibleOrigin(url) {
        var _a, _b;
        if ((_b = (_a = this.moduleOptions) === null || _a === void 0 ? void 0 : _a.compatibleOrigins) === null || _b === void 0 ? void 0 : _b.length) {
            const origin = new URL(url).origin.toLowerCase();
            return this.moduleOptions.compatibleOrigins.some((compatibleOrigin) => {
                let value = compatibleOrigin.value.toLowerCase();
                if (value.endsWith('/'))
                    value = value.substring(0, value.length - 1);
                if (compatibleOrigin.strategy === 'exact' && origin === value) {
                    return true;
                }
                else if (compatibleOrigin.strategy === 'startsWith' && origin.startsWith(value)) {
                    return true;
                }
            });
        }
        return false;
    }
    handleAuthFailed(error) {
        this.performExtraLogging('Auth Failed (455)', error.url, 'Performing log off.');
        this.oopsDomService.showOops({ type: _OopsType.Authentication });
    }
    handleForbidden(error) {
        this.performExtraLogging('Forbidden (403)', error.url, 'Navigating to insufficient privileges page.');
        window.location.href = this.state.location.baasStatic.url + BAR_CORE_CONSTANTS.PAGES.INSUFFICIENT_PRIVILEGES;
    }
    get baasContextModus() {
        var _a, _b;
        return (_b = (_a = this.moduleOptions.auth) === null || _a === void 0 ? void 0 : _a.contextTransportModus) !== null && _b !== void 0 ? _b : BaasContextTransportModus.OnlineCookies;
    }
    /** Define global variables related to interception */
    defineGlobal() {
        // make sure the state is available globally for non Angular code
        const interception = ensureGlobal('lvflanders.bar.ng.core.interception');
        // here we define a global property to be used to turn on/off the fact that we handle auth failed responses
        Object.defineProperty(interception, 'handleAuthFailed', {
            set: (value) => {
                this.handleAuthFailedStatus = value;
            },
            get: () => {
                return this.handleAuthFailedStatus;
            }
        });
        // here we define a global property to be used to turn on/off the fact that we handle auth failed responses
        Object.defineProperty(interception, 'handleForbidden', {
            set: (value) => {
                this.handleForbiddenStatus = value;
            },
            get: () => {
                return this.handleForbiddenStatus;
            }
        });
    }
    performExtraLogging(action, url, comment) {
        var _a, _b;
        let message = `[BarCoreHttpInterceptor] ${action} - ${url}`;
        if (comment)
            message += ` - ${comment}`;
        if ((_a = this.state) === null || _a === void 0 ? void 0 : _a.basiscontext)
            message += ` - context: ${JSON.stringify((_b = this.state) === null || _b === void 0 ? void 0 : _b.basiscontext)}`;
        this.logging.warn({ message });
    }
}
BarCoreHttpInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCoreHttpInterceptor, deps: [{ token: i0.Injector }, { token: BarCoreStateService }, { token: BarAppInfoService }, { token: BarXdcService }, { token: BarConnectedModuleOptions }, { token: BaasContextService }, { token: BarLoggingService }, { token: BAR_LOCALHOST }, { token: _OopsDomService }], target: i0.ɵɵFactoryTarget.Injectable });
BarCoreHttpInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCoreHttpInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCoreHttpInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () {
        return [{ type: i0.Injector }, { type: BarCoreStateService }, { type: BarAppInfoService }, { type: BarXdcService }, { type: BarConnectedModuleOptions }, { type: BaasContextService }, { type: BarLoggingService }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [BAR_LOCALHOST]
                    }] }, { type: _OopsDomService }];
    } });

class BarPageNotFoundComponent {
}
BarPageNotFoundComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarPageNotFoundComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BarPageNotFoundComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BarPageNotFoundComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: "<div class=\"d-flex flex-row\">\r\n    <h1>\r\n        {{ 'DOMAIN_BAR_CORE_CONNECTED.PAGE_NOT_FOUND' | translate }}\r\n    </h1>\r\n    <mat-icon aria-hidden=\"false\" class=\"fa fa-ban page-not-found-icon ml-2\" [attr.aria-label]=\"'DOMAIN_BAR_CORE_CONNECTED.PAGE_NOT_FOUND' | translate\">\r\n    </mat-icon>\r\n</div>\r\n", dependencies: [{ kind: "ngmodule", type: MatIconModule }, { kind: "component", type: i1$4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "ngmodule", type: BarI18nModule }, { kind: "pipe", type: i1$2.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarPageNotFoundComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, imports: [MatIconModule, BarI18nModule, NgIf], template: "<div class=\"d-flex flex-row\">\r\n    <h1>\r\n        {{ 'DOMAIN_BAR_CORE_CONNECTED.PAGE_NOT_FOUND' | translate }}\r\n    </h1>\r\n    <mat-icon aria-hidden=\"false\" class=\"fa fa-ban page-not-found-icon ml-2\" [attr.aria-label]=\"'DOMAIN_BAR_CORE_CONNECTED.PAGE_NOT_FOUND' | translate\">\r\n    </mat-icon>\r\n</div>\r\n" }]
        }] });

/*** Handles hub message to show a push notification. */
class BarLogOffHubMessageHandler {
    constructor(auth) {
        this.auth = auth;
        this.action = 'LogOff';
    }
    handle() {
        this.auth.logOff().subscribe();
    }
}
BarLogOffHubMessageHandler.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarLogOffHubMessageHandler, deps: [{ token: BarAuthService }], target: i0.ɵɵFactoryTarget.Injectable });
BarLogOffHubMessageHandler.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarLogOffHubMessageHandler });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarLogOffHubMessageHandler, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: BarAuthService }]; } });

/** provides the user in offline apps. */
class BaasUserProvider {
    constructor() {
        // internal property
        this._disabled = false;
    }
}
BaasUserProvider.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasUserProvider, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BaasUserProvider.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasUserProvider });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasUserProvider, decorators: [{
            type: Injectable
        }] });

/** allows for (offline) apps to set their prefered user without using IDP service */
class BaasExternalAuthService extends BarAuthService {
    constructor(injector, guidProvider) {
        super(injector);
        this.guidProvider = guidProvider;
    }
    get authenticated() {
        return window.sessionStorage.getItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAAS_STATE_CONTEXT) != null;
    }
    get authenticating() {
        return false;
    }
    authenticate() {
        return new Observable((subscriber) => {
            this.clearStorage();
            if (!this.guidProvider)
                throw 'BaasExternalAuthService was called but the injected guidProvider is note defined.';
            if (this.guidProvider._disabled)
                throw 'BaasExternalAuthService was called but the injected guidProvider is disabled.';
            this.guidProvider.provideUser().subscribe((guid) => {
                if (guid) {
                    //TODO: make sound logic to return prefered user
                    const userHeaderContext = `{"userTicketGuid":"${guid}"}`; //offline ticket guid
                    window.sessionStorage.setItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAAS_STATE_CONTEXT, userHeaderContext);
                    subscriber.next(true);
                }
                else
                    subscriber.next(null);
            }, (err) => {
                console.error(err);
                subscriber.next(false);
            });
        });
    }
    performLogOff() {
        this.clearStorage();
        return of(undefined);
    }
    clearStorage() {
        window.sessionStorage.removeItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAAS_STATE_CONTEXT);
        try {
            window.localStorage.removeItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAAS_STATE_CONTEXT);
        }
        catch (_a) {
            console.debug('BaasExternalAuthService: the process could not clear items in localhost');
        }
    }
}
BaasExternalAuthService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasExternalAuthService, deps: [{ token: i0.Injector }, { token: BaasUserProvider }], target: i0.ɵɵFactoryTarget.Injectable });
BaasExternalAuthService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasExternalAuthService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasExternalAuthService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: BaasUserProvider }]; } });

/** Default no operation user provider. */
class BaasNoopUserProvider extends BaasUserProvider {
    constructor() {
        super(...arguments);
        this._disabled = true;
    }
    /** Gets  */
    provideUser() {
        return EMPTY;
    }
}
BaasNoopUserProvider.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasNoopUserProvider, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BaasNoopUserProvider.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasNoopUserProvider });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaasNoopUserProvider, decorators: [{
            type: Injectable
        }] });

/** Public BAR authentication service using IDP. */
class BarIdpAuthService extends BarAuthService {
    constructor(injector, coreState, coreOptions, idpClient, appInfo, localhost) {
        super(injector);
        this.coreState = coreState;
        this.coreOptions = coreOptions;
        this.idpClient = idpClient;
        this.appInfo = appInfo;
        this.localhost = localhost;
    }
    get authenticated() {
        // being authenticated means having a bar-cookie (if we have the idp client we use this to check whether we are authenticated)
        return this.idpClient.authenticated;
    }
    get authenticating() {
        return false;
    }
    authenticate() {
        return new Observable((subscriber) => {
            // make sure local storage value impersonate is removed before authentication
            window.localStorage.removeItem(BAR_CORE_CONSTANTS.STORAGE_KEYS.IDP_IMPERSONATE);
            // NOTE we cannot use the route here because it is before routing takes place
            const idpStatus = parseQueryStringValue('idp-status');
            if (idpStatus === 'fail') {
                // idp returned a fail, just make sure we go to authenticate failed page (to avoid endless loop)
                subscriber.next(false);
                subscriber.complete();
            }
            else {
                // if we are using @lvflanders/bar we use the idp client
                this.idpClient.authenticate(this.coreOptions.auth.config).then(() => {
                    // make sure processing is stopped because we are doing a full page redirect
                    subscriber.next(null);
                    subscriber.complete();
                });
            }
        });
    }
    /** Processing that occurs after the authentication. Meaning we are authenticated. */
    postProcessing() {
        if (!this.authenticated)
            return;
        const impersonateStrQuery = parseQueryStringValue('idp-impersonate');
        const impersonateStrStorage = window.localStorage.getItem(BAR_CORE_CONSTANTS.STORAGE_KEYS.IDP_IMPERSONATE);
        let impersonate = false;
        if (impersonateStrQuery && (!impersonateStrStorage || impersonateStrStorage === false.toString())) {
            impersonate = impersonateStrQuery.toLowerCase() === true.toString();
            window.localStorage.setItem(BAR_CORE_CONSTANTS.STORAGE_KEYS.IDP_IMPERSONATE, impersonate.toString());
        }
        else
            impersonate = impersonateStrStorage === true.toString();
        const impersonateKey = 'impersonate';
        this.coreState.basiscontext[impersonateKey] = impersonate;
    }
    performLogOff() {
        // execute everything within an observable (otherwise it is immediately executed, which we don't want)
        return new Observable((subscriber) => {
            if (this.localhost) {
                // NOTE app info localhost xdc stuff is not yet in @lvflanders/bar
                this.appInfo.delete();
            }
            const target = concatUrl(this.coreState.location.baasStatic.url, BAR_CORE_CONSTANTS.PAGES.LOG_OFF);
            this.idpClient.logout(target).then(() => {
                subscriber.next();
                subscriber.complete();
            });
        });
    }
}
BarIdpAuthService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarIdpAuthService, deps: [{ token: i0.Injector }, { token: BarCoreStateService }, { token: BarConnectedModuleOptions }, { token: i1$3.BarIdpClient }, { token: BarAppInfoService }, { token: BAR_LOCALHOST }], target: i0.ɵɵFactoryTarget.Injectable });
BarIdpAuthService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarIdpAuthService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarIdpAuthService, decorators: [{
            type: Injectable
        }], ctorParameters: function () {
        return [{ type: i0.Injector }, { type: BarCoreStateService }, { type: BarConnectedModuleOptions }, { type: i1$3.BarIdpClient }, { type: BarAppInfoService }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [BAR_LOCALHOST]
                    }] }];
    } });

var _BarIdpHeaderAuthService_idpClient, _BarIdpHeaderAuthService_options, _BarIdpHeaderAuthService_contextService, _BarIdpHeaderAuthService_coreState;
// TODO Use auth strategy in vnext
class BarIdpHeaderAuthService extends BarAuthService {
    constructor() {
        super(...arguments);
        _BarIdpHeaderAuthService_idpClient.set(this, inject(BarIdpClient));
        _BarIdpHeaderAuthService_options.set(this, inject(BarConnectedModuleOptions));
        _BarIdpHeaderAuthService_contextService.set(this, inject(BaasContextService));
        _BarIdpHeaderAuthService_coreState.set(this, inject(BarCoreStateService));
    }
    get authenticated() {
        return __classPrivateFieldGet(this, _BarIdpHeaderAuthService_contextService, "f").checkBaasContextInStorage();
    }
    get authenticating() {
        // we are coming from IDP meaning we still need to authenticate
        return parseQueryStringValue('idp-status') != null;
    }
    authenticate() {
        const idpStatus = parseQueryStringValue('idp-status');
        switch (idpStatus) {
            case 'success': {
                // authentication success
                const idpUsr = parseQueryStringValue('idp-usr');
                const voorwie = parseQueryStringValue('idp-vw');
                const voorwieRolcode = parseQueryStringValue('idp-vwrc');
                // NOTE voorwie rolcode is niet verplicht
                const userVoorwie = voorwie ? `${voorwie};${voorwieRolcode ? voorwieRolcode.toUpperCase() : 'NULL'}` : undefined;
                const hoedanigheid = parseQueryStringValue('idp-hd');
                const hoedanigheidRolcode = parseQueryStringValue('idp-hdrc');
                // NOTE hoedanigheid rolcode is niet verplicht
                const userHoedanigheid = hoedanigheid ? `${hoedanigheid};${hoedanigheidRolcode ? hoedanigheidRolcode.toUpperCase() : 'NULL'}` : undefined;
                const state = { userTicketGuid: idpUsr, userVoorwie, userHoedanigheid };
                __classPrivateFieldGet(this, _BarIdpHeaderAuthService_contextService, "f").saveBaasContextToStorage(state);
                return of(true);
            }
            case 'fail': {
                // authentication failed
                return of(false);
            }
            default: {
                // authenticating
                // go to idp and pass this url as the target
                __classPrivateFieldGet(this, _BarIdpHeaderAuthService_idpClient, "f").authenticate(__classPrivateFieldGet(this, _BarIdpHeaderAuthService_options, "f").auth.config);
                return of(undefined);
            }
        }
    }
    performLogOff() {
        window.sessionStorage.removeItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAAS_STATE_CONTEXT);
        try {
            window.localStorage.removeItem(_BAAS_SHARED_CONSTANTS.STORAGE_KEY.BAAS_STATE_CONTEXT);
        }
        catch (_a) {
            console.debug('BarIdpHeaderAuthService: the process could not clear items in localhost');
        }
        const target = concatUrl(__classPrivateFieldGet(this, _BarIdpHeaderAuthService_coreState, "f").location.baasStatic.url, BAR_CORE_CONSTANTS.PAGES.LOG_OFF);
        window.location.replace(target);
        return of(undefined);
    }
}
_BarIdpHeaderAuthService_idpClient = new WeakMap(), _BarIdpHeaderAuthService_options = new WeakMap(), _BarIdpHeaderAuthService_contextService = new WeakMap(), _BarIdpHeaderAuthService_coreState = new WeakMap();
BarIdpHeaderAuthService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarIdpHeaderAuthService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BarIdpHeaderAuthService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarIdpHeaderAuthService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarIdpHeaderAuthService, decorators: [{
            type: Injectable
        }] });

class BarAuditService {
    constructor(logging, state, auditHttpService) {
        this.logging = logging;
        this.state = state;
        this.auditHttpService = auditHttpService;
        // instantiate the queue with session storage
        this.queueProcessor = new BarQueueProcessor(window.sessionStorage, BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX + 'auditQueue');
    }
    /**
     * Puts an audit record on the queue.
     * @param audit Audit information.
     */
    log(audit) {
        // do not log if disabled or if audit type is excluded
        if (this.state.config.audit.enabled !== true ||
            (this.state.config.audit.excludedAuditTypes != null && this.state.config.audit.excludedAuditTypes.indexOf(audit.auditType) > -1)) {
            return;
        }
        if (audit.timestamp == null) {
            audit.timestamp = new Date();
        }
        if (audit.sessionId == null) {
            audit.sessionId = this.state.sessionId;
        }
        if (audit.appCode == null && this.state.toepassing != null) {
            audit.appCode = this.state.toepassing.code;
        }
        if (this.state.basiscontext != null) {
            audit.hoedanigheid = this.state.basiscontext.hoedanigheid;
            audit.hoedanigheidRolcode = this.state.basiscontext.hoedanigheidRolcode;
            audit.voorwie = this.state.basiscontext.voorwie;
            audit.voorwieRolcode = this.state.basiscontext.voorwieRolcode;
            audit.userId = this.state.basiscontext.userId;
        }
        audit.hostName = location.hostname;
        if (!audit.details)
            audit.details = {};
        if (!audit.details['PGID']) {
            audit.details['PGID'] = this.state.pageId;
        }
        this.queueProcessor.enqueue(audit);
    }
    /**
     * Start to listen to the queue.
     */
    start() {
        // start listening to the audit queue
        this.queueProcessor.start(this.state.config.audit.interval, this.state.config.audit.itemCount);
        // post items to back-end with interval
        this.queueProcessor.execute$.subscribe((auditItems) => {
            this.auditHttpService.save(auditItems).subscribe(null, (error) => {
                // in case an error occurs just handle in background
                console.error(error);
                this.logging.error({ error });
            });
        });
    }
}
BarAuditService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAuditService, deps: [{ token: BarLoggingService }, { token: BarCoreStateService }, { token: BarAuditHttpService }], target: i0.ɵɵFactoryTarget.Injectable });
BarAuditService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAuditService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAuditService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: BarLoggingService }, { type: BarCoreStateService }, { type: BarAuditHttpService }]; } });

/** Implementation within @lvflanders/bar-ng of the @lvflanders/bar app state contract (interconnection shared & core). */
class BarSharedAppStateService {
    constructor(coreState) {
        this.coreState = coreState;
    }
    get sessionId() {
        return this.coreState.sessionId;
    }
}
BarSharedAppStateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarSharedAppStateService, deps: [{ token: BarCoreStateService }], target: i0.ɵɵFactoryTarget.Injectable });
BarSharedAppStateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarSharedAppStateService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarSharedAppStateService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: BarCoreStateService }]; } });

class BarToepassingService {
    constructor(appInfo, state) {
        this.appInfo = appInfo;
        this.state = state;
        /** Occurs when the basiscontext changes */
        this.basiscontextChanged = new EventEmitter();
    }
    /**
     * Sets the voorwie.
     * @param voorwie
     * @param voorwieRolcode
     */
    setVoorwie(voorwie, voorwieRolcode) {
        // do not allow null because it can cause null to be written in de cookie as a string causing trouble in the neighbourhood
        if (voorwie == null)
            voorwie = '';
        if (voorwieRolcode == null)
            voorwieRolcode = '';
        return this.setBasiscontextData((basiscontext) => {
            basiscontext.voorwie = voorwie;
            basiscontext.voorwieRolcode = voorwieRolcode;
        }, 'Set-Voorwie');
    }
    /**
     * Resets the voorwie.
     */
    resetVoorwie() {
        return this.setVoorwie('', '');
    }
    /**
     * Sets the hoedanigheid.
     * @param hoedanigheid
     * @param hoedanigheidRolcode
     */
    setHoedanigheid(hoedanigheid, hoedanigheidRolcode) {
        // do not allow null because it can cause null to be written in de cookie as a string causing trouble in the neighbourhood
        if (hoedanigheid == null)
            hoedanigheid = '';
        if (hoedanigheidRolcode == null)
            hoedanigheidRolcode = '';
        return this.setBasiscontextData((basiscontext) => {
            basiscontext.hoedanigheid = hoedanigheid;
            basiscontext.hoedanigheidRolcode = hoedanigheidRolcode;
        }, 'Set-Hoedanigheid');
    }
    /**
     * Resets the hoedanigheid.
     */
    resetHoedanigheid() {
        return this.setHoedanigheid('', '');
    }
    setBasiscontextData(handler, method) {
        const basiscontext = this.state.basiscontext;
        if (basiscontext != null) {
            handler(basiscontext);
            // trick to fill in readonly prop (will give compilation error if property name changes)
            // https://stackoverflow.com/questions/48992522/get-name-of-property-or-field-in-object-typed/48992694?noredirect=1#comment84991472_48992694
            const basiscontextKey = 'basiscontext';
            this.state[basiscontextKey] = basiscontext;
            return new Promise((resolve, reject) => {
                this.appInfo.persistBasiscontext({ caller: `Toepassing-${method}` }).then(() => {
                    this.basiscontextChanged.emit(basiscontext);
                    resolve();
                });
            });
        }
        else {
            return Promise.resolve();
        }
    }
}
BarToepassingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarToepassingService, deps: [{ token: BarAppInfoService }, { token: BarCoreStateService }], target: i0.ɵɵFactoryTarget.Injectable });
BarToepassingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarToepassingService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarToepassingService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: BarAppInfoService }, { type: BarCoreStateService }]; } });

/** Public BAR (initialization) service */
class BarStartupService {
    constructor(injector, sharedBootstrapper, audit, translate, state, appInfo, meetpunt, auth, logOff, logging, config, xdc, cacheManager, baasContextService, globalStore, idpClient, commonHttpService, initializedHooks, baseHref, rapUrlHelper, meldingEngine, localhost, oopsDomService) {
        this.injector = injector;
        this.sharedBootstrapper = sharedBootstrapper;
        this.audit = audit;
        this.translate = translate;
        this.state = state;
        this.appInfo = appInfo;
        this.meetpunt = meetpunt;
        this.auth = auth;
        this.logOff = logOff;
        this.logging = logging;
        this.config = config;
        this.xdc = xdc;
        this.cacheManager = cacheManager;
        this.baasContextService = baasContextService;
        this.globalStore = globalStore;
        this.idpClient = idpClient;
        this.commonHttpService = commonHttpService;
        this.initializedHooks = initializedHooks;
        this.baseHref = baseHref;
        this.rapUrlHelper = rapUrlHelper;
        this.meldingEngine = meldingEngine;
        this.localhost = localhost;
        this.oopsDomService = oopsDomService;
        // whether the configuration has been handled and assigned
        this.configHandled = false;
    }
    // avoid cyclic DI error
    get router() {
        return this.injector.get(Router);
    }
    load() {
        // launch bootstrapping for @lvflanders/bar
        this.sharedBootstrapper.launch();
        // https://stackoverflow.com/questions/47422095/angular-app-initializer-promise-vs-observable?rq=1
        return new Promise((resolve, reject) => {
            // assign as variables to avoid passing them through the methods
            this.resolve = resolve;
            this.reject = reject;
            if (this.mustAuthenticate) {
                // first we check if the context transport modus has been overridden (local storage)
                const contextTransportModusOverride = this.contextTransportModusOverride;
                // override default context transport modus if defined
                if (contextTransportModusOverride !== undefined)
                    this.config.auth.contextTransportModus = contextTransportModusOverride;
            }
            this.configHandled = false;
            // clear out request log off
            this.logOff.requestLogOff = undefined;
            // launch the startup life cycle (pre-init, auth, init, init-local)
            this.launchLifeCycle();
        });
    }
    get mustAuthenticate() {
        return this.config.auth != null ? this.config.auth.enabled : false;
    }
    get authFailedUrl() {
        return this.state.config.auth.failedUrl;
    }
    get targetOriginOverride() {
        return window.localStorage.getItem(BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX + 'targetOrigin');
    }
    set targetOriginOverride(value) {
        if (value == null) {
            window.localStorage.removeItem(BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX + 'targetOrigin');
        }
        else {
            window.localStorage.setItem(BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX + 'targetOrigin', value);
        }
    }
    set contextTransportModusOverride(value) {
        window.localStorage.setItem(BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX + 'context-transport-modus', value.toString());
    }
    get contextTransportModusOverride() {
        const str = window.localStorage.getItem(BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX + 'context-transport-modus');
        if (str && str.length)
            return +str;
        return undefined;
    }
    launchLifeCycle() {
        this.enhanceRouting();
        // generate the page id
        const pageIdKey = 'pageId';
        this.state[pageIdKey] = generateUuid();
        this.defineConnectivity();
        const locationKey = 'location';
        this.state[locationKey] = {};
        const applicationKey = 'application';
        this.state.location[applicationKey] = extractUrlParts(this.defineApplicationUrl());
        const spaKey = 'spa';
        this.state.location[spaKey] = extractUrlParts(this.defineSpaUrl());
        const apiRootKey = 'apiRoot';
        this.state.location[apiRootKey] = extractUrlParts(this.defineApiUrl());
        this.idpClient.options.targetUrl = window.location.href;
        // different steps (in case not authenticated):
        // 1-a) pre - init local (only in XDC modus)
        // 1-b) pre - init (if not authenticated)
        // 2) authenticate (if not authenticated)
        // 3-a) init
        // 3-b) init local (only in XDC modus)
        const launch = () => {
            // we can define the release state location here because a value depends on the pre-init-local (release domain aka target)
            const releaseKey = 'release';
            this.state.location[releaseKey] = extractUrlParts(this.defineReleaseOrigin());
            const barWebKey = 'barWeb';
            this.state.location[barWebKey] = extractUrlParts(this.defineBarWebRootUrl());
            const baasStaticKey = 'baasStatic';
            this.state.location[baasStaticKey] = extractUrlParts(this.defineBaasStaticRootUrl());
            const baasWebKey = 'baasWeb';
            this.state.location[baasWebKey] = extractUrlParts(this.defineBaasWebRootUrl());
            this.idpClient.options.wwUrl = this.state.location.baasStatic.url;
            // if not authenticated we perform the pre-init to retrieve unauthenticated data
            if (!this.auth.authenticated)
                this.launchPreInit();
            else if (this.auth.authenticating && this.mustAuthenticate)
                this.launchAuth();
            else
                this.launchInit(true);
        };
        if (this.localhost) {
            //localhost needs pre-init-local call to function
            const core = ensureGlobal('lvflanders.bar.ng.core');
            // and here we make a hook to overide the targetOrigin through the console
            Object.defineProperty(core, 'targetOrigin', {
                get: () => {
                    return this.targetOriginOverride;
                },
                set: (value) => {
                    this.targetOriginOverride = value;
                }
            });
            // use the target origin override (set via developer tools console if defined)
            this.targetOrigin = this.targetOriginOverride;
            // we don't have a target origin override check if we have it in session storage
            if (this.targetOrigin == null) {
                // if xdc is enabled we need to define the target origin to which to connect to (BAR, basiscomponenten, iframe).
                // we remember this in the session storage to avoid performing the pre-init-local constantly
                this.targetOrigin = window.sessionStorage.getItem(BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX + 'targetOrigin');
            }
            else {
                console.warn(this.translate.instant('DOMAIN_BAR_CORE_CONNECTED.TARGET_ORIGIN_OVERRIDE_WARNING', { targetOrigin: this.targetOrigin }));
            }
            if (this.targetOrigin != null) {
                // we already know the target origin no need to go fetch it
                launch();
            }
            else {
                // perform a local api call to get the target origin
                this.commonHttpService
                    .preInitLocal()
                    .pipe(retry(3))
                    .subscribe((data) => {
                    this.targetOrigin = data.targetOrigin || data.TargetOrigin;
                    if (this.targetOrigin != null) {
                        window.sessionStorage.setItem(BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX + 'targetOrigin', this.targetOrigin);
                    }
                    launch();
                }, (error) => {
                    const msg = this.translate.instant('DOMAIN_BAR_CORE_CONNECTED.PRE_INIT_LOCAL_FAILED');
                    console.warn(msg);
                    // launch anyway
                    launch();
                });
            }
        }
        else {
            // if not in xdc modus we don't have a target origin and interpret it based on current settings
            launch();
        }
    }
    launchPreInit() {
        // try get config from session storage first to avoid having to retrieve it (can become larger and larger)
        const loadConfig = this.tryLoadConfigFromStorage();
        const initRequest = this.getInitRequest(loadConfig);
        // get the config from web api without authentication
        this.commonHttpService
            .preInit(initRequest)
            .pipe(retry(3), tap((data) => {
            // handle the data
            this.handleConfig(data.config, true);
            this.handleToepassing(data.toepassing);
        }), 
        // invoke pre initialized hooks
        mergeMap(() => this.initialized(true)), tap(() => {
            var _a;
            // in this tap we check if we have an override for the context transport modus (from baas static configuration)
            if (this.mustAuthenticate &&
                this.localhost &&
                this.contextTransportModusOverride === undefined &&
                // no default was given (null or undefined)
                this.config.auth._originalContextTransportModus == null &&
                this.config.auth.contextTransportModus === BaasContextTransportModus.OnlineHeaders &&
                ((_a = this.state.config.baasStatic.auth) === null || _a === void 0 ? void 0 : _a.localhostHeaderTransportModus) === false) {
                // put auth back to online cookies if disabled explicitly
                this.config.auth.contextTransportModus = BaasContextTransportModus.OnlineCookies;
                // remember override
                this.contextTransportModusOverride = this.config.auth.contextTransportModus;
            }
        }))
            .subscribe((data) => {
            if (this.xdc.enabled) {
                // in case xdc is enabled we do a sync to see if we are already authenticated on the remote domain
                this.xdc.sync({ caller: 'Startup', step: 'Auth' }).then(() => {
                    // after the sync we check again if we are not authenticated
                    if (this.mustAuthenticate && !this.auth.authenticated) {
                        //when session is filled during (offline modus), IDP call (launchauth) is bypassed!
                        this.launchAuth();
                    }
                    else {
                        // if we succeeded to authenticate we perform the init straight away
                        this.launchInit(false);
                    }
                });
            }
            else {
                // we are not working with xdc meaning we should authenticate
                if (!this.auth.authenticated && this.mustAuthenticate)
                    this.launchAuth();
                else
                    this.launchInit(false);
            }
        }, (err) => this.handleStartupError(err));
    }
    tryLoadConfigFromStorage() {
        let notLoaded = true;
        const configStr = window.sessionStorage.getItem(BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX + 'config');
        if (configStr != null && configStr.length > 0) {
            notLoaded = false;
            const config = JSON.parse(configStr);
            this.handleConfig(config, false);
        }
        return notLoaded;
    }
    // handles the configuration object
    handleConfig(config, putInStorage) {
        if (this.configHandled) {
            return;
        }
        // configuration data
        const configKey = 'config';
        // trick to have assignment to readonly prop
        this.state[configKey] = config;
        if (putInStorage) {
            // store config in session storage to avoid retrieving it when switching application
            window.sessionStorage.setItem(BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX + 'config', JSON.stringify(config));
        }
        const processIdpRootUrl = (origin) => {
            let idpRootUrl = origin;
            if (!config.idpRootUrl.startsWith('/')) {
                idpRootUrl += '/';
            }
            idpRootUrl += config.idpRootUrl;
            config.idpRootUrl = idpRootUrl;
            config.idpRootUrl = this.rapUrlHelper.parseUrl(config.idpRootUrl);
        };
        if (this.localhost) {
            // NOTE overschrijven van urls voor de lokale BAR omgeving (deze solution): localhost heeft geen profielbeheer notie
            if (this.config.local && !this.config.auth.forceRemote) {
                // indien localhost client EN bundle build voor local : via lokale authprovider/IDP
                config.auth.url = 'https://localhost:44307/auth?noredirect=1';
                config.auth.failedUrl = 'https://localhost:44307/authenticate-failed';
                config.logoutUrl = 'https://localhost:44307/auth/logout';
                config.errorUrl = 'https://alv-dotnet4-d/startscherm/domain.startscherm.Web/probleemrapport/';
                config.idpRootUrl = 'https://alv-dotnet4-d/a/idp/wui';
            }
            else {
                // this will be used in XDC modus
                // this.state.location.release.origin;
                processIdpRootUrl(this.state.location.release.origin);
            }
        }
        else {
            processIdpRootUrl(window.location.origin);
        }
        // pass the idp root url to the idp client if used
        this.idpClient.options.idpUrl = config.idpRootUrl;
        this.configHandled = true;
    }
    launchAuth() {
        // authenticate ! when successfull also initialize
        this.auth.authenticate().subscribe((authSuccess) => {
            if (authSuccess == null) {
                // redirect already done
                this.reject();
            }
            else if (authSuccess) {
                this.launchInit(true);
            }
            else {
                window.location.href = this.authFailedUrl;
                this.reject();
            }
        }, (err) => {
            console.error(err);
            window.location.href = this.authFailedUrl;
            this.reject();
        });
    }
    // handles startup errors specially because there is no user interface yet
    handleStartupError(err) {
        console.error(err);
        if (this.oopsDomService.checkOopsSupported()) {
            this.oopsDomService.showOops({ type: _OopsType.Technical });
        }
        else {
            // @deprecated old mechanism
            // fallback error
            this.translate.get('DOMAIN_BAR_CORE_CONNECTED.STARTUP_ERROR').subscribe((msg) => {
                document.body.innerText = msg;
                this.reject(new Error(msg));
            });
        }
    }
    // following method is invoked after authenticating
    defineBrowserSession() {
        return new Promise((resolve) => {
            // get session id from cookie
            let cookieSessionId = this.appInfo.sessionId;
            if (!cookieSessionId) {
                // no session cookie, create session cookie and use new uuid
                cookieSessionId = generateUuid();
                this.appInfo.sessionId = cookieSessionId;
            }
            // get actual session id being used
            this.globalStore.getItem(BAR_CORE_CONSTANTS.STORAGE_KEYS.SESSION_ID).then((sessionId) => {
                // this routing is called at the end
                const proceed = (clearSession) => {
                    // use session id in the temp storage generated after successfull authentication
                    const sessionIdKey = 'sessionId';
                    // save it in state
                    this.state[sessionIdKey] = sessionId;
                    if (this.config.disableCacheInvalidation)
                        resolve();
                    else {
                        // invalidate the cache (if not disabled) and pass flag determining whether we must clear out all session cache entries
                        this.cacheManager.invalidate(clearSession).then(() => {
                            resolve();
                        });
                    }
                };
                // if no session id yet or if there is a session but the app info cookie isn't equal we start a new browser session
                if (sessionId !== cookieSessionId) {
                    sessionId = cookieSessionId;
                    // put the new session id in the global cache store (and keep it there)
                    this.globalStore.setItem(BAR_CORE_CONSTANTS.STORAGE_KEYS.SESSION_ID, sessionId, { session: false }).then(() => {
                        proceed(true);
                    });
                }
                // re-use session
                else {
                    proceed(false);
                }
            });
        });
    }
    defineConnectivity() {
        const connectivity = 'connectivity';
        this.state[connectivity] = this.config.connectivity || BarConnectivity.Online;
    }
    /** tests baasContextmodus setting to determine if session storage needs to be filled  */
    get baasHeadersAllowed() {
        //below setting can be null when not defined in forroot().
        return this.baasContextModus !== BaasContextTransportModus.OnlineCookies;
    }
    tryRunIdpValidation(ticketId) {
        if (this.mustAuthenticate && this.config.auth.validation !== false && this.baasContextModus === BaasContextTransportModus.OnlineCookies) {
            // here we launch a web worker asynchronously bound to the idp client
            this.idpClient.validate(undefined);
        }
    }
    // following method is always invoked (after authenticating or if already authenticated)
    launchInit(preInitSkipped) {
        const doInit = () => {
            var _a;
            if (!this.auth.authenticated &&
                ((_a = this.config._noInitPaths) === null || _a === void 0 ? void 0 : _a.some((noInitPath) => {
                    const fullPath = concatUrl(this.state.location.spa.pathname, noInitPath).toLowerCase();
                    return window.location.pathname.toLowerCase() === fullPath;
                }))) {
                this.initializeFinal(undefined, preInitSkipped);
                return;
            }
            // try get config from session storage first to avoid having to retrieve it (can become larger and larger)
            const loadConfig = !this.configHandled && this.tryLoadConfigFromStorage();
            const initRequest = this.getInitRequest(loadConfig);
            initRequest.loadToepassing = this.state.toepassing == null;
            this.commonHttpService
                .init(initRequest)
                .pipe(retry(3), tap((data) => {
                if (data.config != null) {
                    this.handleConfig(data.config, true);
                }
                const baasVersionKey = 'baasVersion';
                this.state[baasVersionKey] = data.baasVersion;
                const requestTokenKey = 'requestToken';
                this.state[requestTokenKey] = data.requestToken;
                if (data.toepassing != null) {
                    this.handleToepassing(data.toepassing);
                }
                if (this.baasHeadersAllowed && (data === null || data === void 0 ? void 0 : data.state) !== null && typeof data.state !== 'undefined') {
                    const currentContext = this.baasContextService.getBaasContextFromStorage();
                    const updatedContext = Object.assign(Object.assign({}, data.state), { userTicketGuid: currentContext.userTicketGuid });
                    //will save context of authenticated user in session storage
                    this.baasContextService.saveBaasContextToStorage(updatedContext);
                }
                const meetpuntenAutomatischAanmakenKey = 'meetpuntenAutomatischAanmaken';
                this.state[meetpuntenAutomatischAanmakenKey] =
                    data.meetpuntenAutomatischAanmaken == null ? false : data.meetpuntenAutomatischAanmaken;
            }))
                // post and pass request object
                .subscribe((data) => {
                // in case localhost we do an extra init on the localhost api
                if (this.localhost) {
                    const doInitLocal = () => {
                        // extra localhost init for antiforgery
                        this.commonHttpService.initLocal().subscribe((localData) => {
                            const localRequestTokenKey = 'localRequestToken';
                            this.state[localRequestTokenKey] = localData.requestToken;
                            // end the initialization
                            this.initializeFinal(data, preInitSkipped);
                        }, (error) => {
                            const msg = this.translate.instant('DOMAIN_BAR_CORE_CONNECTED.INIT_LOCAL_FAILED');
                            console.error(msg);
                            this.handleStartupError(error);
                        });
                    };
                    if (this.xdc.enabled) {
                        this.xdc.sync({ caller: 'Startup', step: 'After Init' }).then(() => doInitLocal());
                    }
                    else
                        doInitLocal();
                }
                // normal situation (on the deployed environment, not localhost)
                else {
                    // end the initialization
                    this.initializeFinal(data, preInitSkipped);
                }
            }, (error) => this.handleStartupError(error));
        };
        if (preInitSkipped && this.xdc.enabled) {
            this.xdc.sync({ caller: 'Startup', step: 'Before Init' }).then(() => {
                doInit();
            });
        }
        else
            doInit();
    }
    handleToepassing(toepassing) {
        if (this.config.appVersion) {
            // NOTE use the version from the config as the toepassing versie
            // ATM (17-01-2024) there is a bug where BaaS.NET gives a wrong version through the init
            const versieKey = 'versie';
            toepassing[versieKey] = this.config.appVersion;
        }
        const toepassingKey = 'toepassing';
        this.state[toepassingKey] = toepassing;
        // set zone for IDP based on state
        this.idpClient.options.zone = this.state.toepassing.zone;
    }
    initializeFinal(data, preInitSkipped) {
        this.defineBrowserSession().then(() => {
            var _a;
            // audit page (make sure it is after session audit)
            const audit = {
                auditId: this.state.pageId,
                parentAuditId: this.state.sessionId,
                auditType: BarAuditType.Page,
                appCode: this.config.appCode,
                details: {
                    URL: document.location.href,
                    'APP-VERSION': this.config.appVersion
                }
            };
            this.audit.log(audit);
            this.addAuditInfoOnDocument(audit);
            this.auditDependencies();
            // here we put some global stuff
            const core = ensureGlobal('lvflanders.bar.ng.core');
            // make sure the state is available globally for non Angular code
            core.state = this.state;
            // put the toepassing service on global scope to open it up for outside user (such as puppeteer and web accessibility)
            core.toepassing = this.injector.get(BarToepassingService);
            this.appInfo.init(data);
            // define audit now because we need to know if audit is enabled (based on config)
            this.defineAuditMeetpunten();
            // get basiscontext from cookie (cookie is the master)
            const basiscontext = this.appInfo.getBasiscontext();
            // also set the basiscontext regular variable (non observable)
            // trick to fill in readonly prop (will give compilation error if property name changes)
            // https://stackoverflow.com/questions/48992522/get-name-of-property-or-field-in-object-typed/48992694?noredirect=1#comment84991472_48992694
            const basiscontextKey = 'basiscontext';
            this.state[basiscontextKey] = basiscontext;
            if (this.auth.postProcessing)
                this.auth.postProcessing();
            if (this.config.auth.contextTransportModus === BaasContextTransportModus.OnlineCookies) {
                // persist basiscontext whenever tab gets focus or we are leaving the tab
                // basiscontext can be different per tab but there is only one cookie
                document.addEventListener('visibilitychange', (ev) => {
                    this.appInfo.persistBasiscontext({
                        caller: 'Startup-VisibilityChange'
                    });
                });
            }
            // NOTE in ng 18 the user ticket guid is not passed to the validation
            // because the idp client internally knows about the user ticket in this case
            this.tryRunIdpValidation((_a = data === null || data === void 0 ? void 0 : data.state) === null || _a === void 0 ? void 0 : _a.userTicketGuid);
            // go through all lifecycle hooks and call initialized
            this.initialized(preInitSkipped ? undefined : false).subscribe(() => {
                this.logOff.startListening();
                this.resolve();
            });
        });
    }
    /** Invoked when BAR is initialized. */
    initialized(pre) {
        if (this.initializedHooks != null) {
            return this.executeInitializedHooks(pre);
        }
        else {
            return of(undefined);
        }
    }
    executeInitializedHooks(pre) {
        const hookComparer = (a, b) => {
            // first let _framework internal property take precedence
            if (a._framework && !b._framework)
                return -1;
            if (!a._framework && b._framework)
                return 1;
            // second take into account the order
            if (a.order == null && b.order == null)
                return 0;
            if (a.order != null && b.order == null)
                return -1;
            if (a.order == null && b.order != null)
                return 1;
            if (a.order < b.order)
                return -1;
            if (a.order > b.order)
                return 1;
            return 0;
        };
        let initializedHooks = this.initializedHooks;
        // only filter if boolean is not undefined
        if (pre)
            initializedHooks = initializedHooks.filter((hook) => hook._pre === true);
        else if (pre === false)
            initializedHooks.filter((hook) => hook._pre !== true);
        // sort the hooks by order, if no order it goes in the back of the list
        const sortedHooks = initializedHooks.sort(hookComparer);
        let result$ = null;
        // NOTE concat didn't seem to work and forkJoin doesn't preserve the order
        // ensure everything is ran sequentially by modifying the observable till we reach the end of the array
        for (let i = 0; i < sortedHooks.length; i++) {
            const hookOutput$ = sortedHooks[i].run() || of(undefined);
            if (!result$)
                result$ = hookOutput$;
            else
                result$ = result$.pipe(mergeMap(() => hookOutput$));
        }
        return result$;
    }
    defineAuditMeetpunten() {
        var _a, _b, _c, _d;
        const perflog = parseQueryStringValue('perflog');
        if (perflog != null) {
            const appinfo = this.appInfo.get();
            if (appinfo != null) {
                switch (perflog.toLowerCase()) {
                    case 'off':
                        appinfo.ForcePerformanceLog = false;
                        this.appInfo.save(appinfo);
                        break;
                    case 'on':
                        appinfo.ForcePerformanceLog = true;
                        this.appInfo.save(appinfo);
                        break;
                }
            }
        }
        if (this.meetpunt.loggingEnabled) {
            // here we measure the page load time (duration of loading resources and parsing it)
            // https://stackoverflow.com/a/14878493/2174621
            const pageLoadTime = window.performance.timing.domContentLoadedEventEnd - window.performance.timing.navigationStart;
            this.meetpunt.log({
                meetpunt: 'DOM_CONTENT_LOADED_END',
                meetpuntDetail: document.location.pathname,
                waarde: pageLoadTime,
                meetpuntInfo: document.location.href,
                auditId: this.state.pageId
            });
            this.stopwatch = new BarStopwatch();
            // navigation start event does not occur the first time
            // this means we need to start the stopwatch the frist time
            this.stopwatch.start();
        }
        // here we measure the routing time
        this.router.events.subscribe((val) => {
            // on navigation start we start the stopwatch
            if (val instanceof NavigationStart) {
                // first reset the meldingen
                this.state.meldingen$.next(undefined);
                if (this.stopwatch != null) {
                    this.stopwatch.start();
                }
            }
            // on navigation end or error we stop the stopwatch + use NavigationEnd to know the end/leaf route for meldingen
            else if (val instanceof NavigationEnd) {
                // meldingen are still undefined, meaning there was no meldingen guard, retrieve meldingen
                if (this.state.meldingen$.getValue() === undefined)
                    this.retrieveMeldingen(val.urlAfterRedirects || val.url).subscribe();
                this.endRouteWatch(val, 'ROUTER_NAVIGATION_END');
            }
            else if (val instanceof NavigationError) {
                this.endRouteWatch(val, 'ROUTER_NAVIGATION_END');
            }
        });
        if (((_b = (_a = this.state.config) === null || _a === void 0 ? void 0 : _a.audit) === null || _b === void 0 ? void 0 : _b.enabled) == true) {
            // start listening to the audit queue
            this.audit.start();
        }
        if (this.meetpunt.loggingEnabled) {
            // start listening to the meetpunt queue
            this.meetpunt.start();
        }
        // intialize logging (global vars...)
        this.logging.init();
        if (((_d = (_c = this.state.config) === null || _c === void 0 ? void 0 : _c.log) === null || _d === void 0 ? void 0 : _d.enabled) == true) {
            // start listening to the log queue
            this.logging.start();
        }
    }
    retrieveMeldingen(routeUrl) {
        return this.meldingEngine.retrieveAndProcess(routeUrl).pipe(map(() => undefined));
    }
    endRouteWatch(val, meetpunt) {
        // generate the route id
        const routeIdKey = 'routeId';
        this.state[routeIdKey] = generateUuid();
        // audit this
        const audit = {
            auditId: this.state.routeId,
            parentAuditId: this.state.pageId,
            auditType: BarAuditType.Route,
            details: {
                ROUTE: val.url,
                // also log the URL for completeness
                URL: document.location.href
            }
        };
        this.audit.log(audit);
        this.addAuditInfoOnDocument(audit);
        // do it in timeout so we executed meetpunt after (more accurate measurement)
        window.setTimeout(() => {
            // if no stopwatch it means meetpunten is not enabled
            if (this.stopwatch != null) {
                this.stopwatch.stop();
                this.meetpunt.log({
                    meetpunt,
                    meetpuntDetail: val.url,
                    waarde: this.stopwatch.duration,
                    meetpuntInfo: val.url,
                    auditId: this.state.routeId
                });
            }
        }, 0);
    }
    addAuditInfoOnDocument(audit) {
        if (document && audit) {
            const htmlEl = document.getElementsByTagName('html');
            if (htmlEl.length > 0) {
                htmlEl[0].setAttribute(BAR_CORE_CONSTANTS.AUDIT.HTML_ATTRIBUTE_AUDIT_ID, audit.auditId);
                htmlEl[0].setAttribute(BAR_CORE_CONSTANTS.AUDIT.HTML_ATTRIBUTE_AUDIT_TYPE, audit.auditType);
            }
        }
    }
    auditDependencies() {
        const scripts = [];
        const scriptTags = document.getElementsByTagName('script');
        for (let i = 0; i < scriptTags.length; i++) {
            const scriptTag = scriptTags[i];
            if (scriptTag.src != null && scriptTag.src.length > 0) {
                const script = {
                    src: scriptTag.src,
                    type: scriptTag.type
                };
                scripts.push(script);
            }
        }
        const links = [];
        const linkTags = document.getElementsByTagName('link');
        for (let i = 0; i < linkTags.length; i++) {
            const linkTag = linkTags[i];
            if (linkTag.href != null && linkTag.href.length > 0) {
                const link = {
                    href: linkTag.href,
                    rel: linkTag.rel,
                    type: linkTag.type
                };
                links.push(link);
            }
        }
        this.audit.log({
            parentAuditId: this.state.pageId,
            auditType: BarAuditType.Dependencies,
            appCode: this.config.appCode,
            details: {
                SCRIPTS: JSON.stringify(scripts),
                LINKS: JSON.stringify(links)
            }
        });
    }
    /** The application url of the current application. This is for example used for defining api url's for the current application */
    defineApplicationUrl() {
        let url = null;
        // if the application url is defined use this
        if (this.config.applicationUrl)
            url = this.config.applicationUrl;
        else if (this.baseHref)
            url = this.baseHref;
        else {
            // by default use the global base href tag
            const baseTag = document.getElementsByTagName('base');
            // no angular base href defined, use the html base href (set through angular.json baseHref or directly in index.html)
            if (baseTag.length && baseTag[0].href)
                url = baseTag[0].href;
            // if no base href just take the domain
            else
                url = location.origin;
        }
        if (!checkUrlAbsolute(url)) {
            if (!url.startsWith('/'))
                url = '/' + url;
            // we make the url absolute
            url = location.origin + url;
        }
        // make it end with a slash
        if (!url.endsWith('/'))
            url += '/';
        return url.toLowerCase();
    }
    defineApiUrl() {
        if (this.config.apiRootUrl)
            return this.config.apiRootUrl;
        return this.defineApplicationUrl();
    }
    defineSpaUrl() {
        if (this.baseHref) {
            if (checkUrlAbsolute(this.baseHref))
                return this.baseHref;
            const baseHref = this.baseHref.startsWith('/') ? this.baseHref : `/${this.baseHref}`;
            return `${this.state.location.application.origin}${baseHref}`;
        }
        return this.state.location.application.url;
    }
    // this is the domain where the @lvflanders/bar-ng script is released and from which it is referenced within the application
    // we guess this domain by checking the script tags (the localhost application has an absolute reference to the script file (cdn)
    // in case a localhost consumer outside BAR is using a script we use the domain of that script to determine where to do api calls or other stuff
    /** The domain where @lvflanders BAR is running */
    defineReleaseOrigin() {
        let result = null;
        if (this.targetOrigin != null) {
            // here we are in xdc modus and are using a target origin to define to which domain to connect to
            // for BAR & basiscomponenten and & XDC iframe
            result = this.targetOrigin;
        }
        else {
            let src = null;
            // note that scripts property is not a regular array
            for (let i = 0; i < document.scripts.length; i++) {
                const script = document.scripts[i];
                // find script tag with bar-ng
                if (script.src != null && script.src.indexOf('lvflanders-bar-ng') > -1) {
                    src = script.src;
                    break;
                }
            }
            if (src != null) {
                result = extractUrlOrigin(src);
            }
            else {
                // no bar-core bundle meaning everything is probably bundled inline -> just take current origin
                result = window.location.origin;
            }
        }
        return result;
    }
    /** Root url to BAR web (api) (this is the domain + the bar web segment) */
    defineBarWebRootUrl() {
        let url = null;
        if (this.config.connectivity === BarConnectivity.Offline) {
            // local means BAR web is in process -> we need to point to url of current application
            url = this.state.location.application.url + 'domain.basisarchitectuur.web/';
        }
        // remote modus (default)
        else if (this.localhost) {
            // check local: this means we are in the BAR solution: just use the URL of BAR web localhost
            if (this.config.local && this.config.rootUrl) {
                // NOTE that the bar web process is hosted somewhere else (other localhost) and this is passed through the forRoot options
                url = this.config.rootUrl;
                if (!url.endsWith('/')) {
                    url += '/';
                }
            }
            // if localhost client and this bundle is build for DEV
            // this means we need to use the DEV url
            else {
                url = this.state.location.release.origin + BAR_CORE_CONSTANTS.URL_SEGMENT.BAR_WEB;
            }
        }
        // we are on the deployed environment: just use current host name
        else {
            url = location.origin + BAR_CORE_CONSTANTS.URL_SEGMENT.BAR_WEB;
        }
        return url;
    }
    defineBaasWebRootUrl() {
        const origin = this.localhost ? this.state.location.release.origin : location.origin;
        return concatUrl(origin, this.rapUrlHelper.baasWebSegment);
    }
    defineBaasStaticRootUrl() {
        let url = null;
        if (this.config.connectivity === BarConnectivity.Offline) {
            // local means BaaS Static is in process -> we need to point to url of current application
            url = this.state.location.application.url + 'domain.baas-static.web/';
        }
        // remote modus (default)
        else if (this.localhost) {
            // check local: this means we are in the BAR solution: just use the URL of BAR web localhost
            if (this.config.local && this.config.staticRootUrl) {
                // NOTE that the bar web process is hosted somewhere else (other localhost) and this is passed through the forRoot options
                url = this.config.staticRootUrl;
                if (!url.endsWith('/')) {
                    url += '/';
                }
            }
            // if localhost client and this bundle is build for DEV
            // this means we need to use the DEV url
            else {
                url = this.state.location.release.origin + this.rapUrlHelper.baasStaticSegment;
            }
        }
        // we are on the deployed environment: just use current host name
        else {
            url = location.origin + this.rapUrlHelper.baasStaticSegment;
        }
        return url;
    }
    getInitRequest(loadConfig) {
        // make request object needed for pre-init or init
        return {
            appCode: this.config.appCode,
            appVersion: this.config.appVersion,
            loadConfig,
            loadToepassing: false,
            meetpuntType: BAR_CORE_CONSTANTS.DEFAULT_MEETPUNT_TYPE
        };
    }
    get baasContextModus() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.auth) === null || _b === void 0 ? void 0 : _b.contextTransportModus) !== null && _c !== void 0 ? _c : BaasContextTransportModus.OnlineCookies;
    }
    /** Enhances routing of application by adding guards where needed. */
    enhanceRouting() {
        if (this.router.config) {
            this.router.config
                // do not handle framework routes
                .filter((route) => { var _a; return ((_a = route.data) === null || _a === void 0 ? void 0 : _a._framework) !== true; })
                .forEach((route) => {
                if (route.children || route.loadChildren) {
                    if (!route.canActivateChild)
                        route.canActivateChild = [];
                    route.canActivateChild.push(_BarMeldingGuard);
                }
                else if (route.component) {
                    if (!route.canActivate)
                        route.canActivate = [];
                    route.canActivate.push(_BarMeldingGuard);
                }
            });
        }
    }
}
BarStartupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarStartupService, deps: [{ token: i0.Injector }, { token: i1$3.BarSharedBootstrapper }, { token: BarAuditService }, { token: i1$2.BarI18nService }, { token: BarCoreStateService }, { token: BarAppInfoService }, { token: BarMeetpuntService }, { token: BarAuthService }, { token: BarLogOffUtilityService }, { token: BarLoggingService }, { token: BarConnectedModuleOptions }, { token: BarXdcService }, { token: i1$3.BarCacheManager }, { token: BaasContextService }, { token: BAR_GLOBAL_CACHE }, { token: i1$3.BarIdpClient }, { token: BarCommonHttpService }, { token: BAR_INITIALIZED, optional: true }, { token: APP_BASE_HREF, optional: true }, { token: _BarRapUrlHelper }, { token: BarMeldingenEngine }, { token: BAR_LOCALHOST }, { token: _OopsDomService }], target: i0.ɵɵFactoryTarget.Injectable });
BarStartupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarStartupService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarStartupService, decorators: [{
            type: Injectable
        }], ctorParameters: function () {
        return [{ type: i0.Injector }, { type: i1$3.BarSharedBootstrapper }, { type: BarAuditService }, { type: i1$2.BarI18nService }, { type: BarCoreStateService }, { type: BarAppInfoService }, { type: BarMeetpuntService }, { type: BarAuthService }, { type: BarLogOffUtilityService }, { type: BarLoggingService }, { type: BarConnectedModuleOptions }, { type: BarXdcService }, { type: i1$3.BarCacheManager }, { type: BaasContextService }, { type: i1$3.BarCacheStore, decorators: [{
                        type: Inject,
                        args: [BAR_GLOBAL_CACHE]
                    }] }, { type: i1$3.BarIdpClient }, { type: BarCommonHttpService }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [BAR_INITIALIZED]
                    }, {
                        type: Optional
                    }] }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [APP_BASE_HREF]
                    }, {
                        type: Optional
                    }] }, { type: _BarRapUrlHelper }, { type: BarMeldingenEngine }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [BAR_LOCALHOST]
                    }] }, { type: _OopsDomService }];
    } });

var translations = {
    PAGE_NOT_FOUND: 'Pagina niet gevonden',
    STARTUP_ERROR: 'Er heeft zich een fout voorgedaan bij het opstarten.',
    INIT_LOCAL_FAILED: 'Local init has failed. The localhost web api server may not be running or a server-side error has occured.',
    PRE_INIT_LOCAL_FAILED: 'Local pre-init has failed. The localhost web api server may not be running or a server-side error has occured. Make sure to reference Domain.BasisArchitectuur.AspNetCore.dll 7.4.3 or higher.',
    INSUFFICIENT_PRIVILEGES_FOR_ACTIE: 'Onvoldoende rechten voor actie "{{actie}}" (includeVoorWie: {{includeVoorwie}} - includeHoedanigheid: {{includeHoedanigheid}})',
    ZONES_NOT_ALLOWED: 'Geen toegang voor zone(s): "{{zones}}"',
    XDC_ERROR: 'Fout bij het synchroniseren (XDC).',
    XDC_SYNC_DISABLED: 'XDC synchronisatie uitgeschakeld.',
    TARGET_ORIGIN_OVERRIDE_WARNING: 'Target/release origin has been overridden by "{{targetOrigin}}". This can lead to undesired behavior.'
};

// next will be called at application startup
function startupServiceFactory(startup) {
    // AOT-proof setup: https://github.com/angular/angular-cli/issues/5158
    const fn = () => startup.load();
    return fn;
}
function cacheManagerFactory(sharedAppState) {
    // NOTE we use factory because we cannot inject interfaces in a normal way
    return new BarCacheManager(sharedAppState);
}
// factory to create a default cache store bound to the application
function defaultCacheStoreFactory(cacheManager, options) {
    // standaard implementatie (kan overschreden worden door de toepassingen)
    if (options.appCode) {
        // we have a specific appCode meaning we can create a unique store for the application
        return cacheManager.getStore({
            storeType: BarCacheStoreType.Application,
            appCode: options.appCode
        });
    }
    else {
        // no appCode meaning it's a unique application just use the global level
        return cacheManager.getStore({ storeType: BarCacheStoreType.Global });
    }
}
function userCacheStoreFactory(cacheManager, coreState) {
    // use lambda for user id because it can change over the lifetime of this application
    return cacheManager.getStore({
        storeType: BarCacheStoreType.User,
        userId: coreState.basiscontext.userId
    });
}
function globalCacheStoreFactory(cacheManager) {
    return cacheManager.getStore({ storeType: BarCacheStoreType.Global });
}
function meldingenCacheStoreFactory(cacheManager) {
    return cacheManager.getStore({ storeType: BarCacheStoreType.Global, store: 'meldingen' });
}
function defaultGvkManagerFactory(gvkStateBridge) {
    return new BarGvkManager(gvkStateBridge);
}
function authServiceFactory(config, userProvider, idpAuthService, externalAuthService, idpHeaderAuthService) {
    if (config.auth.contextTransportModus === BaasContextTransportModus.OnlineHeaders)
        return idpHeaderAuthService;
    // here we check if we have a user provider
    // default we use idp
    if (userProvider._disabled)
        return idpAuthService;
    // user provider defined meaning external authentication is applied
    return externalAuthService;
}
function idpClientFactory(cfg) {
    const result = new BarIdpClient();
    if (cfg.auth.contextTransportModus === BaasContextTransportModus.OnlineHeaders)
        result.options.formatToken = 'qs';
    return result;
}
function hubClientFactory(logOffHandler) {
    // create the non angular client with its default handlers
    const result = new BarHubClient();
    // add angular service as a handler
    result.addHandler(logOffHandler);
    return result;
}
function notificationManagerFactory() {
    return new BarNotificationManager();
}
class BarConnectedModule {
    constructor(router, translate) {
        this.router = router;
        this.translate = translate;
        // set up translation system
        this.translate.addTranslations('DOMAIN_BAR_CORE_CONNECTED', translations);
        this.definePageNotFoundRoute();
    }
    definePageNotFoundRoute() {
        this.router.config.push({
            path: '**',
            canActivate: [BarPageNotFoundGuard],
            component: BarPageNotFoundComponent,
            data: { _framework: true }
        });
    }
    /** Import through this function in the app root module */
    static forRoot(config = {}) {
        if (!config)
            config = new BarConnectedModuleOptions();
        if (config.connectivity == null) {
            config.connectivity = BarConnectivity.Online;
        }
        if (config.auth == null) {
            config.auth = new BarAuthOptions();
        }
        if (config.localhost == null)
            config.localhost = checkLocalhost();
        config.auth._originalContextTransportModus = config.auth.contextTransportModus;
        if (config.auth.contextTransportModus == null) {
            // in localhost use online headers instead of cookies (avoid third party cookie issues)
            config.auth.contextTransportModus = config.localhost ? BaasContextTransportModus.OnlineHeaders : BaasContextTransportModus.OnlineCookies;
        }
        return {
            ngModule: BarConnectedModule,
            providers: [
                {
                    // NOTE use separate token to avoid having to pass all the options through dependency injection
                    provide: BAR_LOCALHOST,
                    useValue: config.localhost
                },
                // https://stackoverflow.com/a/43293449/2174621
                {
                    provide: BarConnectedModuleOptions,
                    useValue: config
                },
                BarLoggingService,
                // here we register our interceptor
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: BarCoreHttpInterceptor,
                    multi: true
                },
                // next registration is the BAR service used at startup
                BarStartupService,
                {
                    provide: APP_INITIALIZER,
                    useFactory: startupServiceFactory,
                    deps: [BarStartupService],
                    multi: true
                },
                {
                    provide: BarAuthService,
                    useFactory: authServiceFactory,
                    deps: [BarConnectedModuleOptions, BaasUserProvider, BarIdpAuthService, BaasExternalAuthService, BarIdpHeaderAuthService]
                },
                BaasExternalAuthService,
                BarIdpAuthService,
                BarIdpHeaderAuthService,
                BarLogOffUtilityService,
                BarCoreStateService,
                BarAppInfoService,
                BaasContextService,
                BarAuditService,
                BarToepassingService,
                BarSecurityService,
                BarProfielService,
                BarConfigurationService,
                BarMeetpuntService,
                BarActieAllowedGuard,
                BarZoneGuard,
                BarXdcService,
                BarMeldingService,
                BarMeldingGuard,
                _BarMeldingGuard,
                BarMeldingenEngine,
                {
                    provide: BarIdpClient,
                    useFactory: idpClientFactory,
                    deps: [BarConnectedModuleOptions]
                },
                BarSharedBootstrapper,
                {
                    provide: BarCacheManager,
                    useFactory: cacheManagerFactory,
                    deps: [BarSharedAppStateService]
                },
                {
                    provide: BarHubClient,
                    useFactory: hubClientFactory,
                    deps: [BarLogOffHubMessageHandler]
                },
                BarLogOffHubMessageHandler,
                {
                    provide: BarNotificationManager,
                    useFactory: notificationManagerFactory
                },
                {
                    // inject default cache store which is for the current app
                    provide: BarCacheStore,
                    useFactory: defaultCacheStoreFactory,
                    deps: [BarCacheManager, BarConnectedModuleOptions]
                },
                {
                    // inject current app cache
                    provide: BAR_APP_CACHE,
                    useFactory: defaultCacheStoreFactory,
                    deps: [BarCacheManager, BarConnectedModuleOptions]
                },
                {
                    // inject the user cache
                    provide: BAR_USER_CACHE,
                    useFactory: userCacheStoreFactory,
                    deps: [BarCacheManager, BarCoreStateService]
                },
                {
                    // inject the global cache
                    provide: BAR_GLOBAL_CACHE,
                    useFactory: globalCacheStoreFactory,
                    deps: [BarCacheManager]
                },
                {
                    provide: BAR_MELDINGEN_CACHE,
                    useFactory: meldingenCacheStoreFactory,
                    deps: [BarCacheManager]
                },
                // bridge to link the GVK state to the @lvflanders/bar-ng state
                BarGvkStateBridge,
                {
                    provide: BarGvkManager,
                    useFactory: defaultGvkManagerFactory,
                    deps: [BarGvkStateBridge]
                },
                {
                    provide: BAR_INITIALIZED,
                    useClass: BarUserDataHook,
                    multi: true
                },
                {
                    provide: BAR_INITIALIZED,
                    useClass: BaasStaticInitializedHook,
                    multi: true
                },
                {
                    provide: BAR_INITIALIZED,
                    useClass: BarNotificationInitializedHook,
                    multi: true
                },
                _BarRapUrlHelper,
                _BarRouteLogger,
                {
                    provide: BaasUserProvider,
                    useClass: BaasNoopUserProvider
                },
                BarPageNotFoundGuard
            ]
        };
    }
    /** Import through this function in a lazy loaded module (only in case problems occur with interceptors) */
    static forChild() {
        return {
            ngModule: BarConnectedModule,
            providers: [
                {
                    // interceptor herdefinieren kan mogelijks probleem zijn in lazy loaded module
                    provide: HTTP_INTERCEPTORS,
                    useClass: BarCoreHttpInterceptor,
                    multi: true
                }
            ]
        };
    }
}
BarConnectedModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarConnectedModule, deps: [{ token: i1.Router }, { token: i1$2.BarI18nService }], target: i0.ɵɵFactoryTarget.NgModule });
BarConnectedModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: BarConnectedModule, imports: [CommonModule, BarI18nModule] });
BarConnectedModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarConnectedModule, imports: [CommonModule, BarI18nModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarConnectedModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, BarI18nModule]
                }]
        }], ctorParameters: function () { return [{ type: i1.Router }, { type: i1$2.BarI18nService }]; } });

/** Creates a validator which compares the given control to another control with a comparison type in case both controls are filled in.
    The error key is the comparison type.
 */
function createComparisonValidator(otherControl, comparison) {
    return (control) => {
        const otherValue = otherControl.value;
        if (control.value && otherValue) {
            switch (comparison) {
                case 'equal': {
                    if (control.value != otherValue)
                        return { equal: true };
                    break;
                }
                case 'larger': {
                    if (control.value <= otherValue)
                        return { larger: true };
                    break;
                }
                case 'largerOrEqual': {
                    if (control.value < otherValue)
                        return { largerOrEqual: true };
                    break;
                }
                case 'smaller': {
                    if (control.value >= otherValue)
                        return { smaller: true };
                    break;
                }
                case 'smallerOrEqual': {
                    if (control.value > otherValue)
                        return { smallerOrEqual: true };
                    break;
                }
                default:
                    return null;
            }
        }
        return null;
    };
}
/** @experimental Creates a validator which compares the given date control to another date control with a comparison type in case both controls are filled in.
    Date-fns is used internally.
    The error key is the comparison type.
 */
function createDateComparisonValidator(otherControl, comparison) {
    return (control) => {
        const otherValue = otherControl === null || otherControl === void 0 ? void 0 : otherControl.value;
        if ((control === null || control === void 0 ? void 0 : control.value) && otherValue) {
            switch (comparison) {
                case 'equal': {
                    if (!isEqual(control.value, otherValue))
                        return { equal: true };
                    break;
                }
                case 'larger': {
                    if (!isAfter(control.value, otherValue))
                        return { larger: true };
                    break;
                }
                case 'largerOrEqual': {
                    if (isBefore(control.value, otherValue))
                        return { largerOrEqual: true };
                    break;
                }
                case 'smaller': {
                    if (!isBefore(control.value, otherValue))
                        return { smaller: true };
                    break;
                }
                case 'smallerOrEqual': {
                    if (isAfter(control.value, otherValue))
                        return { smallerOrEqual: true };
                    break;
                }
                default:
                    return null;
            }
        }
        return null;
    };
}

// Public functions
/** Creates a validator with a given error key and callback to check for validity. */
function createGenericValidator(errorKey, checkValid) {
    return (control) => {
        const valid = checkValid(control);
        if (valid)
            return null;
        else {
            const result = {};
            result[errorKey] = { value: control.value };
            return result;
        }
    };
}
function checkTruthy(value, truthyCheckMode) {
    switch (truthyCheckMode) {
        case 'truthy':
            return value; // Default truthy check
        case 'notNullOrUndefined':
            return value !== null && value !== undefined;
        case 'notNull':
            return value !== null;
        case 'notUndefined':
            return value !== undefined;
    }
}
/** Creates a validators where the given control value is required in case a given condition is true. */
function createRequiredIfValidator(ifCondition, truthyCheckMode = 'truthy') {
    const checkValid = (control) => {
        return !ifCondition(control) || checkTruthy(control === null || control === void 0 ? void 0 : control.value, truthyCheckMode);
    };
    return createGenericValidator('required', checkValid);
}
/** Creates a validators where the given control value must be larger than the value of another given control. */
function createGreaterThanControlValidator(otherControl) {
    return createCompareControlValidator('greaterThan', otherControl, (value, otherValue) => value > otherValue);
}
/** Creates a validators where the given control value must be larger than or equal to the value of another given control. */
function createGreaterThanOrEqualControlValidator(otherControl) {
    return createCompareControlValidator('greaterThanOrEqual', otherControl, (value, otherValue) => value >= otherValue);
}
/** Creates a validators where the given control value must be smaller than the value of another given control. */
function createSmallerThanControlValidator(otherControl) {
    return createCompareControlValidator('smallerThan', otherControl, (value, otherValue) => value < otherValue);
}
/** Creates a validators where the given control value must be smaller than or equal the value of another given control. */
function createSmallerThanOrEqualControlValidator(otherControl) {
    return createCompareControlValidator('smallerThanOrEqual', otherControl, (value, otherValue) => value <= otherValue);
}
// Facade
// NOTE inspired by Validators class from @angular
/** BAR reactive forms validators. */
class BarValidators {
    /** Creates a validators where the given control value is required in case a given condition is true. */
    static requiredIf(ifCondition, truthyCheckMode = 'truthy') {
        return createRequiredIfValidator(ifCondition, truthyCheckMode);
    }
    /** Creates a validators where the given control value must be larger than the value of another given control. */
    static greaterThanControl(otherControl) {
        return createGreaterThanControlValidator(otherControl);
    }
    /** Creates a validators where the given control value must be larger than or equal to the value of another given control. */
    static greaterThanOrEqualControl(otherControl) {
        return createGreaterThanOrEqualControlValidator(otherControl);
    }
    /** Creates a validators where the given control value must be smaller than the value of another given control. */
    static smallerThanControl(otherControl) {
        return createSmallerThanControlValidator(otherControl);
    }
    /** Creates a validators where the given control value must be smaller than or equal the value of another given control. */
    static smallerThanOrEqualControl(otherControl) {
        return createSmallerThanOrEqualControlValidator(otherControl);
    }
    /** @experimental Creates a validators where the given control date value is compared to to another typed date control using date-fns. */
    static dateComparison(otherControl, comparison) {
        return createDateComparisonValidator(otherControl, comparison);
    }
    /** Creates a validators where the given control value is compared to to another control. */
    static comparison(otherControl, comparison) {
        return createComparisonValidator(otherControl, comparison);
    }
}
// Private functions
function controlValueDefined(control) {
    return (control === null || control === void 0 ? void 0 : control.value) != null;
}
function createCompareControlValidator(errorKey, otherControl, comparisonCondition) {
    return createGenericValidator(errorKey, (control) => {
        // both control values must be defined in able to perform the condition (otherwise it is considered value)
        return !controlValueDefined(control) || !controlValueDefined(otherControl) || comparisonCondition(control.value, otherControl.value);
    });
}

/*
 * Public API Surface of @lvflanders/bar-ng
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BAR_APP_CACHE, BAR_ERROR_HANDLER, BAR_GLOBAL_CACHE, BAR_INITIALIZED, BAR_LOCALHOST, BAR_LOG_OFF, BAR_MELDINGEN_CACHE, BAR_USER_CACHE, BaasContextTransportModus, BaasCoreModule, BaasModuleOptions, BaasNoopUserProvider, BaasUserProvider, BarActie, BarActieAllowedGuard, BarActieFromContext, BarActionDef, BarAuthGuard, BarAuthService, BarBasiscontext, BarCacheable, BarCacheableOptions, BarConfigurationService, BarConnectedModule, BarConnectedModuleOptions, BarConnectivity, BarCoreModule, BarCoreService, BarCoreStateService, BarDateTimeConversionStrategy, BarHttpParams, BarLogInfo, BarLoggingService, BarMeetpunt, BarMeetpuntService, BarMelding, BarMeldingGuard, BarMeldingService, BarMeldingType, BarProfielService, BarRoutingService, BarSecurityLevel, BarSecurityService, BarToepassingService, BarValidators, BarZoneGuard, _BaasStaticConfigurationApiClient, _OopsDomService, _OopsType, convertToHttpParams, createComparisonValidator, createDateComparisonValidator, createDefaultBaseHrefFactory, createGenericValidator, createGreaterThanControlValidator, createGreaterThanOrEqualControlValidator, createRequiredIfValidator, createSmallerThanControlValidator, createSmallerThanOrEqualControlValidator, resolveValue$ };
//# sourceMappingURL=lvflanders-bar-ng.mjs.map
